// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-4 {
  right: 1rem;
}
.top-1 {
  top: 0.25rem;
}
.top-16 {
  top: 4rem;
}
.top-full {
  top: 100%;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-16 {
  height: 4rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-\\[210px\\] {
  height: 210px;
}
.h-full {
  height: 100%;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[calc\\(100vh-5rem\\)\\] {
  max-height: calc(100vh - 5rem);
}
.min-h-screen {
  min-height: 100vh;
}
.w-12 {
  width: 3rem;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[7\\.5rem\\] {
  min-width: 7.5rem;
}
.min-w-\\[760px\\] {
  min-width: 760px;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-px {
  gap: 1px;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-full {
  border-radius: 9999px;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-border {
  --tw-border-opacity: 1;
  border-color: rgb(226 226 230 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(26 26 26 / var(--tw-border-opacity, 1));
}
.border-text-primary\\/10 {
  border-color: rgb(26 26 26 / 0.1);
}
.bg-bg-card {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-bg-hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 244 / var(--tw-bg-opacity, 1));
}
.bg-bg-hover\\/70 {
  background-color: rgb(242 242 244 / 0.7);
}
.bg-bg-main {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-bg-secondary\\/60 {
  background-color: rgb(246 246 247 / 0.6);
}
.bg-border {
  --tw-bg-opacity: 1;
  background-color: rgb(226 226 230 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.bg-primary-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-primary-light {
  --tw-bg-opacity: 1;
  background-color: rgb(88 88 88 / var(--tw-bg-opacity, 1));
}
.bg-text-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.bg-text-primary\\/30 {
  background-color: rgb(26 26 26 / 0.3);
}
.bg-text-primary\\/70 {
  background-color: rgb(26 26 26 / 0.7);
}
.bg-text-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-28 {
  padding-top: 7rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[0\\.98\\] {
  line-height: 0.98;
}
.leading-\\[1\\.02\\] {
  line-height: 1.02;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.025em\\] {
  letter-spacing: -0.025em;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.03em\\] {
  letter-spacing: -0.03em;
}
.tracking-\\[-0\\.045em\\] {
  letter-spacing: -0.045em;
}
.tracking-\\[-0\\.04em\\] {
  letter-spacing: -0.04em;
}
.tracking-\\[-0\\.055em\\] {
  letter-spacing: -0.055em;
}
.tracking-\\[-0\\.05em\\] {
  letter-spacing: -0.05em;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.text-error {
  --tw-text-opacity: 1;
  color: rgb(192 38 45 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-primary-dark {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-primary-light {
  --tw-text-opacity: 1;
  color: rgb(88 88 88 / var(--tw-text-opacity, 1));
}
.text-text-muted {
  --tw-text-opacity: 1;
  color: rgb(107 107 112 / var(--tw-text-opacity, 1));
}
.text-text-primary {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
.text-warning {
  --tw-text-opacity: 1;
  color: rgb(168 98 0 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}

/* Corporate design of pAIoneer Labs GmbH, the same as the company's letters:
   white ground, Open Sans in its light weight, near-black text, thin rules and
   magenta #FF0088 as the one accent colour. Magenta marks the letters "AI" of
   the company name and small details (link underlines, markers, focus); text,
   rules and buttons stay black and grey. */
:root {
  --accent: #ff0088;
  --accent-strong: #d10070;
  --ink: #1a1a1a;
  --ink-soft: #333333;
  --muted: #6b6b70;
  --logo-grey: #585858;
  --rule: #1a1a1a;

  --primary: var(--accent);
  --primary-dark: #ffffff;
  --primary-light: var(--logo-grey);
  --success: #2e7d4f;
  --warning: #a86200;
  --error: #c0262d;
  --info: #4d5966;
  --secondary: var(--logo-grey);

  --bg-main: #ffffff;
  --bg-secondary: #f6f6f7;
  --bg-card: #ffffff;
  --bg-hover: #f2f2f4;

  --text-primary: var(--ink);
  --text-secondary: var(--ink-soft);
  --text-muted: var(--muted);
  --text-white: #ffffff;

  --border: #e2e2e6;
  --border-hover: #b8b8be;
  --line-strong: var(--rule);
  --shadow: none;
  --radius: 2px;
  --container: 1248px;

  --font-sans: "Open Sans Variable", "Open Sans", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Noto Sans JP", "Yu Gothic", "Segoe UI", Arial, sans-serif;
}

html {
  scroll-behavior: smooth;
}

html[lang="ja"] body {
  font-weight: 400;
}

body {
  margin: 0;
  min-width: 320px;
  background: var(--bg-main);
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-weight: 300;
  font-optical-sizing: auto;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: inherit;
}

strong,
b {
  font-weight: 600;
}

a {
  color: inherit;
}

ul,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

li::marker {
  content: "";
}

::-moz-selection {
  background: rgba(255, 0, 136, 0.16);
}

::selection {
  background: rgba(255, 0, 136, 0.16);
}

:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: var(--bg-main);
}

::-webkit-scrollbar-thumb {
  background: #c9c9ce;
  border: 2px solid var(--bg-main);
  border-radius: 999px;
}

/* The letters "AI" of pAIoneer, wherever the name is written. */
.brand-ai {
  color: var(--accent);
}

/* The older pages mark headings with Tailwind weights; in the light design a
   heading is set in the regular weight and emphasis in the medium one. */
.font-black { font-weight: 400 !important; }
.font-bold,
.font-semibold { font-weight: 500 !important; }
.font-medium { font-weight: 400 !important; }
[class*="tracking-[-"] { letter-spacing: -0.01em !important; }
.bg-primary { background-color: var(--ink) !important; }
.bg-primary-light { background-color: var(--accent) !important; }
.bg-primary-dark { background-color: var(--bg-main) !important; }
.bg-success { background-color: var(--success) !important; }
.bg-warning { background-color: var(--warning) !important; }
.bg-error { background-color: var(--error) !important; }
.bg-info { background-color: var(--info) !important; }
.bg-secondary { background-color: var(--bg-secondary) !important; }
.bg-bg-main { background-color: var(--bg-main) !important; }
.bg-bg-secondary { background-color: var(--bg-secondary) !important; }
.bg-bg-card { background-color: var(--bg-card) !important; }
.bg-bg-hover { background-color: var(--bg-hover) !important; }
.bg-text-primary { background-color: var(--bg-secondary) !important; }
[class*="bg-text-primary/"] {
  background-color: rgba(26, 26, 26, 0.4) !important;
}
[class*="bg-primary/"] {
  background-color: rgba(255, 0, 136, 0.06) !important;
}
.text-primary { color: var(--ink) !important; }
.text-primary-light,
.text-primary-dark { color: var(--logo-grey) !important; }
.text-success { color: var(--success) !important; }
.text-warning { color: var(--warning) !important; }
.text-error { color: var(--error) !important; }
.text-info { color: var(--info) !important; }
.text-secondary { color: var(--logo-grey) !important; }
.text-text-primary { color: var(--text-primary) !important; }
.text-text-secondary { color: var(--text-secondary) !important; }
.text-text-muted { color: var(--text-muted) !important; }
.text-text-white { color: var(--text-white) !important; }
.text-bg-main { color: var(--bg-main) !important; }
.border-primary { border-color: var(--ink) !important; }
[class*="border-primary/"] { border-color: var(--border-hover) !important; }
.border-border { border-color: var(--border) !important; }
.border-border-hover { border-color: var(--border-hover) !important; }
.border-text-primary\\/10 { border-color: var(--border) !important; }

.rounded-full,
.rounded-2xl,
.rounded-xl,
.rounded-lg,
.rounded-sm {
  border-radius: var(--radius) !important;
}

.space-y-2 > :not([hidden]) ~ :not([hidden]),
.space-y-3 > :not([hidden]) ~ :not([hidden]),
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
}

.bg-gradient-primary,
.bg-gradient-success,
.bg-gradient-warning,
.bg-gradient-error,
.bg-gradient-info,
.bg-gradient-business,
.bg-gradient-hero,
.bg-gradient-card {
  background: var(--bg-card);
}

.text-gradient-primary,
.text-gradient-success,
.text-glow-primary,
.text-glow-business {
  color: var(--ink);
  text-shadow: none;
}

.site-page {
  min-height: 100vh;
  background: transparent;
  color: var(--text-primary);
}

.site-main,
.signal-home {
  width: min(var(--container), calc(100% - 2rem));
  margin: 0 auto;
  padding: clamp(5.5rem, 9vw, 7rem) 0 clamp(3.5rem, 7vw, 5rem);
}

.site-hero,
.signal-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(18rem, 0.72fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: end;
  padding: clamp(2.4rem, 5vw, 4.8rem) 0;
  border-bottom: 1px solid var(--rule);
}

.site-hero--single,
.signal-hero {
  grid-template-columns: minmax(0, 1fr);
}

.site-hero__copy,
.signal-hero-main {
  max-width: 50rem;
}

.site-hero h1,
.signal-hero h1,
.site-title {
  margin: 0;
  color: var(--ink);
  font-size: clamp(2.3rem, 4.4vw, 4rem);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1.08;
}

.site-lead,
.signal-claim {
  max-width: 44rem;
  margin: 1.1rem 0 0;
  color: var(--ink-soft);
  font-size: clamp(1.06rem, 1.4vw, 1.28rem);
  font-weight: 300;
  line-height: 1.55;
}

.site-copy,
.signal-intro {
  max-width: 50rem;
  margin: 1rem 0 0;
  color: var(--ink-soft);
  font-size: 1rem;
  line-height: 1.75;
}

/* D-HP-SITE-032: a page head built outside the shared page frame starts at the same height as the shared one
   (the page frame's top padding plus the head's own) and keeps its title, lead and copy in the shared styles. */
.page-head {
  padding-top: calc(clamp(5.5rem, 9vw, 7rem) + clamp(2.4rem, 5vw, 4.8rem));
}

/* its kicker is a block of its own, so it starts at the head's top instead of on a text line */
.page-head .editorial-kicker {
  display: flex;
}

.page-head .site-title + .site-lead {
  margin-top: 1.1rem;
}

.page-head__action {
  margin-top: 1.75rem;
}

.editorial-kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  margin: 0;
  color: var(--logo-grey);
  font-size: 0.72rem;
  font-weight: 400;
  letter-spacing: 0.2em;
  line-height: 1.4;
  text-transform: uppercase;
}

.editorial-kicker:empty {
  display: none;
}

.editorial-kicker::before {
  content: "";
  width: 1.6rem;
  height: 1px;
  background: var(--accent);
}

.homepage-section,
.site-section,
.signal-section {
  padding: clamp(2.4rem, 4.4vw, 4rem) 0;
}

.homepage-section + .homepage-section,
.site-section + .site-section {
  border-top: 1px solid var(--border);
}

.homepage-muted-panel,
.site-section--muted {
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.site-section__inner,
.homepage-section > .max-w-7xl,
.homepage-section > .max-w-6xl,
.homepage-section > .max-w-4xl,
.homepage-section > .max-w-3xl,
.homepage-muted-panel > .max-w-7xl,
.homepage-muted-panel > .max-w-6xl,
.homepage-muted-panel > .max-w-4xl,
.homepage-muted-panel > .max-w-3xl,
section > .max-w-7xl,
section > .max-w-6xl,
section > .max-w-4xl,
section > .max-w-3xl {
  width: min(var(--container), calc(100% - 2rem));
  max-width: var(--container) !important;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.signal-section-header,
.site-section-head {
  display: grid;
  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: center;
  margin-bottom: clamp(1.15rem, 3vw, 2rem);
}

.signal-section-header h2,
.signal-contact h2,
.site-section-head h2,
.site-heading {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.55rem, 2.5vw, 2.3rem);
  font-weight: 300;
  letter-spacing: -0.015em;
  line-height: 1.15;
}

.signal-section-header p,
.signal-contact p,
.site-section-head p {
  margin: 0;
  color: var(--ink-soft);
  line-height: 1.72;
}

.homepage-card,
.card-base,
.card-professional,
.card-business-primary,
.card-business-info,
.card-business-success,
.site-card,
.site-panel {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: none;
  overflow: hidden;
}

.card-hover,
.theme-transition {
  transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;
}

.admin-dashboard-main {
  width: min(1680px, calc(100% - 2rem));
}

.admin-hero-title {
  margin: 0;
  color: var(--text-primary);
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 1.1;
}

.admin-kpi-label {
  color: var(--text-muted);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.admin-smtm-panel {
  overflow: visible;
}

.admin-smtm-status-meta {
  min-width: 14rem;
  text-align: right;
}

.admin-smtm-filter-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 0.75rem;
  align-items: center;
}

.admin-status-pill {
  display: inline-flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  border: 1px solid var(--border-hover);
  border-radius: 999px;
  padding: 0.18rem 0.58rem;
  background: var(--bg-secondary);
  color: var(--ink-soft);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.admin-status-pill.is-ok {
  border-color: rgba(46, 125, 79, 0.4);
  background: rgba(46, 125, 79, 0.08);
  color: var(--success);
}

.admin-status-pill.is-warning {
  border-color: rgba(168, 98, 0, 0.42);
  background: rgba(168, 98, 0, 0.08);
  color: var(--warning);
}

.admin-status-pill.is-missing {
  border-color: rgba(192, 38, 45, 0.4);
  background: rgba(192, 38, 45, 0.07);
  color: var(--error);
}

.admin-status-pill.is-neutral {
  margin-top: 0.55rem;
}

.admin-smtm-frame-metric {
  display: grid;
  gap: 0.35rem;
  min-width: 12rem;
  color: var(--text-secondary);
  font-size: 0.78rem;
  line-height: 1.35;
}

.admin-smtm-issue-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.admin-smtm-status-body-scroll {
  display: grid;
  gap: 0.85rem;
  max-height: 74vh;
  overflow: auto;
  padding-right: 0.25rem;
}

.admin-smtm-status-table-shell {
  overflow: hidden;
}

.admin-smtm-status-table-scroll {
  max-height: 42vh;
  overflow: auto;
}

.admin-smtm-training-workbench {
  display: grid;
  grid-template-columns: minmax(18rem, 24rem) minmax(0, 1fr);
  gap: 1rem;
  align-items: stretch;
}

.admin-smtm-training-list-panel,
.admin-smtm-training-detail-panel {
  min-height: 0;
}

.admin-smtm-training-list-scroll,
.admin-smtm-training-detail-scroll {
  display: grid;
  gap: 0.85rem;
  max-height: 70vh;
  overflow: auto;
  padding-right: 0.25rem;
}

.admin-smtm-training-list-item {
  display: grid;
  gap: 0.45rem;
  width: 100%;
  padding: 0.95rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  text-align: left;
  transition: border-color 180ms ease, background-color 180ms ease;
}

.admin-smtm-training-list-item:hover,
.admin-smtm-training-list-item.active {
  border-color: var(--ink);
  background: var(--bg-hover);
}

.admin-smtm-training-list-head,
.admin-smtm-training-detail-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 0.85rem;
}

.admin-smtm-training-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.admin-smtm-training-card {
  display: grid;
  gap: 0.75rem;
  align-content: start;
}

.admin-smtm-training-card-tall {
  min-height: 16rem;
}

.admin-smtm-training-card-wide {
  grid-column: span 2;
}

.admin-smtm-training-detail-list {
  display: grid;
  gap: 0.55rem;
  max-height: 14rem;
  overflow: auto;
}

.admin-smtm-training-detail-row {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-top: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.86rem;
}

.admin-smtm-training-detail-row:first-child {
  border-top: 0;
  padding-top: 0;
}

.admin-panel {
  overflow: hidden;
}

.admin-section-head {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 1rem;
}

.admin-azurite-files {
  display: grid;
  gap: 0.45rem;
  min-width: 14rem;
}

.admin-azurite-file {
  width: 100%;
  justify-content: space-between;
  font-size: 0.78rem;
}

.admin-meta-list {
  padding: 0.8rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-hover);
}

.admin-table-shell {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--bg-card);
}

.admin-table-scroll {
  overflow: auto;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1280px;
}

.admin-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.85rem 0.9rem;
  text-align: left;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

.admin-table tbody td {
  padding: 0.85rem 0.9rem;
  border-top: 1px solid var(--border);
  color: var(--text-secondary);
  vertical-align: top;
}

.admin-table tbody tr:hover {
  background: var(--bg-hover);
}

/* The organisation chart of the Veridion organisation panel, a section of its own: the human
   decision makers on top, the positions outside the areas below them, the positions in their areas,
   the agents working on their behalf (dashed), the connected systems and the company spaces. Areas
   take as many columns as they have positions (two per column) and wrap by the width available, so
   no node shrinks below a readable width. Built from the theme tokens: white ground, thin rules,
   magenta only as the small marker of a state that needs a look. */
.admin-dashboard-main .site-card.org-chart-card {
  padding: 1.25rem 1.5rem 1.5rem;
}

.org-chart {
  display: grid;
  margin-top: 0.75rem;
}

.org-chart__tier {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.org-chart__tier > .org-node {
  width: min(100%, 34rem);
}

.org-chart__link {
  justify-self: center;
  width: 1px;
  height: 1.25rem;
  background: var(--line-strong);
}

.org-chart__areas {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));
  gap: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--line-strong);
}

.org-chart__area {
  display: grid;
  gap: 0.6rem;
  align-content: start;
  min-width: 0;
}

.org-chart__area-nodes {
  display: grid;
  gap: 0.75rem;
}

.org-chart__label,
.org-chart__area-name,
.org-chart__band-name {
  font-size: clamp(0.68rem, 0.6rem + 0.2vw, 0.82rem);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.org-chart__area-name {
  padding-bottom: 0.35rem;
  border-bottom: 2px solid var(--line-strong);
}

.org-chart__band {
  display: grid;
  gap: 0.75rem;
  margin-top: 1.75rem;
  padding-top: 1rem;
  border-top: 1px dashed var(--border-hover);
}

.org-chart__band--plain {
  border-top: 1px solid var(--border);
}

/* Organigram-First (IDD D-HP-ADMIN-042): the executive layer over the business units, each a column; a unit or a
   colleague on standby is dimmed; badges name the thread prefix, the runtime, the model and the lead. */
.org-chart__exec {
  display: grid;
  gap: 0.5rem;
  justify-items: center;
  width: 100%;
}

.org-chart__tier--exec {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  width: min(100%, 66rem);
  margin: 0 auto;
}

@media (max-width: 48em) {
  .org-chart__tier--exec {
    grid-template-columns: minmax(0, 1fr);
  }
}

.org-chart__tier--exec > .org-node {
  width: auto;
}

.org-chart__label--units {
  padding-top: 1.25rem;
  border-top: 1px solid var(--line-strong);
}

.org-chart__units {
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 1rem;
  align-items: stretch;
  padding-top: 0.75rem;
  border-top: 0;
}

/* A unit is one column with fixed rows (name, mission, the lead, who supports it, the switch), so the columns line up
   across the row whatever the length of a text. */
.org-chart__unit {
  grid-template-rows: auto auto auto 1fr auto;
  gap: 0.6rem;
  height: 100%;
}

/* The lead's card keeps its own height; the column's free space stays below it, never inside the card. */
.org-chart__unit .org-chart__area-nodes {
  align-content: start;
}

.org-chart__unit .org-chart__area-nodes > .org-node {
  height: auto;
}

.org-chart__unit--standby {
  opacity: 0.6;
}

.org-chart__unit .org-chart__area-name {
  display: grid;
  gap: 0.35rem;
  align-content: start;
  min-height: 3.6rem;
}

.org-chart__area-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 1.3;
}

.org-chart__area-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.org-chart__mission {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: clamp(0.78rem, 0.7rem + 0.2vw, 0.9rem);
  line-height: 1.45;
}

/* The members of a unit after its lead: every supporting colleague as a small card. */
.org-chart__members {
  display: grid;
  gap: 0.5rem;
  align-content: start;
}

.org-chart__members-label {
  font-size: clamp(0.64rem, 0.56rem + 0.2vw, 0.78rem);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.org-chart__mission {
  -webkit-line-clamp: 3;
  min-height: calc(1.45em * 3);
}

.org-chart__switch {
  justify-self: stretch;
  width: 100%;
  font-size: 0.75rem;
  padding: 0.35rem 0.6rem;
}

.org-chart__hint {
  margin-top: 0.75rem;
}

.org-node--standby {
  opacity: 0.65;
  border-style: dashed;
}

.org-node__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.org-badge {
  display: inline-block;
  padding: 0.05rem 0.45rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  font-size: clamp(0.64rem, 0.56rem + 0.2vw, 0.78rem);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: none;
  color: var(--text-secondary);
  background: var(--bg-muted, transparent);
  white-space: nowrap;
}

.org-badge--prefix {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.org-badge--lead,
.org-badge--active {
  border-color: var(--accent);
  color: var(--accent);
}

.org-badge--standby {
  border-style: dashed;
}

.org-node__switch {
  padding: 0.15rem 0.55rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  font-size: 0.95em;
}

.org-dialog__turn--meta {
  font-size: 0.7rem;
  color: var(--text-muted);
  padding: 0 0 0.5rem;
  background: transparent;
  border: 0;
}

.org-chart__band-nodes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 1rem;
}

.org-chart__people {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.2rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-primary);
}

.org-chart__systems,
.org-node__list {
  -moz-columns: 18rem;
       columns: 18rem;
  -moz-column-gap: 2rem;
       column-gap: 2rem;
  font-size: 0.8rem;
}

.org-chart__systems li,
.org-node__list li {
  -moz-column-break-inside: avoid;
       break-inside: avoid;
  padding: 0.2rem 0;
}

.org-chart__spaces {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.org-chart__spaces th {
  padding: 0 1rem 0.4rem 0;
  text-align: left;
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  border-bottom: 1px solid var(--line-strong);
}

.org-chart__spaces td {
  padding: 0.45rem 1rem 0.45rem 0;
  vertical-align: top;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
}

.org-chart__space-name {
  width: 18rem;
  white-space: nowrap;
  font-weight: 500;
  color: var(--text-primary);
}

.org-node {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
  height: 100%;
  padding: 0.8rem 0.9rem;
  font-size: clamp(0.8rem, 0.7rem + 0.25vw, 0.95rem);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  color: var(--text-primary);
}

.org-node--people {
  align-items: center;
  text-align: center;
  border-color: var(--line-strong);
}

.org-node--agent {
  border-style: dashed;
  border-color: var(--border-hover);
}

.org-node__name {
  font-size: 1.05em;
  font-weight: 600;
  line-height: 1.25;
  overflow-wrap: anywhere;
  color: var(--text-primary);
}

.org-node__title {
  font-size: 0.86em;
  color: var(--text-muted);
}

/* A supporting colleague inside a unit's column: the same card, smaller, without actions; its own card with the
   actions stands in its own unit. */
.org-node--support {
  padding: 0.5rem 0.7rem;
  gap: 0.15rem;
  border-style: dashed;
}

.org-node--support .org-node__name {
  font-size: 0.95em;
}

.org-node__item {
  font-weight: 500;
  color: var(--text-primary);
}

.org-node__text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.org-node__alert {
  font-size: 0.74rem;
  color: var(--text-primary);
}

.org-node__meta {
  display: grid;
  gap: 0.15rem;
  margin-top: auto;
  padding-top: 0.4rem;
  font-size: 0.82em;
  color: var(--text-muted);
  border-top: 1px solid var(--border);
}

.org-node__meta > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Write and call on a colleague's box: two quiet line icons with their label as a whisper, never buttons with text
   (IDD D-HP-ADMIN-028). */
.org-node__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
  margin-top: 0.3rem;
  font-size: 0.82em;
}

.org-node__icon {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.3rem;
  border: 1px solid transparent;
  border-radius: calc(var(--radius) / 2);
  background: transparent;
  color: var(--text-muted);
  font-size: 1em;
  line-height: 1;
  cursor: pointer;
}

.org-node__icon:hover,
.org-node__icon:focus-visible {
  color: var(--text-primary);
  border-color: var(--border);
  outline: none;
}

.org-node__icon svg {
  flex: none;
}

/* The voice of a colleague, chosen at its box (IDD D-HP-ADMIN-034): a small select in the row of the icons. */
.org-node__voice {
  flex: 1 1 100%;
  order: 10;
  min-width: 0;
  max-width: 100%;
  padding: 0.2rem 0.3rem;
  border: 1px solid var(--border);
  border-radius: calc(var(--radius) / 2);
  background: var(--bg-card);
  color: var(--text-muted);
  font-size: 1em;
  line-height: 1.2;
}

.org-node__voice:hover,
.org-node__voice:focus-visible {
  color: var(--text-primary);
  outline: none;
}

/* The call panel is a phone (IDD D-HP-ADMIN-037): the state with its timer, the microphone's level, the hang-up. */
.org-call__status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem 1rem;
  font-size: 0.85rem;
}

.org-call__state::before {
  content: "";
  display: inline-block;
  width: 0.55rem;
  height: 0.55rem;
  margin-right: 0.4rem;
  border-radius: 50%;
  background: var(--text-muted);
  vertical-align: 0.05em;
}

.org-call__state--ringing::before {
  background: var(--accent);
  animation: org-call-ring 1s ease-in-out infinite;
}

.org-call__state--connected::before {
  background: var(--accent);
}

@keyframes org-call-ring {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
}

.org-call__meter {
  display: inline-block;
  width: 7rem;
  height: 0.45rem;
  border: 1px solid var(--border);
  border-radius: 0.3rem;
  overflow: hidden;
  background: var(--bg-card);
}

.org-call__meter-bar {
  display: block;
  height: 100%;
  background: var(--accent);
  transition: width 0.1s linear;
}

.org-call__hangup {
  min-width: 9rem;
}

.org-call__turns {
  max-height: 420px;
  overflow-y: auto;
}

.org-node__marker::before,
.org-node__alert::before {
  content: "";
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.35rem;
  border-radius: 50%;
  background: var(--accent);
  vertical-align: 0.08em;
}

@media (max-width: 56.25em) {
  .org-chart__area {
    grid-column: auto !important;
  }

  .org-chart__area-nodes {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .org-chart__space-name {
    width: auto;
    white-space: normal;
  }
}

/* Stacked tables share one grid: fixed column widths, so every workload row
   and every namespace group aligns regardless of name length. Long names and
   images are clipped and carry the full value as a tooltip. */
.admin-workload-table,
.admin-events-table {
  table-layout: fixed;
  min-width: 1080px;
}

.admin-workload-table .admin-col-name { width: 24%; }
.admin-workload-table .admin-col-state { width: 9%; }
.admin-workload-table .admin-col-replicas { width: 9%; }
.admin-workload-table .admin-col-cpu { width: 10%; }
.admin-workload-table .admin-col-memory { width: 10%; }
.admin-workload-table .admin-col-restarts { width: 9%; }
.admin-workload-table .admin-col-image { width: 29%; }

.admin-events-table .admin-col-seen { width: 13%; }
.admin-events-table .admin-col-object { width: 31%; }
.admin-events-table .admin-col-reason { width: 16%; }
.admin-events-table .admin-col-message { width: 40%; }

/* The AI gateway tab stacks several tables; they share one column grid so
   their edges line up, the same way the workload table does. */
.admin-gateway-table,
.admin-usage-table {
  table-layout: fixed;
  min-width: 1080px;
}
.admin-gateway-table .admin-col-a { width: 26%; }
.admin-gateway-table .admin-col-b { width: 22%; }
.admin-gateway-table .admin-col-c { width: 16%; }
.admin-gateway-table .admin-col-d { width: 36%; }
.admin-gateway-table .admin-col-rest { width: 52%; }
.admin-gateway-table .admin-col-rest-wide { width: 74%; }

.admin-usage-table .admin-col-identity { width: 26%; }
.admin-usage-table .admin-col-tokens { width: 13%; }
.admin-usage-table .admin-col-model { width: 21%; }
.admin-usage-table .admin-col-action { width: 14%; }

.admin-table .admin-cell-clip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-table tbody tr.admin-table-group td,
.admin-table tbody tr.admin-table-group:hover td {
  padding: 0.55rem 0.9rem;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
}

.admin-table-group-name {
  margin-right: 0.75rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.admin-table-group-note {
  font-size: 0.8rem;
  color: var(--text-muted);
}

.admin-inline-input {
  min-width: 11rem;
}

.admin-inline-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* Node cards sit beside each other while there is room and stack below it. */
.admin-node-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 1fr));
  gap: 0.75rem;
}

.admin-user-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.admin-user-search {
  flex: 1 1 16rem;
  min-width: 12rem;
}

.admin-user-select {
  flex: 0 0 12rem;
}

.admin-user-count {
  margin-left: auto;
  color: var(--text-muted);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}

/* Six columns, not the twelve-plus of the SMTM tables, so the list fits a
   normal window without horizontal scrolling. */
.admin-user-table {
  min-width: 52rem;
}

.admin-user-table tbody td {
  vertical-align: middle;
}

.admin-user-table tbody tr.is-selected {
  background: rgba(255, 0, 136, 0.05);
}

.admin-user-name {
  color: var(--text-primary);
  font-weight: 500;
}

/* The address is the longest value in the row; it truncates instead of pushing
   the neighbouring columns out of their width. */
.admin-user-mail {
  max-width: 22rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-muted);
  font-size: 0.8rem;
}

.admin-user-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.admin-user-created {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.admin-user-pager {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  color: var(--text-muted);
  font-size: 0.82rem;
}

.admin-user-hint {
  align-self: center;
  color: var(--text-muted);
  font-size: 0.8rem;
  line-height: 1.35;
}

.admin-user-detail {
  border-color: var(--border-hover);
}

.card-hover:hover {
  border-color: var(--border-hover);
  transform: translateY(-1px);
}

.shadow-professional,
.shadow-primary-strong,
.shadow-success-glow,
.shadow-error-glow,
.shadow-info-glow {
  box-shadow: var(--shadow);
}

.border-gradient {
  border: 1px solid var(--border);
  background: var(--bg-card);
}

.homepage-photo-frame,
.site-media {
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  overflow: hidden;
}

.homepage-photo,
.site-media img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.about-photo-frame {
  height: auto;
  max-width: 220px;
  justify-self: end;
  background: var(--bg-main);
}

.about-photo {
  display: block;
  width: 100%;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
}

.about-hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(180px, 220px);
  gap: clamp(1rem, 3vw, 2rem);
  align-items: start;
}

.about-hero-copy {
  min-width: 0;
}

.about-download-panel {
  display: grid;
  grid-template-columns: minmax(11rem, 0.42fr) minmax(0, 1fr);
  gap: 1rem;
  align-items: center;
  margin-top: clamp(1rem, 2vw, 1.35rem);
  padding: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-secondary);
}

.about-download-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.7rem;
}

.about-download-card {
  display: block;
  padding: 0.72rem 0.82rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  line-height: 1.25;
  transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;
}

.about-download-card:hover {
  border-color: var(--ink);
  background: var(--bg-hover);
  transform: translateY(-1px);
}

@media (max-width: 63.9375em) {
  .about-hero-grid,
  .about-download-panel {
    grid-template-columns: 1fr;
  }

  .about-photo-frame {
    justify-self: start;
    max-width: 200px;
  }
}

@media (max-width: 40em) {
  .about-download-actions {
    grid-template-columns: 1fr;
  }
}

.homepage-rule {
  height: 1px;
  background: var(--border);
}

.signal-service-list,
.signal-capability-list,
.site-row-list {
  border-top: 1px solid var(--rule);
}

.signal-service-row,
.signal-capability-list article,
.site-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: start;
  padding: clamp(1.05rem, 2.1vw, 1.55rem) 0;
  border-bottom: 1px solid var(--border);
}

.signal-capability-list article,
.site-row--text {
  grid-template-columns: minmax(12rem, 0.42fr) minmax(0, 1fr);
}

.signal-service-row h3,
.signal-capability-list h3,
.site-row h3,
.site-card h3 {
  margin: 0 0 0.35rem;
  color: var(--text-primary);
  font-size: clamp(1.05rem, 1.35vw, 1.32rem);
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.18;
}

.signal-service-row p,
.signal-capability-list p,
.site-row p,
.site-card p {
  max-width: 48rem;
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.68;
}

.signal-service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.65rem;
  margin-top: 0.85rem;
}

.signal-service-tags span {
  color: var(--muted);
  font-size: 0.76rem;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0.01em;
  padding: 0.26rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: transparent;
}

.signal-service-row a,
.signal-contact a,
.site-text-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  color: var(--ink);
  font-size: 0.92rem;
  font-weight: 400;
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-decoration-thickness: 1px;
  text-underline-offset: 0.32em;
  white-space: normal;
  text-align: center;
  line-height: 1.4;
  max-width: min(100%, 18rem);
  overflow-wrap: anywhere;
  transition: color 160ms ease;
}

.signal-service-row a:hover,
.signal-contact a:hover,
.site-text-link:hover {
  color: var(--accent);
}

.signal-sector-line,
.site-sector-list,
.site-label-line {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem 1.2rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.signal-sector-line p,
.site-sector-list p,
.site-label-line span {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.94rem;
  line-height: 1.45;
}

.signal-contact,
.site-contact {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: end;
  margin-top: clamp(2.5rem, 5vw, 4.5rem);
  padding-top: 1.4rem;
  border-top: 1px solid var(--rule);
}

.site-grid,
.site-matrix {
  display: grid;
  gap: 1px;
  background: var(--border);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}

.site-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.site-grid--3,
.site-matrix--3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.site-grid--4,
.site-matrix--4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

.site-grid > *,
.site-matrix > * {
  background: var(--bg-card);
  border-radius: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
}

.site-list {
  display: grid;
  gap: 0;
  border-top: 1px solid var(--border);
}

.site-list > *,
.site-list-row {
  padding: 0.95rem 0;
  border-bottom: 1px solid var(--border);
}

.site-statement {
  display: inline-block;
  margin-top: 1.4rem;
  padding: 0.9rem 1.1rem;
  border-left: 2px solid var(--accent);
  background: var(--bg-secondary);
  color: var(--ink);
  font-weight: 400;
  line-height: 1.55;
}

.site-statement--large {
  display: block;
  margin-top: clamp(1.4rem, 2.4vw, 2rem);
  font-size: clamp(1.1rem, 1.6vw, 1.35rem);
  font-weight: 300;
}

.btn-primary,
.btn-secondary,
.homepage-button-primary,
.homepage-button-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: var(--radius);
  border: 1px solid var(--ink);
  background: var(--ink);
  color: #ffffff;
  font-weight: 400;
  letter-spacing: 0.02em;
  padding: 0.8rem 1.2rem;
  box-shadow: none;
  text-decoration: none;
  text-align: center;
  line-height: 1.35;
  white-space: normal;
  max-width: 100%;
  overflow-wrap: anywhere;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}

.btn-primary:hover,
.homepage-button-primary:hover {
  background: var(--accent);
  border-color: var(--accent);
  color: #ffffff;
  transform: none;
}

.homepage-button-secondary,
.btn-secondary {
  background: transparent;
  color: var(--ink);
  border-color: var(--ink);
}

.homepage-button-secondary:hover,
.btn-secondary:hover {
  background: transparent;
  border-color: var(--accent);
  color: var(--accent);
}

.form-input {
  width: 100%;
  background: var(--bg-card);
  border: 1px solid var(--border-hover);
  color: var(--ink);
  padding: 0.85rem 0.95rem;
  border-radius: var(--radius);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(255, 0, 136, 0.14);
}

.form-input::-moz-placeholder {
  color: var(--text-muted);
}

.form-input::placeholder {
  color: var(--text-muted);
}

.nav-link {
  color: var(--ink-soft);
  font-weight: 400;
  padding: 0.55rem 0.75rem;
  border-radius: var(--radius);
  transition: color 160ms ease, background-color 160ms ease;
}

.nav-link:hover,
.nav-link.active {
  color: var(--ink);
  background: var(--bg-hover);
}

.animate-pulse-professional,
.animate-float-smooth,
.animate-gradient-pro {
  animation: none;
}

section.pt-20,
section.md\\:pt-24,
div.pt-20,
div.md\\:pt-24 {
  padding-top: clamp(5.5rem, 9vw, 7rem) !important;
}

section.pb-8,
section.md\\:pb-10 {
  padding-bottom: clamp(2rem, 4vw, 3rem) !important;
}

section.pt-20 > div > .grid,
section.md\\:pt-24 > div > .grid,
.homepage-card > .grid:first-child {
  gap: clamp(1.5rem, 5vw, 4rem) !important;
}

.homepage-card .bg-bg-hover,
.homepage-card .bg-bg-card,
.bg-bg-card.rounded-2xl,
.bg-bg-hover.rounded-2xl {
  border-color: var(--border) !important;
}

.grid.gap-px,
.grid.md\\:grid-cols-3.gap-px,
.grid.md\\:grid-cols-2.lg\\:grid-cols-4.gap-px,
.grid.md\\:grid-cols-2.lg\\:grid-cols-3.gap-px {
  border-radius: var(--radius) !important;
  border-color: var(--border) !important;
  background: var(--border) !important;
}

table {
  border-collapse: collapse;
}

th,
td {
  vertical-align: top;
}

pre {
  margin: 0;
}

@media (max-width: 56.25em) {
  .admin-smtm-training-workbench,
  .admin-smtm-training-detail-grid {
    grid-template-columns: 1fr;
  }

  .admin-smtm-training-card-wide {
    grid-column: span 1;
  }

  .admin-smtm-filter-row {
    grid-template-columns: 1fr;
  }

  .admin-smtm-status-meta {
    text-align: left;
  }

  .admin-user-select {
    flex: 1 1 100%;
  }

  .admin-user-count {
    margin-left: 0;
  }

  .admin-section-head {
    flex-direction: column;
  }

  .site-hero {
    grid-template-columns: 1fr;
    align-items: start;
  }

  .signal-section-header,
  .site-section-head,
  .signal-service-row,
  .signal-capability-list article,
  .signal-contact,
  .site-row,
  .site-row--text,
  .site-contact {
    grid-template-columns: 1fr;
  }

  .site-grid--2,
  .site-grid--3,
  .site-grid--4,
  .site-matrix--3,
  .site-matrix--4 {
    grid-template-columns: 1fr;
  }

  .signal-service-row a,
  .signal-contact a,
  .site-text-link {
    white-space: normal;
    justify-self: start;
  }
}

@media (max-width: 35em) {
  .admin-dashboard-main {
    width: min(1680px, calc(100% - 1.25rem));
  }

  .admin-smtm-training-list-scroll,
  .admin-smtm-training-detail-scroll {
    max-height: 50vh;
  }

  .site-main,
  .signal-home,
  .site-section__inner,
  .homepage-section > .max-w-7xl,
  .homepage-section > .max-w-6xl,
  .homepage-section > .max-w-4xl,
  .homepage-muted-panel > .max-w-7xl,
  .homepage-muted-panel > .max-w-6xl,
  .homepage-muted-panel > .max-w-4xl,
  /* D-HP-SITE-032: the pages built from sections keep the shared frame's phone margin too */
  section > .max-w-7xl,
  section > .max-w-6xl,
  section > .max-w-4xl,
  section > .max-w-3xl {
    width: min(var(--container), calc(100% - 1.25rem));
  }

  /* D-HP-SITE-030: on phones a page title is never larger than on a tablet (2.3rem); it scales with the width,
     balances its lines so no word stands alone on the last one, and hyphenates only a long word wider than the
     line. */
  .site-hero h1,
  .signal-hero h1,
  .site-title {
    font-size: clamp(2rem, 9vw, 2.3rem);
  }

  :where(h1, h2, h3):not(.admin-dashboard-main *) {
    overflow-wrap: break-word;
    text-wrap: balance;
    /* A word longer than the line (de "Datenschutzerklärung", fi "kaupankäyntiavustaja") is hyphenated by the page
       language's rules; words under twelve letters never are. */
    hyphens: auto;
    hyphenate-limit-chars: 12 5 5;
    -webkit-hyphenate-limit-before: 5;
    -webkit-hyphenate-limit-after: 5;
  }

  /* The columns of a page head may become narrower than their longest word; where the browser has no hyphenation
     dictionary for the page language, such a word then breaks at the line's end instead of widening the page. */
  :where(.site-hero, .finance-hero) > * {
    min-width: 0;
  }

  /* The consent dialog's title is one long word in some languages (sv "Integritetsinställningar"); it scales down
     with the width instead of running past the dialog's edge, and reaches its desktop size from about 430px on. */
  #cookie-consent-title {
    font-size: clamp(1.5rem, 7vw, 1.875rem);
  }

  /* When the title and the language control do not fit side by side, the control moves below the title instead of
     squeezing the title into broken words. */
  .cookie-consent__head {
    flex-wrap: wrap;
  }
}

/* ---------- admin dashboard density ----------
   The operator surface shows tables, states and controls, not marketing copy.
   Everything below tightens the shared components inside the dashboard only;
   the public pages keep their own proportions. The utility overrides carry two
   classes plus the two :not() parts so they outrank Tailwind's own spacing. */
.admin-dashboard-main {
  font-size: 0.88rem;
}

.admin-dashboard-main.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.7rem;
}

.admin-dashboard-main .space-y-2 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.3rem;
}

.admin-dashboard-main .space-y-3 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.4rem;
}

.admin-dashboard-main .space-y-4 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem;
}

.admin-dashboard-main .site-card {
  padding: 0.8rem 0.9rem;
}

.admin-dashboard-main .homepage-muted-panel {
  padding: 0.65rem 0.75rem;
}

.admin-dashboard-main .homepage-button-primary,
.admin-dashboard-main .homepage-button-secondary {
  padding: 0.3rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 500;
  border-radius: var(--radius);
  gap: 0.35rem;
}

.admin-dashboard-main .form-input {
  padding: 0.32rem 0.55rem;
  font-size: 0.8rem;
}

/* The indicator row packs as many cards per line as fit instead of leaving a
   single orphan below a fixed eight-column grid. */
/* Service cards are as tall as their content; the links stay bottom-aligned
   within a row instead of a fixed height stretching every card. */
.admin-dashboard-main .admin-panel h2,
.admin-dashboard-main .site-card h2 {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.admin-dashboard-main .admin-panel h3,
.admin-dashboard-main .site-card h3 {
  font-size: 0.87rem;
  font-weight: 500;
  margin: 0;
}

.admin-dashboard-main .site-copy,
.admin-dashboard-main .site-card p,
.admin-dashboard-main .homepage-muted-panel p {
  font-size: 0.78rem;
  line-height: 1.4;
}

.admin-dashboard-main .editorial-kicker {
  margin-bottom: 0.35rem;
}

.admin-dashboard-main .admin-section-head {
  gap: 0.5rem;
}

.admin-dashboard-main .admin-node-grid {
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 0.5rem;
}

.admin-dashboard-main .admin-table thead th {
  padding: 0.35rem 0.55rem;
  font-size: 0.64rem;
  letter-spacing: 0.05em;
}

.admin-dashboard-main .admin-table tbody td {
  padding: 0.38rem 0.55rem;
  font-size: 0.79rem;
}

.admin-dashboard-main .admin-status-pill {
  padding: 0.08rem 0.45rem;
  font-size: 0.65rem;
}

.admin-dashboard-main .admin-inline-actions {
  gap: 0.3rem;
}

.admin-dashboard-main .admin-user-toolbar {
  gap: 0.4rem;
}

.admin-dashboard-main .admin-user-hint,
.admin-dashboard-main .admin-user-count {
  font-size: 0.75rem;
}

/* The tab-specific grids follow the same rule as the overview: cards pack by
   available width and are as tall as their content. */
.admin-dashboard-main .admin-smtm-filter-row {
  gap: 0.5rem;
}

.admin-dashboard-main .admin-smtm-training-card-tall {
  min-height: 11rem;
}

.admin-dashboard-main .admin-smtm-training-detail-grid {
  gap: 0.5rem;
}

.admin-dashboard-main .admin-smtm-status-meta {
  min-width: 11rem;
  font-size: 0.75rem;
}

/* Tailwind's spacing utilities are sized for the public pages. */
.admin-dashboard-main .gap-2 { gap: 0.3rem; }
.admin-dashboard-main .gap-3 { gap: 0.4rem; }
.admin-dashboard-main .gap-4 { gap: 0.5rem; }
.admin-dashboard-main .gap-6 { gap: 0.6rem; }
.admin-dashboard-main .mt-2 { margin-top: 0.3rem; }
.admin-dashboard-main .mt-4 { margin-top: 0.5rem; }

.admin-dashboard-main input[type="checkbox"],
.admin-dashboard-main input[type="radio"] {
  width: 0.85rem;
  height: 0.85rem;
}

/* The remaining tab-local components, on the same proportions as the rest. */
.admin-dashboard-main .admin-smtm-frame-metric { gap: 0.25rem; font-size: 0.74rem; }
.admin-dashboard-main .admin-smtm-issue-list { gap: 0.25rem; }
.admin-dashboard-main .admin-smtm-status-body-scroll { gap: 0.5rem; }
.admin-dashboard-main .admin-smtm-training-workbench { gap: 0.5rem; }
.admin-dashboard-main .admin-smtm-training-list-scroll { gap: 0.45rem; }
.admin-dashboard-main .admin-smtm-training-list-item { gap: 0.3rem; padding: 0.6rem 0.7rem; }
.admin-dashboard-main .admin-smtm-training-list-head { gap: 0.5rem; }
.admin-dashboard-main .admin-smtm-training-card { gap: 0.45rem; }
.admin-dashboard-main .admin-smtm-training-detail-list { gap: 0.35rem; }
.admin-dashboard-main .admin-smtm-training-detail-row { gap: 0.5rem; padding: 0.35rem 0; font-size: 0.79rem; }
.admin-dashboard-main .admin-azurite-files { gap: 0.3rem; }
.admin-dashboard-main .admin-azurite-file { font-size: 0.75rem; }
.admin-dashboard-main .admin-meta-list { padding: 0.55rem 0.7rem; }
.admin-dashboard-main .admin-user-mail { font-size: 0.74rem; }
.admin-dashboard-main .admin-user-roles { gap: 0.25rem; }
.admin-dashboard-main .admin-user-pager { gap: 0.5rem; font-size: 0.76rem; }

/* ---------- admin dashboard navigation ----------
   Two levels in one bar that stays below the site navigation while the page
   scrolls: the tabs grouped by what they operate, and the sections of the
   open tab. Every section fills the same content width, so cards, tables and
   grids of all tabs share one left and one right edge. */
.admin-dashboard-main .admin-nav-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.3rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 600;
  line-height: 1;
}

.admin-nav-badge.is-warning {
  background: rgba(168, 98, 0, 0.12);
  color: var(--warning);
}

.admin-nav-badge.is-error {
  background: var(--accent);
  color: #ffffff;
}

/* Tables fill their card; only a narrow screen scrolls them sideways. */
.admin-dashboard-main .admin-table {
  min-width: 100%;
}

.admin-fixed-table {
  table-layout: fixed;
}

.admin-dashboard-main .admin-table tbody tr.is-selected td {
  background: var(--bg-hover);
}

.admin-dashboard-main .admin-detail-row td,
.admin-dashboard-main .admin-detail-row:hover td {
  background: var(--bg-secondary);
}

.admin-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
}

.admin-card {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 0.45rem;
  padding: 0.9rem 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
}

.admin-card-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

/* A project's state as a badge, and the reasons it is not presentable as a list the administrator opens
   (software development page, IDD D-HP-ADMIN-021). */
.admin-badge {
  display: inline-block;
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.admin-badge-ok {
  background: color-mix(in srgb, var(--success) 16%, transparent);
  color: var(--success);
}

.admin-badge-warn {
  background: color-mix(in srgb, var(--warning) 18%, transparent);
  color: var(--warning);
}

.admin-reasons summary {
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-primary);
}

.admin-reasons ol {
  margin: 0.45rem 0 0;
  padding-left: 1.6rem;
  list-style: decimal outside;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.admin-reasons li {
  display: list-item;
  list-style: decimal outside;
  margin-top: 0.35rem;
  overflow-wrap: anywhere;
}

.admin-reasons li::marker {
  content: counter(list-item) ". ";
  color: var(--text-primary);
  font-weight: 600;
}

.admin-table td.admin-col-state {
  min-width: 14rem;
}

.admin-table td.admin-col-address {
  min-width: 14rem;
  overflow-wrap: anywhere;
}

.admin-table td.admin-col-actions {
  white-space: nowrap;
}

.admin-table td.admin-col-actions a,
.admin-table td.admin-col-actions button {
  flex: 0 0 auto;
  white-space: nowrap;
}

.admin-filter-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.5rem;
}

.admin-log {
  max-height: 60vh;
  overflow-y: auto;
  font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
  font-size: 12px;
  white-space: pre-wrap;
}

.admin-table-scroll-tall {
  max-height: 60vh;
}

/* The overview's list of what needs a person: one row per item on a shared
   column grid, the whole row leads to the section that holds it. */
.admin-attention-list {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}

.admin-attention-item {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr) 22rem;
  align-items: center;
  gap: 0.75rem;
  padding: 0.45rem 0.6rem;
  border: 0;
  border-top: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  font-size: 0.8rem;
  text-align: left;
}

.admin-attention-item:first-child {
  border-top: 0;
}

.admin-attention-item:hover {
  background: var(--bg-hover);
  color: var(--ink);
}

.admin-attention-item .admin-status-pill {
  justify-self: start;
  white-space: nowrap;
}

.admin-attention-text {
  min-width: 0;
  overflow-wrap: anywhere;
}

.admin-attention-where {
  color: var(--text-muted);
  font-size: 0.74rem;
  text-align: right;
}

.admin-attention-list > .homepage-muted-panel {
  border: 0;
  border-radius: 0;
}

@media (max-width: 68.75em) {
  .admin-dashboard-main .admin-table {
    min-width: 900px;
  }

  }

@media (max-width: 56.25em) {
  .admin-dashboard-main   .admin-attention-item {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .admin-attention-where {
    text-align: left;
  }

  .admin-detail-grid,
  .admin-filter-row {
    grid-template-columns: 1fr;
  }
}

/* ---- Team: overview cards and the switcher inside a profile ---- */
.team-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(1rem, 2.4vw, 1.6rem);
}

.team-card {
  display: flex;
  flex-direction: column;
  color: inherit;
  text-decoration: none;
  transition: border-color 180ms ease, transform 180ms ease;
}

.team-card:hover,
.team-card:focus-visible {
  border-color: var(--ink);
  transform: translateY(-2px);
}

.team-card__photo {
  aspect-ratio: 4 / 5;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  overflow: hidden;
}

.team-card__photo img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center 18%;
     object-position: center 18%;
}

.team-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.55rem;
  padding: clamp(1rem, 2vw, 1.35rem);
}

.team-card__body h2 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.3rem, 1.9vw, 1.65rem);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1.15;
}

.team-card__headline {
  margin: 0;
  color: var(--ink);
  font-size: 0.94rem;
  font-weight: 400;
  line-height: 1.45;
}

.team-card__summary {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.9rem;
  line-height: 1.66;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.team-card__cta {
  justify-content: flex-start;
  justify-self: start;
  margin-top: auto;
  padding-top: 0.4rem;
}

.team-switcher {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem 1rem;
  margin-bottom: 1rem;
}

.team-switcher__back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--ink-soft);
  font-size: 0.88rem;
  font-weight: 400;
  text-decoration: none;
}

.team-switcher__back:hover {
  color: var(--accent);
}

.team-switcher__members {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.team-switcher__item {
  padding: 0.42rem 0.8rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  color: var(--ink-soft);
  font-size: 0.88rem;
  font-weight: 400;
  text-decoration: none;
  transition: border-color 160ms ease, color 160ms ease;
}

.team-switcher__item:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}

.team-switcher__item--active {
  border-color: var(--ink);
  color: var(--ink);
}

.landing-contact {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: start;
  margin: clamp(0.8rem, 2vw, 1.6rem) 0 clamp(2rem, 4vw, 3.2rem);
  padding-top: 1.6rem;
  border-top: 1px solid var(--rule);
}

.finance-cta__lead {
  max-width: 34rem;
  margin: 0.7rem 0 0;
  color: var(--text-muted);
  line-height: 1.72;
}

.landing-contact__cta {
  margin-top: 1.3rem;
}

.landing-contact__facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem 1.6rem;
  margin: 0;
}

.landing-contact__facts dt {
  margin-bottom: 0.45rem;
  color: var(--logo-grey);
  font-size: 0.72rem;
  font-weight: 400;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.landing-contact__facts dd {
  margin: 0;
  color: var(--ink);
  font-size: 1rem;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.landing-contact__facts a {
  color: inherit;
  text-decoration: none;
}

.landing-contact__phone {
  display: block;
}

.landing-contact__facts a:hover {
  color: var(--accent);
}

.profile-link {
  color: var(--ink);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 0.28em;
}

.profile-link + .profile-link {
  margin-left: 0.8rem;
}

.profile-link:hover {
  color: var(--accent);
}

/* ---- Teaching page: full-width sections, rows instead of nested cards ---- */
.teaching-page .signal-section {
  padding: clamp(1.9rem, 3.2vw, 2.8rem) 0;
  border-bottom: 1px solid var(--border);
}

.teaching-page .signal-section-header {
  margin-bottom: clamp(0.9rem, 1.8vw, 1.3rem);
}

/* D-HP-SITE-032: the teaching head starts at the shared head's height; the photo stands beside the title. */
.teaching-hero {
  align-items: start;
  padding: clamp(2.4rem, 5vw, 4.8rem) 0 clamp(1.8rem, 3.4vw, 3rem);
}

.teaching-hero__photo {
  height: clamp(13rem, 22vw, 19rem);
}

.teaching-subtitle {
  margin-bottom: 0.6rem !important;
  color: var(--text-primary) !important;
  font-size: 1.08rem;
  font-weight: 500;
  line-height: 1.45;
}

.teaching-inline-label {
  color: var(--text-secondary);
  font-weight: 500;
}

.teaching-cell {
  padding: 1rem 1.2rem;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.5;
}

.teaching-row {
  display: grid;
  gap: 0.5rem clamp(1.2rem, 3.5vw, 3rem);
  align-items: start;
  padding: clamp(0.95rem, 1.8vw, 1.3rem) 0;
  border-bottom: 1px solid var(--border);
}

.teaching-row--group {
  grid-template-columns: minmax(13rem, 0.3fr) minmax(0, 1fr) minmax(15rem, 0.46fr);
}

.teaching-row--format {
  grid-template-columns: minmax(13rem, 0.3fr) minmax(7rem, 0.16fr) minmax(0, 1fr);
}

.teaching-row h3,
.teaching-topics h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: clamp(1.02rem, 1.25vw, 1.2rem);
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.25;
}

.teaching-row p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
}

.teaching-row .teaching-row__focus {
  margin-top: 0.3rem;
  color: var(--text-muted);
  font-size: 0.86rem;
}

.teaching-row__focus span {
  font-weight: 500;
}

.teaching-row .teaching-row__duration {
  color: var(--primary-light);
  font-weight: 500;
}

.teaching-row__tags {
  margin-top: 0;
  justify-content: flex-end;
}

.teaching-topics {
  padding: clamp(1.05rem, 2vw, 1.45rem);
}

.teaching-topics h3 {
  margin-bottom: 0.8rem;
}

.teaching-topics li {
  padding: 0.42rem 0;
  border-top: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.93rem;
  line-height: 1.5;
}

.teaching-topics p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.93rem;
  line-height: 1.65;
}

.teaching-topics .signal-service-tags {
  margin-top: 0;
}

.teaching-benefits {
  margin-top: 1.4rem;
}

.teaching-expertise {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 clamp(1.5rem, 4vw, 3.5rem);
  border-top: 1px solid var(--border-hover);
}

.teaching-expertise li {
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.55;
}

.teaching-facts {
  margin-top: clamp(1.4rem, 3vw, 2.2rem);
}

/* ---- Finance page: lead, the analysis set apart, one row per function ---- */
.finance-hero {
  max-width: 62rem;
}

/* D-HP-SITE-032: the lead of Finance AI and the IDD pages is the shared lead (size, weight, colour). */
.finance-lead {
  margin: 1.1rem 0 0;
  color: var(--ink-soft);
  font-size: clamp(1.06rem, 1.4vw, 1.28rem);
  font-weight: 300;
  line-height: 1.55;
}

.finance-analysis {
  display: grid;
  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);
  gap: 1rem clamp(1.5rem, 5vw, 4rem);
  align-items: start;
  margin-top: clamp(1.6rem, 3vw, 2.4rem);
  padding: clamp(1.6rem, 3vw, 2.4rem) clamp(1.2rem, 2.6vw, 2.2rem);
  border-left: 2px solid var(--accent);
  background: var(--bg-secondary);
}

.finance-analysis__text {
  display: grid;
  gap: 0.9rem;
}

.finance-analysis__text p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 1rem;
  line-height: 1.72;
}

.finance-analysis__text p:first-child {
  color: var(--ink);
  font-size: 1.1rem;
}

/* One row per item, title beside text: the functions of the finance page and
   the applications of the platform on the start page. */
.finance-features,
.platform-apps {
  border-top: 1px solid var(--rule);
}

.finance-feature,
.platform-app {
  display: grid;
  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);
  gap: 0.6rem clamp(1.5rem, 5vw, 4rem);
  align-items: start;
  padding: clamp(1.1rem, 2vw, 1.5rem) 0;
  border-bottom: 1px solid var(--border);
}

.finance-feature h3,
.platform-app h3 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.08rem, 1.35vw, 1.24rem);
  font-weight: 400;
  line-height: 1.35;
}

.finance-feature p,
.platform-app p {
  max-width: 54rem;
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.98rem;
  line-height: 1.7;
}

.finance-feature .finance-feature__facts {
  margin-top: 0.45rem;
  color: var(--muted);
  font-size: 0.84rem;
  line-height: 1.6;
}

/* Pages told in prose (IDD, Veridion) keep several paragraphs in one row and
   link words inside a paragraph. */
.story-page .finance-feature p + p {
  margin-top: 0.8rem;
}

.story-page__detail {
  margin-top: 0.8rem;
}

/* On the start page the rows sit under a section header with its own text, so
   they take the header's columns. */
.platform-app {
  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);
}

.platform-app__link {
  margin-top: 0.6rem;
}

@media (max-width: 63.9375em) {
  .team-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .finance-analysis,
  .finance-feature,
  .platform-app,
  .legal-section,
  .profile-contact,
  .landing-contact,
  .teaching-row--group,
  .teaching-row--format,
  .teaching-expertise {
    grid-template-columns: 1fr;
  }

  .teaching-row__tags {
    justify-content: flex-start;
  }
}

@media (max-width: 40em) {
  .team-grid,
  .landing-contact__facts {
    grid-template-columns: 1fr;
  }

  .team-card__photo {
    aspect-ratio: 1 / 1;
  }

  .team-switcher {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* ---- Navigation: the logo is the home link ---- */
.site-nav {
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid var(--border);
}

.site-nav--scrolled {
  border-bottom-color: var(--rule);
}

.site-nav__logo {
  display: flex;
  align-items: center;
}

.site-nav__logo img {
  display: block;
  width: auto;
  height: 30px;
}

.site-nav__link {
  position: relative;
  padding: 0.5rem 0.6rem;
  color: var(--ink-soft);
  font-size: 0.9rem;
  font-weight: 400;
  white-space: nowrap;
  text-decoration: none;
  transition: color 160ms ease;
}

.site-nav__link:hover {
  color: var(--ink);
}

.site-nav__link--active {
  color: var(--ink);
}

.site-nav__link--active::after {
  content: "";
  position: absolute;
  left: 0.6rem;
  right: 0.6rem;
  bottom: 0.15rem;
  height: 1px;
  background: var(--accent);
}

.site-nav__menu {
  min-width: 13rem;
  padding: 0.4rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  box-shadow: 0 10px 30px rgba(26, 26, 26, 0.08);
}

.site-nav__menu-item {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius);
  color: var(--ink-soft);
  font-size: 0.9rem;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
  transition: background-color 160ms ease, color 160ms ease;
}

.site-nav__menu-item:hover,
.site-nav__menu-item--active {
  background: var(--bg-hover);
  color: var(--ink);
}

.site-nav__control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  height: 2.25rem;
  box-sizing: border-box;
  padding: 0 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  color: var(--ink-soft);
  font-size: 0.86rem;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  transition: border-color 160ms ease, color 160ms ease;
}

.site-nav__control:hover {
  border-color: var(--ink);
  color: var(--ink);
}

.site-nav__control--lang {
  border-color: transparent;
  background: transparent;
  padding: 0 0.45rem;
}

.site-nav__control--lang:hover {
  border-color: transparent;
  color: var(--ink);
}

.site-nav__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.25rem;
  box-sizing: border-box;
  padding: 0 1rem;
  font-size: 0.86rem;
  line-height: 1;
  white-space: nowrap;
}

/* D-HP-SITE-030: on narrow phones the bar keeps language, sign-in and menu fully on screen in every language — the
   logo may shrink in proportion and the controls tighten their padding; wider screens are unchanged. */
@media (max-width: 30em) {
  .site-nav .site-nav__logo {
    flex-shrink: 1;
    min-width: 4.5rem;
    margin-right: 0.5rem;
  }

  .site-nav .site-nav__logo img {
    max-width: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: left center;
       object-position: left center;
  }

  .site-nav .site-nav__button {
    padding: 0 0.7rem;
  }

  .site-nav .site-nav__control {
    padding: 0 0.55rem;
  }

  /* The bar never reaches past the screen sideways: on a phone an overflowing fixed bar widens the layout viewport,
     which then drags every fixed layer (the consent dialog among them) past the screen and makes the bar measure more
     room than there is. Menus that open downwards are not affected. */
  .site-nav > div {
    overflow-x: clip;
  }
}

/* When the bar is too narrow for logo, language, sign-in and menu side by side — on a small phone or with an enlarged
   system font — sign-in moves into the menu, where it is always offered. The bar is a size container whose em follows
   its font size, so the point grows with the text; each language's point is its measured need (logo 4.5em, gap 0.5em,
   the measured width of the right-hand controls, 0.3em margin). */
@media (max-width: 30em) {
  .site-nav > div {
    container: sitenav / inline-size;
  }
}

@container sitenav (max-width: 19.66em) {
  html:lang(de) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 17.78em) {
  html:lang(en) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 19.15em) {
  html:lang(nl) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 18.43em) {
  html:lang(uk) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 19.85em) {
  html:lang(fr) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 17.86em) {
  html:lang(it) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 21.06em) {
  html:lang(es) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 18.9em) {
  html:lang(sv) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 21.77em) {
  html:lang(fi) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 18.64em) {
  html:lang(ja) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 19.89em) {
  html:lang(pl) .site-nav .site-nav__button {
    display: none;
  }
}

@container sitenav (max-width: 17.52em) {
  html:lang(bg) .site-nav .site-nav__button {
    display: none;
  }
}

.site-nav__mobile {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  box-shadow: 0 16px 40px rgba(26, 26, 26, 0.1);
}

.site-nav__mobile-item {
  display: block;
  width: 100%;
  padding: 0.7rem 1rem;
  border-left: 2px solid transparent;
  color: var(--ink-soft);
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
}

.site-nav__mobile-item:hover {
  background: var(--bg-hover);
  color: var(--ink);
}

.site-nav__mobile-item--active {
  border-left-color: var(--accent);
  color: var(--ink);
}

.site-nav__mobile-item--sub {
  padding-left: 2rem;
  font-size: 0.92rem;
}

/* ---- Start page ---- */
.landing-hero {
  padding: clamp(2.6rem, 5vw, 4.6rem) 0 clamp(2.4rem, 4.6vw, 4rem);
  border-bottom: 1px solid var(--rule);
}

.landing-hero__logo {
  margin: 0;
}

.landing-hero__logo img {
  display: block;
  width: min(100%, 40rem);
  height: auto;
}

.landing-hero__text {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: clamp(1.5rem, 5vw, 4.5rem);
  align-items: start;
  margin-top: clamp(2.4rem, 4.4vw, 3.6rem);
}

.landing-hero__claim {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.6rem, 2.5vw, 2.35rem);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1.22;
}

.landing-hero__copy p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 1.04rem;
  line-height: 1.74;
}

.landing-hero__copy p + p {
  margin-top: 1rem;
}

/* The vision fills the claim column: the one bold paragraph under the claim,
   so both hero columns carry equal weight and no space stands empty. */
.landing-hero__vision {
  margin: 1.6rem 0 0;
  color: var(--ink);
  font-weight: 600;
  font-size: 1.12rem;
  line-height: 1.6;
}

.product-list {
  border-top: 1px solid var(--rule);
}

.product-row {
  display: grid;
  grid-template-columns: 16rem minmax(0, 1fr) 13rem;
  gap: clamp(1.4rem, 3.6vw, 3rem);
  align-items: start;
  padding: clamp(1.5rem, 2.6vw, 2.2rem) 0;
  border-bottom: 1px solid var(--border);
}

.product-row__mark {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16 / 10;
  border-radius: var(--radius);
  overflow: hidden;
}

.product-row__mark img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.product-row__mark--kyveil {
  background: #141c27;
}

.product-row__mark--kyveil img {
  -o-object-fit: contain;
     object-fit: contain;
}

.product-row__mark--veridion {
  background: #020733;
}

.product-row__mark--robuddy {
  background: var(--bg-secondary);
}

.product-row__mark--robuddy img {
  width: auto;
  height: 88%;
  -o-object-fit: contain;
     object-fit: contain;
}

.product-row__mark--bisigma,
.partner-row__mark {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: 0;
  padding: 0;
}

.product-row__mark--bisigma img,
.partner-row__mark img {
  display: block;
  width: min(100%, 16.5rem);
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
}

/* Partner row sits directly under .signal-section-header and shares its exact
   two-column grid and vertical centering for symmetrical alignment. */
.partner-row {
  display: grid;
  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: center;
  padding: clamp(1.75rem, 3vw, 2.5rem) 0;
  border-bottom: 1px solid var(--border);
}

.partner-row__body {
  display: grid;
  gap: 0.65rem;
  justify-items: start;
}

.partner-row__tagline {
  margin: 0;
  color: var(--logo-grey);
  font-size: 0.72rem;
  font-weight: 400;
  letter-spacing: 0.16em;
  line-height: 1.55;
  text-transform: uppercase;
}

.partner-row__body h3 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.3rem, 1.8vw, 1.6rem);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.partner-row__body p:not(.partner-row__tagline) {
  max-width: 52rem;
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.98rem;
  line-height: 1.72;
}

.partner-row__link {
  justify-self: start;
  justify-content: flex-start;
  text-align: left;
  margin-top: 0.25rem;
}

.product-row__body {
  display: grid;
  gap: 0.75rem;
}

.product-row__body h3 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.3rem, 1.8vw, 1.6rem);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.product-row__body p {
  max-width: 48rem;
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.98rem;
  line-height: 1.72;
}

.product-row__body h3 + p {
  color: var(--ink);
  font-size: 1.05rem;
}

.product-row__body .product-row__note {
  color: var(--muted);
  font-size: 0.86rem;
}

.product-row__offer {
  display: grid;
  justify-items: start;
  gap: 0.7rem;
}

.product-row__price {
  margin: 0;
  color: var(--ink);
  font-size: 1.15rem;
  font-weight: 400;
}

.product-row__offer .site-text-link {
  justify-self: start;
  justify-content: flex-start;
  text-align: left;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  -moz-column-gap: clamp(1.5rem, 3.2vw, 2.8rem);
       column-gap: clamp(1.5rem, 3.2vw, 2.8rem);
  border-top: 1px solid var(--rule);
}

.service-cell {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: clamp(1.3rem, 2.2vw, 1.8rem) 0;
  border-bottom: 1px solid var(--border);
}

.service-cell h3 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.12rem, 1.4vw, 1.28rem);
  font-weight: 400;
  line-height: 1.3;
}

.service-cell p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.95rem;
  line-height: 1.68;
}

.service-cell .service-cell__features {
  color: var(--muted);
  font-size: 0.82rem;
  line-height: 1.6;
}

.service-cell__link {
  align-self: flex-start;
  justify-content: flex-start;
  margin-top: auto;
  padding-top: 0.3rem;
  text-align: left;
}

/* ---- Legal notice and privacy policy: topic left, text right ---- */
.legal-section {
  display: grid;
  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);
  gap: 0.8rem clamp(1.5rem, 5vw, 4rem);
  align-items: start;
  padding: clamp(1.6rem, 3vw, 2.4rem) 0;
  border-bottom: 1px solid var(--border);
}

/* D-HP-SITE-030: on phones topic and text stand one above the other. The rule in the tablet block further up never
   took effect, because this base rule follows it in the file; the legal notice and the privacy statement squeezed
   their text into a narrow right column on phones. Desktop and tablet keep their two columns unchanged. */
@media (max-width: 40em) {
  .legal-section {
    grid-template-columns: minmax(0, 1fr);
  }
}

.legal-section__title {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.2rem, 1.6vw, 1.45rem);
  font-weight: 300;
  line-height: 1.3;
}

.legal-section__body {
  max-width: 52rem;
}

.legal-section__body h3 {
  margin: 1.2rem 0 0.3rem;
  color: var(--ink);
  font-size: 0.98rem;
  font-weight: 500;
}

.legal-section__body h3:first-child {
  margin-top: 0;
}

.legal-section__body p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.98rem;
  line-height: 1.72;
}

.legal-section__body p + p {
  margin-top: 0.8rem;
}

.legal-section__body .legal-section__name {
  color: var(--ink);
  font-size: 1.1rem;
  font-weight: 400;
}

.legal-section__body a,
.product-row__body p a,
.signal-section-header p a,
.story-page p a {
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 0.28em;
}

.legal-section__body a:hover,
.product-row__body p a:hover,
.signal-section-header p a:hover,
.story-page p a:hover {
  color: var(--accent);
}

.legal-note {
  margin: 1.6rem 0 0;
  color: var(--muted);
  font-size: 0.84rem;
}

/* ---- Team: the function of a member and the contact below a profile ---- */
.team-members-intro {
  max-width: 52rem;
  margin-top: 1.2rem;
}

.profile-role {
  margin: 0 0 0.6rem;
  color: var(--logo-grey);
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
}

.profile-name {
  margin: 0 0 0.5rem;
  color: var(--ink);
  font-size: clamp(2.1rem, 3.6vw, 3.2rem);
  font-weight: 300;
  letter-spacing: -0.015em;
  line-height: 1.1;
}

.profile-contact {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1.5rem clamp(1.5rem, 5vw, 4rem);
  align-items: end;
  width: min(var(--container), calc(100% - 2rem));
  margin: 0 auto clamp(2.4rem, 4vw, 3.6rem);
  padding-top: 1.4rem;
  border-top: 1px solid var(--rule);
}

/* D-HP-SITE-030: the same cascade order as the legal sections — on phones the contact block of a profile is one
   column; desktop and tablet are unchanged. */
@media (max-width: 40em) {
  .profile-contact {
    grid-template-columns: minmax(0, 1fr);
  }
}

.profile-contact__mail {
  margin: 0.6rem 0 0;
  color: var(--ink);
  font-size: 1.05rem;
}

.profile-contact__mail a:hover {
  color: var(--accent);
}

/* ---- Events: start page and events page ---- */
.site-row--text.event-row {
  grid-template-columns: minmax(9rem, 13rem) minmax(0, 1fr);
}

/* D-HP-SITE-030: on phones the date stands above the event; this rule is more specific than the general one in the
   tablet block, so it needs its own phone rule. Desktop and tablet are unchanged. */
@media (max-width: 40em) {
  .site-row--text.event-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

.event-row .event-row__date {
  margin: 0;
  color: var(--ink);
  font-size: 0.95rem;
  font-weight: 400;
}

.event-row h3 a {
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 0.28em;
}

.event-row h3 a:hover {
  color: var(--accent);
}

.event-year + .event-year {
  margin-top: clamp(1.8rem, 3vw, 2.6rem);
}

.event-year__label {
  margin: 0 0 0.8rem;
  color: var(--logo-grey);
  font-size: 0.78rem;
  font-weight: 400;
  letter-spacing: 0.2em;
}

.landing-events__all {
  justify-self: start;
  justify-content: flex-start;
  margin-top: 1.2rem;
}

/* ---- Footer: laid out like the foot of the company's letters ---- */
.site-footer {
  border-top: 1px solid var(--rule);
  background: var(--bg-main);
}

.site-footer__inner {
  width: min(var(--container), calc(100% - 2rem));
  margin: 0 auto;
  padding: clamp(2rem, 4vw, 3rem) 0 1.6rem;
}

.site-footer__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1.6rem clamp(1.2rem, 3vw, 2.4rem);
}

.site-footer__grid p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.86rem;
  line-height: 1.75;
}

.site-footer__grid a,
.site-footer__grid button {
  color: inherit;
  font: inherit;
  text-decoration: none;
  transition: color 160ms ease;
}

.site-footer__grid a:hover,
.site-footer__grid button:hover {
  color: var(--accent);
}

.site-footer .site-footer__name {
  color: var(--ink);
  font-weight: 400;
}

.site-footer .site-footer__label {
  color: var(--ink);
}

.site-footer__copyright {
  margin: clamp(1.6rem, 3vw, 2.4rem) 0 0;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
  color: var(--muted);
  font-size: 0.8rem;
}

@media (max-width: 63.9375em) {
  .landing-hero__text,
  .product-row,
  .partner-row {
    grid-template-columns: 1fr;
  }

  .product-row__mark {
    max-width: 22rem;
  }

  .service-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .site-footer__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 40em) {
  .service-grid,
  .site-footer__grid {
    grid-template-columns: 1fr;
  }

  .site-nav__logo img {
    height: 26px;
  }
}

/* Account page: who is signed in, one row per fact under a thin rule. */
.account-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.6rem;
}

.account-facts {
  margin: 0;
}

.account-facts__row {
  display: grid;
  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);
  gap: 0.2rem clamp(1.5rem, 5vw, 4rem);
  padding: 1rem 0;
  border-bottom: 1px solid var(--border);
}

.account-facts dt,
.account-facts dd {
  margin: 0;
  line-height: 1.5;
}

.account-facts dt {
  color: var(--muted);
}

.account-facts dd {
  color: var(--ink);
  overflow-wrap: anywhere;
}

@media (max-width: 40em) {
  .account-facts__row {
    grid-template-columns: 1fr;
  }
}

/* The parts of a page with two areas (the IDD page): named at its top as links,
   and anchors that keep their heading clear of the fixed navigation. */
.page-parts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 2rem;
  padding-top: 1.5rem;
}

.page-parts__link {
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  color: var(--text-secondary, inherit);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 0.35em;
}

.page-parts__link:hover {
  color: var(--accent);
}

.page-anchor {
  scroll-margin-top: 5rem;
}

.page-parts__link--current {
  color: var(--text-primary, inherit);
}

/* The parts links at the start of the method part sit on the page ground and
   keep only a small gap above the method's own heading. */
.page-parts-bar .site-main {
  padding-bottom: 0;
  min-height: 0;
}

/* The navigation links while the bar is compact: kept in the layout but out of
   sight and out of reach, so the navigation can measure whether they fit. */
.site-nav__links--measured {
  position: absolute;
  left: -10000px;
  top: 0;
  visibility: hidden;
  pointer-events: none;
  white-space: nowrap;
}

/* ---------- admin dashboard: the console (IDD D-HP-ADMIN-040) ----------
   One sidebar with the pages in the groups of the company's working day, one
   page at a time with its sections; a section carries its state in the header
   and folds when it holds reference material or a form; numbers stand in rows,
   never in tiles; long tables show fifty rows and more on request. Writing to
   and calling a colleague open a dialog over the page (IDD D-HP-ADMIN-041). */
.admin-dashboard-main {
  font-size: 0.92rem;
}

/* The dashboard is an operating surface and uses the whole screen, however wide it is; only the public pages keep
   the reading width of the container. */
.site-main.admin-dashboard-main {
  width: calc(100% - 3rem);
  max-width: none;
}

.admin-shell {
  display: grid;
  grid-template-columns: 14rem minmax(0, 1fr);
  gap: 1.5rem;
  align-items: start;
}

.admin-sidebar {
  position: sticky;
  top: 4.5rem;
  max-height: calc(100vh - 5rem);
  overflow-y: auto;
  padding: 0.6rem 0.6rem 1.2rem 0;
  border-right: 1px solid var(--border);
}

.admin-sidebar-head {
  margin-bottom: 0.6rem;
  padding: 0 0.6rem 0.9rem;
  border-bottom: 1px solid var(--border);
}

.admin-sidebar-title {
  margin-top: 0.4rem;
  color: var(--text-primary);
  font-size: 1.05rem;
  font-weight: 500;
}

.admin-sidebar-group {
  margin-top: 0.85rem;
}

.admin-sidebar-group-label {
  padding: 0 0.6rem 0.3rem;
  color: var(--text-muted);
  font-size: 0.78rem;
  font-weight: 600;
}

.admin-sidebar-list,
.admin-sidebar-sublist {
  display: grid;
  gap: 0.1rem;
}

.admin-sidebar-sublist {
  margin: 0.1rem 0 0.3rem 0.9rem;
  padding-left: 0.6rem;
  border-left: 1px solid var(--border);
}

.admin-sidebar-sublist.is-next-group {
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px solid var(--border);
}

.admin-sidebar-link,
.admin-sidebar-sublink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  padding: 0.38rem 0.6rem;
  border: 0;
  border-left: 2px solid transparent;
  border-radius: var(--radius);
  background: transparent;
  color: var(--ink-soft);
  font-size: 0.92rem;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
}

.admin-sidebar-sublink {
  padding: 0.28rem 0.5rem;
  font-size: 0.86rem;
}

.admin-sidebar-link:hover,
.admin-sidebar-sublink:hover {
  background: var(--bg-hover);
  color: var(--ink);
}

.admin-sidebar-link.active,
.admin-sidebar-sublink.active {
  background: var(--bg-hover);
  border-left-color: var(--accent);
  color: var(--ink);
  font-weight: 500;
}

.admin-content {
  min-width: 0;
}

.admin-page-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.admin-dashboard-main .site-card.admin-page-head {
  padding: 1rem 1.15rem;
  overflow: visible;
}

.admin-page-head .admin-hero-title {
  font-size: 1.35rem;
  font-weight: 500;
}

.admin-page-head .site-copy {
  margin-top: 0.35rem;
  max-width: 60rem;
  font-size: 0.9rem;
}

.admin-page-meta {
  display: grid;
  gap: 0.15rem 1.5rem;
  margin: 0;
  font-size: 0.85rem;
  text-align: right;
}

.admin-page-meta div {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.admin-page-meta dt {
  color: var(--text-muted);
}

.admin-page-meta dd {
  margin: 0;
  color: var(--text-primary);
}

.admin-page-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.admin-dashboard-main .site-card.admin-section {
  padding: 0.9rem 1.15rem;
  overflow: visible;
}

.admin-dashboard-main .admin-section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem 1rem;
}

.admin-section-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
  min-width: 0;
}

.admin-section-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.admin-dashboard-main .admin-section-toggle h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 500;
}

.admin-section-caret {
  flex: none;
  width: 0.5rem;
  height: 0.5rem;
  border-right: 1.5px solid var(--text-muted);
  border-bottom: 1.5px solid var(--text-muted);
  transform: rotate(-45deg);
  transition: transform 150ms ease;
}

.admin-section.is-open .admin-section-caret {
  transform: rotate(45deg);
}

.admin-section-state {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.admin-dashboard-main .admin-status-pill.admin-section-count {
  margin-top: 0;
}

.admin-section-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.admin-dashboard-main .admin-section-subtitle {
  margin: 0.35rem 0 0;
  max-width: 60rem;
  font-size: 0.86rem;
}

.admin-section-body {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.admin-section-body[hidden] {
  display: none;
}

.admin-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 2rem;
  margin: 0;
}

.admin-fact {
  display: grid;
  grid-template-columns: minmax(9rem, 16rem) minmax(0, 1fr);
  gap: 1rem;
  padding: 0.4rem 0;
  border-top: 1px solid var(--border);
}

.admin-fact dt {
  color: var(--text-muted);
}

.admin-fact dd {
  margin: 0;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.admin-rows {
  display: flex;
  flex-direction: column;
}

.admin-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.45rem 0;
  border-top: 1px solid var(--border);
  font-size: 0.9rem;
}

.admin-row:first-child {
  border-top: 0;
}

.admin-row--stack {
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
}

.admin-form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.6rem;
}

.admin-form-row > .form-input {
  width: auto;
  min-width: 12rem;
  flex: 1 1 12rem;
}

.admin-field {
  display: grid;
  gap: 0.25rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.admin-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem 1rem;
}

.admin-form-grid-wide {
  grid-column: 1 / -1;
}

.admin-check {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.9rem;
}

.admin-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.admin-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 0.5rem;
}

.admin-dashboard-main .homepage-button-primary,
.admin-dashboard-main .homepage-button-secondary {
  padding: 0.38rem 0.8rem;
  font-size: 0.84rem;
  white-space: nowrap;
}

.admin-dashboard-main .homepage-button-secondary.is-destructive {
  border-color: var(--error);
  color: var(--error);
}

.admin-dashboard-main .homepage-button-secondary.is-destructive:hover {
  background: var(--error);
  border-color: var(--error);
  color: #ffffff;
}

.admin-dashboard-main .homepage-button-primary.is-destructive {
  background: var(--error);
  border-color: var(--error);
}

/* A button the dashboard has locked looks locked (D-HP-ADMIN-089). */
.admin-dashboard-main .homepage-button-primary:disabled,
.admin-dashboard-main .homepage-button-secondary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Uniform grid alignment for master switches and per-unit autopilot buttons (IDD D-HP-ADMIN-056, D-HP-ADMIN-046). */
.admin-autopilot-master {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 22rem));
  gap: 0.5rem;
  align-items: stretch;
}

.admin-autopilot-master > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2.35rem;
  text-align: center;
}

.admin-autopilot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 0.5rem;
  align-items: stretch;
}

.admin-dashboard-main .admin-autopilot-unit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 2.35rem;
  text-align: left;
}

.admin-autopilot-unit-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  font-weight: 500;
}

.admin-autopilot-unit-state {
  flex: none;
  font-size: 0.78rem;
  opacity: 0.92;
  white-space: nowrap;
}

@media (max-width: 42em) {
  .admin-autopilot-master,
  .admin-autopilot-grid {
    grid-template-columns: 1fr;
  }
}

/* The data-lake autopilot toggle (IDD D-HP-ADMIN-063/066): the same geometry as every
   other action button — the state speaks through color and the section pill, never
   through size (D-HP-ADMIN-066: uniform, decent). */
.admin-dashboard-main .admin-datalake-toggle.is-on {
  background: var(--success);
  border-color: var(--success);
  color: #ffffff;
}

/* Readiness-to-train pipeline (IDD D-HP-ADMIN-067): the measured stages from storage
   to the first training run. One pill per stage, state through color alone
   (D-HP-ADMIN-066): met green, active blue with a subtle pulse, waiting neutral,
   blocked red. rem/em only (D-HP-ADMIN-046). */
.admin-readiness-summary {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.5;
}

.admin-readiness-pipeline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
}

.admin-readiness-joint {
  color: var(--text-muted);
  font-size: 0.78rem;
}

.admin-readiness-stage {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-hover);
  border-radius: 999px;
  padding: 0.22rem 0.62rem;
  background: var(--bg-secondary);
  color: var(--ink-soft);
  font-size: 0.74rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.admin-readiness-stage.is-ok {
  border-color: rgba(46, 125, 79, 0.4);
  background: rgba(46, 125, 79, 0.08);
  color: var(--success);
}

.admin-readiness-stage.is-active {
  border-color: rgba(37, 99, 235, 0.45);
  background: rgba(37, 99, 235, 0.08);
  color: #1d4ed8;
  animation: admin-readiness-pulse 2.4s ease-in-out infinite;
}

.admin-readiness-stage.is-blocked {
  border-color: rgba(192, 38, 45, 0.4);
  background: rgba(192, 38, 45, 0.07);
  color: var(--error);
}

.admin-readiness-counter {
  margin-left: auto;
  color: var(--text-secondary);
  font-size: 0.78rem;
  white-space: nowrap;
}

.admin-readiness-unblock {
  margin: 0;
  border-left: 0.2rem solid var(--accent);
  padding-left: 0.6rem;
}

@keyframes admin-readiness-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.25); }
  50% { box-shadow: 0 0 0 0.3rem rgba(37, 99, 235, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .admin-readiness-stage.is-active {
    animation: none;
  }
}

.admin-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-primary);
  font: inherit;
  text-align: left;
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 0.15em;
  cursor: pointer;
}

.admin-link:hover {
  color: var(--accent);
}

.admin-show-more {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.admin-quote {
  margin: 0;
  padding: 0.6rem 1rem;
  border-left: 3px solid var(--accent);
  font-size: 1rem;
  line-height: 1.55;
  white-space: pre-wrap;
}

.admin-dashboard-main .admin-table thead th {
  padding: 0.5rem 0.65rem;
  color: var(--text-secondary);
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}

.admin-dashboard-main .admin-table tbody td {
  padding: 0.5rem 0.65rem;
  font-size: 0.88rem;
}

.admin-dashboard-main .admin-status-pill {
  padding: 0.12rem 0.5rem;
  font-size: 0.74rem;
}

.admin-dashboard-main .admin-kpi-label {
  font-size: 0.8rem;
  letter-spacing: 0;
  text-transform: none;
}

.admin-dashboard-main .admin-inline-input {
  width: auto;
  min-width: 10rem;
}

.admin-dashboard-main .form-input {
  padding: 0.42rem 0.6rem;
  font-size: 0.88rem;
}

.admin-dashboard-main .admin-inline-actions {
  align-items: center;
}

.admin-dashboard-main .admin-attention-item {
  font-size: 0.9rem;
}

.admin-dashboard-main .admin-smtm-training-card {
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

/* The dialog over the page (IDD D-HP-ADMIN-041): fixed and centred on a dimmed
   backdrop; the written conversation and the call share it. */
.org-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(26, 26, 26, 0.45);
}

.org-dialog {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: min(44rem, 100%);
  max-height: calc(100vh - 3rem);
  padding: 1.1rem 1.25rem;
  border: 1px solid var(--border-hover);
  border-radius: var(--radius);
  background: var(--bg-card);
  color: var(--text-primary);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  outline: none;
}

.org-dialog__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.org-dialog__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.org-dialog__subtitle {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.org-dialog__close {
  flex: none;
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: transparent;
  color: var(--text-muted);
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
}

.org-dialog__close:hover {
  border-color: var(--ink);
  color: var(--text-primary);
}

.org-dialog__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 8rem;
  max-height: 50vh;
  overflow-y: auto;
  padding: 0.5rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-secondary);
}

.org-dialog__turn {
  max-width: 85%;
  padding: 0.45rem 0.65rem;
  border-radius: var(--radius);
  font-size: 0.9rem;
  white-space: pre-wrap;
}

.org-dialog__turn--person {
  align-self: flex-end;
  border: 1px solid var(--border);
  background: var(--bg-card);
}

.org-dialog__turn--bot {
  align-self: flex-start;
  background: var(--bg-hover);
}

.org-dialog__who {
  margin-bottom: 0.15rem;
  color: var(--text-muted);
  font-size: 0.74rem;
}

.org-dialog__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}

.org-dialog__form {
  flex-direction: column;
  align-items: stretch;
}

.org-dialog__form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.admin-dashboard-main .org-call__hangup,
.org-call__hangup {
  background: var(--error);
  border-color: var(--error);
  color: #ffffff;
}

.admin-dashboard-main .org-call__hangup:hover,
.org-call__hangup:hover {
  background: #a11f26;
  border-color: #a11f26;
  color: #ffffff;
}

@media (max-width: 68.75em) {
  .admin-shell {
    grid-template-columns: 1fr;
  }

  /* Under tablet width the sidebar is a bar above the page: the pages in a wrapping row, the open page's sections
     in a second row, nothing stacked into a long list. */
  .admin-sidebar {
    position: static;
    max-height: none;
    padding: 0.4rem 0 0.8rem;
    border-right: 0;
    border-bottom: 1px solid var(--border);
  }

  .admin-sidebar-head {
    margin-bottom: 0.4rem;
    padding-bottom: 0.5rem;
  }

  .admin-sidebar-group {
    margin-top: 0.4rem;
  }

  .admin-sidebar-list,
  .admin-sidebar-sublist {
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem 0.4rem;
  }

  .admin-sidebar-sublist {
    margin: 0.3rem 0 0;
    padding: 0.3rem 0 0;
    border-left: 0;
    border-top: 1px solid var(--border);
  }

  .admin-sidebar-link,
  .admin-sidebar-sublink {
    width: auto;
  }

  .admin-facts,
  .admin-form-grid,
  .admin-pair {
    grid-template-columns: 1fr;
  }

  .admin-page-meta {
    text-align: left;
  }

  .admin-page-meta div {
    justify-content: flex-start;
  }
}

/* The organisation editor as aligned rows (D-HP-ADMIN-040): a unit's head with its remove button in the right
   column, its members one per row with name, role and the remove control in fixed columns. */
.admin-org-tree { display: flex; flex-direction: column; gap: 0.75rem; }
.admin-org-unit { border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; background: var(--bg-card); }
.admin-org-unit-head { display: grid; grid-template-columns: minmax(0, 1fr) 7.5rem; align-items: center; gap: 0.75rem; padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--border); background: var(--bg-hover); font-size: 0.9rem; }
.admin-org-unit-name { display: flex; flex-direction: column; min-width: 0; }
.admin-org-unit-meta { color: var(--text-muted); font-size: 0.74rem; }
.admin-org-members { list-style: none; margin: 0; padding: 0; }
.admin-org-member { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(0, 2fr) 7.5rem; align-items: center; gap: 0.75rem; padding: 0.35rem 0.75rem; border-top: 1px solid var(--border); font-size: 0.82rem; }
.admin-org-member:first-child { border-top: 0; }
.admin-org-member-name { color: var(--ink); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.admin-org-member-role { color: var(--text-secondary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.admin-org-remove { justify-self: end; min-width: 2.5rem; padding: 0.15rem 0.6rem; font-size: 0.8rem; }

/* The sovereign LLM architecture paper (#llm, IDD D-HP-ADMIN-062): the generated scientific document in the
   look of a classic machine-learning paper — always a white page surface with near-black ink regardless of
   the dashboard theme, a centered serif title block, justified two-column body text, full-width figures and
   tables, and numbered references in smaller type. Sizes in rem/em only (D-HP-ADMIN-046). */
.llm-paper-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

/* Both strands' papers stand SIDE BY SIDE (D-HP-ADMIN-071):
   two sheets next to each other on wide screens — the any-to-any paper left, the document
   strand right — each its own full document; below the grid's minimum width they wrap,
   which is the physical bound of a phone, not a hiding mechanism. rem-only (D-HP-ADMIN-046). */
.llm-paper-duo {
  /* Three sheets in one row on a wide screen (D-HP-ADMIN-075); below the minimum they wrap. */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 30rem), 1fr));
  gap: 1.5rem;
  align-items: start;
}
.llm-paper-duo > section { min-width: 0; }

/* The implementation lifecycle strip under each paper (D-HP-ADMIN-073). */
.llm-kernel-table td, .llm-kernel-table th { font-size: 0.78rem; }
.llm-lifecycle { margin-top: 0.75rem; padding: 0.75rem; display: flex; flex-direction: column; gap: 0.6rem; }
.llm-lifecycle-head { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
.llm-lifecycle-steps { display: flex; flex-wrap: wrap; gap: 0.4rem 0.9rem; }
.llm-lifecycle-step { display: inline-flex; align-items: center; gap: 0.35rem; }
.llm-lifecycle-detail { font-size: 0.72rem; color: var(--color-text-secondary, #64748b); }
.llm-lifecycle-table td, .llm-lifecycle-table th { font-size: 0.72rem; }

.llm-paper {
  max-width: 52rem;
  width: 100%;
  margin: 0 auto;
  padding: 3.5rem 4.5rem;
  background: #ffffff;
  color: #1a1a1a;
  border: 0.0625rem solid #d0d0d0;
  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.12);
  font-family: Georgia, Cambria, 'Times New Roman', Times, serif;
  font-size: 0.9375rem;
  line-height: 1.55;
}

.llm-paper a {
  color: #1a1a1a;
  text-decoration: underline;
}

.llm-paper-title {
  font-size: 1.65rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.25;
  margin: 0 0 1.75rem;
  letter-spacing: -0.01em;
}

.llm-paper-authors {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem 3rem;
  text-align: center;
  margin-bottom: 1rem;
}

.llm-paper-author-name {
  font-weight: 700;
  font-size: 0.95rem;
}

.llm-paper-author-affiliation {
  font-size: 0.85rem;
}

.llm-paper-dateline {
  text-align: center;
  font-size: 0.85rem;
  margin-bottom: 2rem;
}

.llm-paper-abstract-heading {
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
}

.llm-paper-abstract {
  margin: 0 2.5rem 2rem;
  font-size: 0.9rem;
  text-align: justify;
  hyphens: auto;
}

.llm-paper-abstract p {
  margin: 0 0 0.6rem;
}

.llm-paper-section-heading {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 1.9rem 0 0.7rem;
}

.llm-paper-secnum {
  margin-right: 0.75rem;
}

.llm-paper-body p {
  margin: 0 0 0.75rem;
  text-align: justify;
  hyphens: auto;
}

.llm-paper-figure {
  margin: 1.5rem 0 1.75rem;
  text-align: center;
}

.llm-paper-figure-caption {
  font-size: 0.82rem;
  font-style: italic;
  margin-top: 0.6rem;
}

.llm-paper-table-block {
  margin: 1.4rem 0 1.6rem;
}

.llm-paper-tabcaption {
  text-align: center;
  font-size: 0.82rem;
  font-style: italic;
  margin-bottom: 0.45rem;
}

.llm-paper-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
  border-top: 0.125rem solid #1a1a1a;
  border-bottom: 0.125rem solid #1a1a1a;
}

.llm-paper-table thead th {
  border-bottom: 0.0625rem solid #1a1a1a;
  text-align: left;
  font-weight: 700;
  padding: 0.35rem 0.6rem;
}

.llm-paper-table td {
  padding: 0.32rem 0.6rem;
  vertical-align: top;
}

.llm-paper-table th.llm-paper-num,
.llm-paper-table td.llm-paper-num {
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.llm-paper-totalrow td {
  border-top: 0.0625rem solid #1a1a1a;
  font-weight: 700;
}

.llm-paper-strong {
  font-weight: 700;
}

.llm-paper-table .llm-paper-sub {
  display: block;
  font-size: 0.78rem;
  color: #444444;
  font-style: italic;
  font-weight: 400;
  margin-top: 0.15rem;
}

.llm-paper-formula {
  text-align: center;
  font-size: 0.82rem;
  font-style: italic;
  margin: -0.8rem 0 1.4rem;
}

.llm-paper-statusnote {
  font-size: 0.86rem;
  font-style: italic;
  color: #333333;
  margin: 0.6rem 0 0.9rem;
  text-align: justify;
}

.llm-paper-note {
  text-align: center;
  font-size: 0.8rem;
  font-style: italic;
  color: #555555;
  margin: 1.5rem 0 0.5rem;
}

.llm-paper-sup {
  font-size: 0.7em;
}

.llm-paper-ref-link {
  background: none;
  border: none;
  padding: 0;
  color: #1a1a1a;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
}

.llm-paper-references {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.84rem;
}

.llm-paper-references li {
  margin: 0 0 0.5rem;
  padding-left: 1.6rem;
  text-indent: -1.6rem;
}

.llm-paper-empty {
  color: #444444;
  font-size: 0.85rem;
  font-style: italic;
}

.llm-paper-provenance {
  text-align: center;
  font-size: 0.78rem;
  color: #666666;
  margin-top: 2.5rem;
  border-top: 0.0625rem solid #d0d0d0;
  padding-top: 0.8rem;
}

@media (max-width: 48em) {
  .llm-paper {
    padding: 2rem 1.1rem;
  }

  .llm-paper-abstract {
    margin: 0 0.75rem 1.5rem;
  }
}

/* PDF export of the paper (D-HP-ADMIN-065/069): the paper page toggles body.llm-paper-printing on
   beforeprint/afterprint, so these rules apply only when the paper is what is being printed and every
   other page of the site prints normally. The paper stays IN FLOW — its full height defines the page
   count; the first export positioned it absolutely over a two-page document and Chromium clipped the
   print after page two. Chrome is hidden with display:none, page margins come from @page. */
@media print {
  body.llm-paper-printing * {
    visibility: hidden;
  }

  body.llm-paper-printing .llm-paper,
  body.llm-paper-printing .llm-paper * {
    visibility: visible;
  }

  body.llm-paper-printing .site-nav,
  body.llm-paper-printing .admin-sidebar,
  body.llm-paper-printing .site-footer,
  body.llm-paper-printing .llm-paper-toolbar {
    display: none;
  }

  body.llm-paper-printing .admin-shell {
    display: block;
  }

  body.llm-paper-printing {
    background: #ffffff;
  }

  body.llm-paper-printing .site-main {
    width: 100%;
    max-width: none;
    padding: 0;
  }

  body.llm-paper-printing .llm-paper {
    position: static;
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;
    border: none;
    box-shadow: none;
    background: #ffffff;
    color: #000000;
  }

  body.llm-paper-printing .llm-paper-table-block,
  body.llm-paper-printing .llm-paper-figure {
    page-break-inside: avoid;
    -moz-column-break-inside: avoid;
         break-inside: avoid;
  }

  body.llm-paper-printing .llm-paper-table tr {
    page-break-inside: avoid;
    -moz-column-break-inside: avoid;
         break-inside: avoid;
  }

  body.llm-paper-printing .llm-paper a,
  body.llm-paper-printing .llm-paper-ref-link {
    color: #000000;
  }
}

@page {
  margin: 1.5cm 1.8cm;
}

/* The paper's chain steps and kernel table (D-HP-ADMIN-076). */
/* Every step names itself ("Step 3b — …"), so the list carries no markers of its own (D-VCORE-369). */
.llm-paper-steps { list-style: none; padding-left: 0; margin: 0.4rem 0 0.8rem; }
.llm-paper-steps li { margin: 0 0 0.55rem; line-height: 1.5; }
.llm-paper-kernelcell { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.78em; word-break: break-word; }
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.hover\\:bg-bg-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 244 / var(--tw-bg-opacity, 1));
}
.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 640px) {

  .max-sm\\:hyphens-auto {
    hyphens: auto;
  }

  .max-sm\\:break-words {
    overflow-wrap: break-word;
  }

  .max-sm\\:\\[-webkit-hyphenate-limit-after\\:5\\] {
    -webkit-hyphenate-limit-after: 5;
  }

  .max-sm\\:\\[-webkit-hyphenate-limit-before\\:5\\] {
    -webkit-hyphenate-limit-before: 5;
  }

  .max-sm\\:\\[hyphenate-limit-chars\\:12_5_5\\] {
    hyphenate-limit-chars: 12 5 5;
  }
}
@media (min-width: 640px) {

  .sm\\:min-w-\\[200px\\] {
    min-width: 200px;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }
}
@media (min-width: 768px) {

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:h-\\[300px\\] {
    height: 300px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[10rem_1fr\\] {
    grid-template-columns: 10rem 1fr;
  }

  .md\\:grid-cols-\\[180px_1fr\\] {
    grid-template-columns: 180px 1fr;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-7 {
    padding: 1.75rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .md\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .md\\:pb-16 {
    padding-bottom: 4rem;
  }

  .md\\:pb-20 {
    padding-bottom: 5rem;
  }

  .md\\:pt-24 {
    padding-top: 6rem;
  }

  .md\\:pt-36 {
    padding-top: 9rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[0\\.9fr_1\\.1fr\\] {
    grid-template-columns: 0.9fr 1.1fr;
  }

  .lg\\:grid-cols-\\[1fr_0\\.78fr\\] {
    grid-template-columns: 1fr 0.78fr;
  }

  .lg\\:grid-cols-\\[1fr_0\\.82fr\\] {
    grid-template-columns: 1fr 0.82fr;
  }

  .lg\\:grid-cols-\\[240px_1fr\\] {
    grid-template-columns: 240px 1fr;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;;2CAI2C;AAC3C;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;;EAEf,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;;EAE7B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;;EAEnB,0BAA0B;EAC1B,iCAAiC;EACjC,0BAA0B;EAC1B,qBAAqB;;EAErB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;;EAEnB,wJAAwJ;AAC1J;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAFA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;AACtB;;AAEA;yEACyE;AACzE,cAAc,2BAA2B,EAAE;AAC3C;iBACiB,2BAA2B,EAAE;AAC9C,eAAe,2BAA2B,EAAE;AAC5C,yBAAyB,kCAAkC,EAAE;AAC7D,cAAc,uCAAuC,EAAE;AACvD,oBAAoB,0CAA0C,EAAE;AAChE,mBAAmB,2CAA2C,EAAE;AAChE,cAAc,2CAA2C,EAAE;AAC3D,cAAc,2CAA2C,EAAE;AAC3D,YAAY,yCAAyC,EAAE;AACvD,WAAW,wCAAwC,EAAE;AACrD,gBAAgB,gDAAgD,EAAE;AAClE,cAAc,2CAA2C,EAAE;AAC3D,mBAAmB,gDAAgD,EAAE;AACrE,cAAc,2CAA2C,EAAE;AAC3D,eAAe,4CAA4C,EAAE;AAC7D,mBAAmB,gDAAgD,EAAE;AACrE;EACE,kDAAkD;AACpD;AACA;EACE,oDAAoD;AACtD;AACA,gBAAgB,4BAA4B,EAAE;AAC9C;qBACqB,kCAAkC,EAAE;AACzD,gBAAgB,gCAAgC,EAAE;AAClD,gBAAgB,gCAAgC,EAAE;AAClD,cAAc,8BAA8B,EAAE;AAC9C,aAAa,6BAA6B,EAAE;AAC5C,kBAAkB,kCAAkC,EAAE;AACtD,qBAAqB,qCAAqC,EAAE;AAC5D,uBAAuB,uCAAuC,EAAE;AAChE,mBAAmB,mCAAmC,EAAE;AACxD,mBAAmB,mCAAmC,EAAE;AACxD,gBAAgB,gCAAgC,EAAE;AAClD,kBAAkB,mCAAmC,EAAE;AACvD,6BAA6B,4CAA4C,EAAE;AAC3E,iBAAiB,sCAAsC,EAAE;AACzD,uBAAuB,4CAA4C,EAAE;AACrE,2BAA2B,sCAAsC,EAAE;;AAEnE;;;;;EAKE,uCAAuC;AACzC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,0BAA0B;AAC5B;;AAEA;;;;EAIE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,+CAA+C;EAC/C,cAAc;EACd,4DAA4D;AAC9D;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;EAGE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;gHACgH;AAChH;EACE,wEAAwE;AAC1E;;AAEA,+FAA+F;AAC/F;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;EAC/B,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;EAaE,+CAA+C;EAC/C,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;;EAGE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,sFAAsF;AACxF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;mEAKmE;AACnE;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;wGACwG;AACxG;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;kDACkD;AAClD;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd;;AAEA,yGAAyG;AACzG;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,mDAAmD;EACnD,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAc;OAAd,cAAc;EACd,qBAAgB;OAAhB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,+BAAmB;OAAnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;oCACoC;AACpC;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;0BAC0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,8GAA8G;AAC9G;EACE,cAAc;EACd,SAAS;EACT,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;EAC1B,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,mHAAmH;AACnH;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;;8DAE8D;AAC9D;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,wCAAwC,UAAU,EAAE;AACpD,yCAAyC,SAAS,EAAE;AACpD,4CAA4C,SAAS,EAAE;AACvD,uCAAuC,UAAU,EAAE;AACnD,0CAA0C,UAAU,EAAE;AACtD,4CAA4C,SAAS,EAAE;AACvD,yCAAyC,UAAU,EAAE;;AAErD,sCAAsC,UAAU,EAAE;AAClD,wCAAwC,UAAU,EAAE;AACpD,wCAAwC,UAAU,EAAE;AACpD,yCAAyC,UAAU,EAAE;;AAErD;+DAC+D;AAC/D;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;AACA,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,UAAU,EAAE;AAChD,uCAAuC,UAAU,EAAE;AACnD,4CAA4C,UAAU,EAAE;;AAExD,yCAAyC,UAAU,EAAE;AACrD,uCAAuC,UAAU,EAAE;AACnD,sCAAsC,UAAU,EAAE;AAClD,uCAAuC,UAAU,EAAE;;AAEnD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;gDACgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;iDACiD;AACjD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,sFAAsF;AACxF;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;;;;EAIE,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;;EAGE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB,gDAAgD,EAAE;AAClE;kBACkB,gDAAgD,EAAE;AACpE;kBACkB,gDAAgD,EAAE;;AAEpE;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kFAAkF;AACpF;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAFA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;;EAEE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;;EAIE,sCAAsC;AACxC;;AAEA;;;;EAIE,uCAAuC;EACvC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;IAGE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;IAcE,kDAAkD;EACpD;;EAEA;;YAEU;EACV;;;IAGE,mCAAmC;EACrC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB;gEAC4D;IAE5D,aAAa;IACb,6BAA6B;IAC7B,iCAAiC;IACjC,gCAAgC;EAClC;;EAEA;gHAC8G;EAC9G;IACE,YAAY;EACd;;EAEA;kHACgH;EAChH;IACE,uCAAuC;EACzC;;EAEA;6CAC2C;EAC3C;IACE,eAAe;EACjB;AACF;;AAEA;;;;8EAI8E;AAC9E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;mDACmD;AACnD;kEACkE;AAClE;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;sDACsD;AACtD;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE,+BAA+B,WAAW,EAAE;AAC5C,+BAA+B,WAAW,EAAE;AAC5C,+BAA+B,WAAW,EAAE;AAC5C,+BAA+B,WAAW,EAAE;AAC5C,8BAA8B,kBAAkB,EAAE;AAClD,8BAA8B,kBAAkB,EAAE;;AAElD;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA,6EAA6E;AAC7E,iDAAiD,YAAY,EAAE,kBAAkB,EAAE;AACnF,+CAA+C,YAAY,EAAE;AAC7D,uDAAuD,WAAW,EAAE;AACpE,uDAAuD,WAAW,EAAE;AACpE,yDAAyD,YAAY,EAAE;AACvE,uDAAuD,WAAW,EAAE,sBAAsB,EAAE;AAC5F,uDAAuD,WAAW,EAAE;AACpE,kDAAkD,YAAY,EAAE;AAChE,yDAAyD,YAAY,EAAE;AACvE,wDAAwD,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC7G,6CAA6C,WAAW,EAAE;AAC1D,4CAA4C,kBAAkB,EAAE;AAChE,yCAAyC,uBAAuB,EAAE;AAClE,yCAAyC,kBAAkB,EAAE;AAC7D,0CAA0C,YAAY,EAAE;AACxD,0CAA0C,WAAW,EAAE,kBAAkB,EAAE;;AAE3E;;;;yDAIyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;qDACqD;AACrD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;mEACmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;AAEF;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,8BAA2B;KAA3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,6BAA6B;EAC7B,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,4GAA4G;AAC5G;EACE,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;AAClB;;AAEA,uGAAuG;AACvG;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;EACtC,gEAAgE;EAChE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;wDACwD;AACxD;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;mCACmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;oCACoC;AACpC;EACE,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;;;;;;;;;IASE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA,oDAAoD;AACpD;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;uGACuG;AACvG;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,sBAAmB;OAAnB,mBAAmB;IACnB,+BAA4B;OAA5B,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;sEAEoE;EACpE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;kEAGkE;AAClE;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gEAAgE;EAChE,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,+BAA+B;EAC/B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;uEACuE;AACvE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;sEACsE;AACtE;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAAwC;OAAxC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,2DAA2D;EAC3D,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;0GAE0G;AAC1G;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;EAIE,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,+CAA+C;EAC/C,yCAAyC;EACzC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;8CAC8C;AAC9C;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;EACE,yDAAyD;AAC3D;;AAEA;oFACoF;AACpF;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oCAAoC;EACpC,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;uEACuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;0DAC0D;AAC1D;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;4EAC4E;AAC5E;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;;8EAK8E;AAC9E;EACE,kBAAkB;AACpB;;AAEA;wCACwC;AACxC;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,2CAA2C;EAC3C,4CAA4C;EAC5C,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,qEAAqE;AACrE;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oHAAoH;AACpH;EACE,aAAa;EACb,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;oDAEoD;AACpD;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;;+CAG+C;AAC/C;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;8DAC8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;yDACuD;EACvD;IACE,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,mCAAmC;EACrC;;EAEA;;IAEE,WAAW;EACb;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;6FAC6F;AAC7F,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACvE,kBAAkB,+BAA+B,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/H,uBAAuB,aAAa,EAAE,4CAA4C,EAAE,mBAAmB,EAAE,YAAY,EAAE,uBAAuB,EAAE,sCAAsC,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;AACxO,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AAC5E,uBAAuB,wBAAwB,EAAE,kBAAkB,EAAE;AACrE,qBAAqB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AAC9D,oBAAoB,aAAa,EAAE,6DAA6D,EAAE,mBAAmB,EAAE,YAAY,EAAE,wBAAwB,EAAE,mCAAmC,EAAE,kBAAkB,EAAE;AACxN,gCAAgC,aAAa,EAAE;AAC/C,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5G,yBAAyB,4BAA4B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvH,oBAAoB,iBAAiB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;;AAEtG;;;4FAG4F;AAC5F;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;+FAG+F;AAC/F;EACE,4FAA4F;EAC5F,aAAa;EACb,sEAAsE;EACtE,WAAW;EACX,kBAAkB;AACpB;AACA,2BAA2B,YAAY,EAAE;;AAEzC,0EAA0E;AAC1E,6CAA6C,kBAAkB,EAAE;AACjE,iBAAiB,mBAAmB,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC5G,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE;AACxF,uBAAuB,aAAa,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC3E,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC/E,wBAAwB,kBAAkB,EAAE,2CAA2C,EAAE;AACzF,mDAAmD,kBAAkB,EAAE;;AAEvE;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,kDAAkD;EAClD,8DAA8D;EAC9D,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;4FAI4F;AAC5F;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,wBAAwB;IACxB,+BAAmB;SAAnB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,+BAAmB;SAAnB,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D,sGAAsG;AACtG,mBAAmB,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC/E,sBAAsB,mBAAmB,EAAE,gBAAgB,EAAE;AAC7D,wBAAwB,2DAA2D,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AAzwJhI;EAAA;AA0wJA;AA1wJA;EAAA,kBA0wJA;EA1wJA;AA0wJA;AA1wJA;EAAA,oBA0wJA;EA1wJA;AA0wJA;AA1wJA;;EAAA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;AAAA;AA1wJA;;EAAA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;AAAA;AA1wJA;;EAAA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA,iBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA,iBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,mBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,kBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,eA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,kBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,iBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,eA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,mBA0wJA;IA1wJA;EA0wJA;;EA1wJA;IAAA,kBA0wJA;IA1wJA;EA0wJA;AAAA;AA1wJA;;EAAA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA;EA0wJA;;EA1wJA;IAAA,kBA0wJA;IA1wJA;EA0wJA;AAAA;AA1wJA;;EAAA;IAAA;EA0wJA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Corporate design of pAIoneer Labs GmbH, the same as the company's letters:\n   white ground, Open Sans in its light weight, near-black text, thin rules and\n   magenta #FF0088 as the one accent colour. Magenta marks the letters \"AI\" of\n   the company name and small details (link underlines, markers, focus); text,\n   rules and buttons stay black and grey. */\n:root {\n  --accent: #ff0088;\n  --accent-strong: #d10070;\n  --ink: #1a1a1a;\n  --ink-soft: #333333;\n  --muted: #6b6b70;\n  --logo-grey: #585858;\n  --rule: #1a1a1a;\n\n  --primary: var(--accent);\n  --primary-dark: #ffffff;\n  --primary-light: var(--logo-grey);\n  --success: #2e7d4f;\n  --warning: #a86200;\n  --error: #c0262d;\n  --info: #4d5966;\n  --secondary: var(--logo-grey);\n\n  --bg-main: #ffffff;\n  --bg-secondary: #f6f6f7;\n  --bg-card: #ffffff;\n  --bg-hover: #f2f2f4;\n\n  --text-primary: var(--ink);\n  --text-secondary: var(--ink-soft);\n  --text-muted: var(--muted);\n  --text-white: #ffffff;\n\n  --border: #e2e2e6;\n  --border-hover: #b8b8be;\n  --line-strong: var(--rule);\n  --shadow: none;\n  --radius: 2px;\n  --container: 1248px;\n\n  --font-sans: \"Open Sans Variable\", \"Open Sans\", \"Hiragino Sans\", \"Hiragino Kaku Gothic ProN\", \"Noto Sans JP\", \"Yu Gothic\", \"Segoe UI\", Arial, sans-serif;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nhtml[lang=\"ja\"] body {\n  font-weight: 400;\n}\n\nbody {\n  margin: 0;\n  min-width: 320px;\n  background: var(--bg-main);\n  color: var(--text-primary);\n  font-family: var(--font-sans);\n  font-weight: 300;\n  font-optical-sizing: auto;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: inherit;\n}\n\nstrong,\nb {\n  font-weight: 600;\n}\n\na {\n  color: inherit;\n}\n\nul,\nol {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\nli::marker {\n  content: \"\";\n}\n\n::selection {\n  background: rgba(255, 0, 136, 0.16);\n}\n\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-main);\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c9c9ce;\n  border: 2px solid var(--bg-main);\n  border-radius: 999px;\n}\n\n/* The letters \"AI\" of pAIoneer, wherever the name is written. */\n.brand-ai {\n  color: var(--accent);\n}\n\n/* The older pages mark headings with Tailwind weights; in the light design a\n   heading is set in the regular weight and emphasis in the medium one. */\n.font-black { font-weight: 400 !important; }\n.font-bold,\n.font-semibold { font-weight: 500 !important; }\n.font-medium { font-weight: 400 !important; }\n[class*=\"tracking-[-\"] { letter-spacing: -0.01em !important; }\n.bg-primary { background-color: var(--ink) !important; }\n.bg-primary-light { background-color: var(--accent) !important; }\n.bg-primary-dark { background-color: var(--bg-main) !important; }\n.bg-success { background-color: var(--success) !important; }\n.bg-warning { background-color: var(--warning) !important; }\n.bg-error { background-color: var(--error) !important; }\n.bg-info { background-color: var(--info) !important; }\n.bg-secondary { background-color: var(--bg-secondary) !important; }\n.bg-bg-main { background-color: var(--bg-main) !important; }\n.bg-bg-secondary { background-color: var(--bg-secondary) !important; }\n.bg-bg-card { background-color: var(--bg-card) !important; }\n.bg-bg-hover { background-color: var(--bg-hover) !important; }\n.bg-text-primary { background-color: var(--bg-secondary) !important; }\n[class*=\"bg-text-primary/\"] {\n  background-color: rgba(26, 26, 26, 0.4) !important;\n}\n[class*=\"bg-primary/\"] {\n  background-color: rgba(255, 0, 136, 0.06) !important;\n}\n.text-primary { color: var(--ink) !important; }\n.text-primary-light,\n.text-primary-dark { color: var(--logo-grey) !important; }\n.text-success { color: var(--success) !important; }\n.text-warning { color: var(--warning) !important; }\n.text-error { color: var(--error) !important; }\n.text-info { color: var(--info) !important; }\n.text-secondary { color: var(--logo-grey) !important; }\n.text-text-primary { color: var(--text-primary) !important; }\n.text-text-secondary { color: var(--text-secondary) !important; }\n.text-text-muted { color: var(--text-muted) !important; }\n.text-text-white { color: var(--text-white) !important; }\n.text-bg-main { color: var(--bg-main) !important; }\n.border-primary { border-color: var(--ink) !important; }\n[class*=\"border-primary/\"] { border-color: var(--border-hover) !important; }\n.border-border { border-color: var(--border) !important; }\n.border-border-hover { border-color: var(--border-hover) !important; }\n.border-text-primary\\/10 { border-color: var(--border) !important; }\n\n.rounded-full,\n.rounded-2xl,\n.rounded-xl,\n.rounded-lg,\n.rounded-sm {\n  border-radius: var(--radius) !important;\n}\n\n.space-y-2 > :not([hidden]) ~ :not([hidden]),\n.space-y-3 > :not([hidden]) ~ :not([hidden]),\n.space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n}\n\n.bg-gradient-primary,\n.bg-gradient-success,\n.bg-gradient-warning,\n.bg-gradient-error,\n.bg-gradient-info,\n.bg-gradient-business,\n.bg-gradient-hero,\n.bg-gradient-card {\n  background: var(--bg-card);\n}\n\n.text-gradient-primary,\n.text-gradient-success,\n.text-glow-primary,\n.text-glow-business {\n  color: var(--ink);\n  text-shadow: none;\n}\n\n.site-page {\n  min-height: 100vh;\n  background: transparent;\n  color: var(--text-primary);\n}\n\n.site-main,\n.signal-home {\n  width: min(var(--container), calc(100% - 2rem));\n  margin: 0 auto;\n  padding: clamp(5.5rem, 9vw, 7rem) 0 clamp(3.5rem, 7vw, 5rem);\n}\n\n.site-hero,\n.signal-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(18rem, 0.72fr);\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: end;\n  padding: clamp(2.4rem, 5vw, 4.8rem) 0;\n  border-bottom: 1px solid var(--rule);\n}\n\n.site-hero--single,\n.signal-hero {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.site-hero__copy,\n.signal-hero-main {\n  max-width: 50rem;\n}\n\n.site-hero h1,\n.signal-hero h1,\n.site-title {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(2.3rem, 4.4vw, 4rem);\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  line-height: 1.08;\n}\n\n.site-lead,\n.signal-claim {\n  max-width: 44rem;\n  margin: 1.1rem 0 0;\n  color: var(--ink-soft);\n  font-size: clamp(1.06rem, 1.4vw, 1.28rem);\n  font-weight: 300;\n  line-height: 1.55;\n}\n\n.site-copy,\n.signal-intro {\n  max-width: 50rem;\n  margin: 1rem 0 0;\n  color: var(--ink-soft);\n  font-size: 1rem;\n  line-height: 1.75;\n}\n\n/* D-HP-SITE-032: a page head built outside the shared page frame starts at the same height as the shared one\n   (the page frame's top padding plus the head's own) and keeps its title, lead and copy in the shared styles. */\n.page-head {\n  padding-top: calc(clamp(5.5rem, 9vw, 7rem) + clamp(2.4rem, 5vw, 4.8rem));\n}\n\n/* its kicker is a block of its own, so it starts at the head's top instead of on a text line */\n.page-head .editorial-kicker {\n  display: flex;\n}\n\n.page-head .site-title + .site-lead {\n  margin-top: 1.1rem;\n}\n\n.page-head__action {\n  margin-top: 1.75rem;\n}\n\n.editorial-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin: 0;\n  color: var(--logo-grey);\n  font-size: 0.72rem;\n  font-weight: 400;\n  letter-spacing: 0.2em;\n  line-height: 1.4;\n  text-transform: uppercase;\n}\n\n.editorial-kicker:empty {\n  display: none;\n}\n\n.editorial-kicker::before {\n  content: \"\";\n  width: 1.6rem;\n  height: 1px;\n  background: var(--accent);\n}\n\n.homepage-section,\n.site-section,\n.signal-section {\n  padding: clamp(2.4rem, 4.4vw, 4rem) 0;\n}\n\n.homepage-section + .homepage-section,\n.site-section + .site-section {\n  border-top: 1px solid var(--border);\n}\n\n.homepage-muted-panel,\n.site-section--muted {\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n}\n\n.site-section__inner,\n.homepage-section > .max-w-7xl,\n.homepage-section > .max-w-6xl,\n.homepage-section > .max-w-4xl,\n.homepage-section > .max-w-3xl,\n.homepage-muted-panel > .max-w-7xl,\n.homepage-muted-panel > .max-w-6xl,\n.homepage-muted-panel > .max-w-4xl,\n.homepage-muted-panel > .max-w-3xl,\nsection > .max-w-7xl,\nsection > .max-w-6xl,\nsection > .max-w-4xl,\nsection > .max-w-3xl {\n  width: min(var(--container), calc(100% - 2rem));\n  max-width: var(--container) !important;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.signal-section-header,\n.site-section-head {\n  display: grid;\n  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: center;\n  margin-bottom: clamp(1.15rem, 3vw, 2rem);\n}\n\n.signal-section-header h2,\n.signal-contact h2,\n.site-section-head h2,\n.site-heading {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.55rem, 2.5vw, 2.3rem);\n  font-weight: 300;\n  letter-spacing: -0.015em;\n  line-height: 1.15;\n}\n\n.signal-section-header p,\n.signal-contact p,\n.site-section-head p {\n  margin: 0;\n  color: var(--ink-soft);\n  line-height: 1.72;\n}\n\n.homepage-card,\n.card-base,\n.card-professional,\n.card-business-primary,\n.card-business-info,\n.card-business-success,\n.site-card,\n.site-panel {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.card-hover,\n.theme-transition {\n  transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;\n}\n\n.admin-dashboard-main {\n  width: min(1680px, calc(100% - 2rem));\n}\n\n.admin-hero-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: clamp(1.35rem, 2vw, 1.8rem);\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  line-height: 1.1;\n}\n\n.admin-kpi-label {\n  color: var(--text-muted);\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.admin-smtm-panel {\n  overflow: visible;\n}\n\n.admin-smtm-status-meta {\n  min-width: 14rem;\n  text-align: right;\n}\n\n.admin-smtm-filter-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.admin-status-pill {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  border: 1px solid var(--border-hover);\n  border-radius: 999px;\n  padding: 0.18rem 0.58rem;\n  background: var(--bg-secondary);\n  color: var(--ink-soft);\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.admin-status-pill.is-ok {\n  border-color: rgba(46, 125, 79, 0.4);\n  background: rgba(46, 125, 79, 0.08);\n  color: var(--success);\n}\n\n.admin-status-pill.is-warning {\n  border-color: rgba(168, 98, 0, 0.42);\n  background: rgba(168, 98, 0, 0.08);\n  color: var(--warning);\n}\n\n.admin-status-pill.is-missing {\n  border-color: rgba(192, 38, 45, 0.4);\n  background: rgba(192, 38, 45, 0.07);\n  color: var(--error);\n}\n\n.admin-status-pill.is-neutral {\n  margin-top: 0.55rem;\n}\n\n.admin-smtm-frame-metric {\n  display: grid;\n  gap: 0.35rem;\n  min-width: 12rem;\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.admin-smtm-issue-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.admin-smtm-status-body-scroll {\n  display: grid;\n  gap: 0.85rem;\n  max-height: 74vh;\n  overflow: auto;\n  padding-right: 0.25rem;\n}\n\n.admin-smtm-status-table-shell {\n  overflow: hidden;\n}\n\n.admin-smtm-status-table-scroll {\n  max-height: 42vh;\n  overflow: auto;\n}\n\n.admin-smtm-training-workbench {\n  display: grid;\n  grid-template-columns: minmax(18rem, 24rem) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: stretch;\n}\n\n.admin-smtm-training-list-panel,\n.admin-smtm-training-detail-panel {\n  min-height: 0;\n}\n\n.admin-smtm-training-list-scroll,\n.admin-smtm-training-detail-scroll {\n  display: grid;\n  gap: 0.85rem;\n  max-height: 70vh;\n  overflow: auto;\n  padding-right: 0.25rem;\n}\n\n.admin-smtm-training-list-item {\n  display: grid;\n  gap: 0.45rem;\n  width: 100%;\n  padding: 0.95rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  text-align: left;\n  transition: border-color 180ms ease, background-color 180ms ease;\n}\n\n.admin-smtm-training-list-item:hover,\n.admin-smtm-training-list-item.active {\n  border-color: var(--ink);\n  background: var(--bg-hover);\n}\n\n.admin-smtm-training-list-head,\n.admin-smtm-training-detail-header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 0.85rem;\n}\n\n.admin-smtm-training-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.85rem;\n}\n\n.admin-smtm-training-card {\n  display: grid;\n  gap: 0.75rem;\n  align-content: start;\n}\n\n.admin-smtm-training-card-tall {\n  min-height: 16rem;\n}\n\n.admin-smtm-training-card-wide {\n  grid-column: span 2;\n}\n\n.admin-smtm-training-detail-list {\n  display: grid;\n  gap: 0.55rem;\n  max-height: 14rem;\n  overflow: auto;\n}\n\n.admin-smtm-training-detail-row {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.55rem 0;\n  border-top: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.86rem;\n}\n\n.admin-smtm-training-detail-row:first-child {\n  border-top: 0;\n  padding-top: 0;\n}\n\n.admin-panel {\n  overflow: hidden;\n}\n\n.admin-section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  gap: 1rem;\n}\n\n.admin-azurite-files {\n  display: grid;\n  gap: 0.45rem;\n  min-width: 14rem;\n}\n\n.admin-azurite-file {\n  width: 100%;\n  justify-content: space-between;\n  font-size: 0.78rem;\n}\n\n.admin-meta-list {\n  padding: 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-hover);\n}\n\n.admin-table-shell {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n  background: var(--bg-card);\n}\n\n.admin-table-scroll {\n  overflow: auto;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1280px;\n}\n\n.admin-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0.85rem 0.9rem;\n  text-align: left;\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n\n.admin-table tbody td {\n  padding: 0.85rem 0.9rem;\n  border-top: 1px solid var(--border);\n  color: var(--text-secondary);\n  vertical-align: top;\n}\n\n.admin-table tbody tr:hover {\n  background: var(--bg-hover);\n}\n\n/* The organisation chart of the Veridion organisation panel, a section of its own: the human\n   decision makers on top, the positions outside the areas below them, the positions in their areas,\n   the agents working on their behalf (dashed), the connected systems and the company spaces. Areas\n   take as many columns as they have positions (two per column) and wrap by the width available, so\n   no node shrinks below a readable width. Built from the theme tokens: white ground, thin rules,\n   magenta only as the small marker of a state that needs a look. */\n.admin-dashboard-main .site-card.org-chart-card {\n  padding: 1.25rem 1.5rem 1.5rem;\n}\n\n.org-chart {\n  display: grid;\n  margin-top: 0.75rem;\n}\n\n.org-chart__tier {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.org-chart__tier > .org-node {\n  width: min(100%, 34rem);\n}\n\n.org-chart__link {\n  justify-self: center;\n  width: 1px;\n  height: 1.25rem;\n  background: var(--line-strong);\n}\n\n.org-chart__areas {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));\n  gap: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--line-strong);\n}\n\n.org-chart__area {\n  display: grid;\n  gap: 0.6rem;\n  align-content: start;\n  min-width: 0;\n}\n\n.org-chart__area-nodes {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.org-chart__label,\n.org-chart__area-name,\n.org-chart__band-name {\n  font-size: clamp(0.68rem, 0.6rem + 0.2vw, 0.82rem);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.org-chart__area-name {\n  padding-bottom: 0.35rem;\n  border-bottom: 2px solid var(--line-strong);\n}\n\n.org-chart__band {\n  display: grid;\n  gap: 0.75rem;\n  margin-top: 1.75rem;\n  padding-top: 1rem;\n  border-top: 1px dashed var(--border-hover);\n}\n\n.org-chart__band--plain {\n  border-top: 1px solid var(--border);\n}\n\n/* Organigram-First (IDD D-HP-ADMIN-042): the executive layer over the business units, each a column; a unit or a\n   colleague on standby is dimmed; badges name the thread prefix, the runtime, the model and the lead. */\n.org-chart__exec {\n  display: grid;\n  gap: 0.5rem;\n  justify-items: center;\n  width: 100%;\n}\n\n.org-chart__tier--exec {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n  width: min(100%, 66rem);\n  margin: 0 auto;\n}\n\n@media (max-width: 48em) {\n  .org-chart__tier--exec {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.org-chart__tier--exec > .org-node {\n  width: auto;\n}\n\n.org-chart__label--units {\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--line-strong);\n}\n\n.org-chart__units {\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n  gap: 1rem;\n  align-items: stretch;\n  padding-top: 0.75rem;\n  border-top: 0;\n}\n\n/* A unit is one column with fixed rows (name, mission, the lead, who supports it, the switch), so the columns line up\n   across the row whatever the length of a text. */\n.org-chart__unit {\n  grid-template-rows: auto auto auto 1fr auto;\n  gap: 0.6rem;\n  height: 100%;\n}\n\n/* The lead's card keeps its own height; the column's free space stays below it, never inside the card. */\n.org-chart__unit .org-chart__area-nodes {\n  align-content: start;\n}\n\n.org-chart__unit .org-chart__area-nodes > .org-node {\n  height: auto;\n}\n\n.org-chart__unit--standby {\n  opacity: 0.6;\n}\n\n.org-chart__unit .org-chart__area-name {\n  display: grid;\n  gap: 0.35rem;\n  align-content: start;\n  min-height: 3.6rem;\n}\n\n.org-chart__area-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  line-height: 1.3;\n}\n\n.org-chart__area-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.org-chart__mission {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: clamp(0.78rem, 0.7rem + 0.2vw, 0.9rem);\n  line-height: 1.45;\n}\n\n/* The members of a unit after its lead: every supporting colleague as a small card. */\n.org-chart__members {\n  display: grid;\n  gap: 0.5rem;\n  align-content: start;\n}\n\n.org-chart__members-label {\n  font-size: clamp(0.64rem, 0.56rem + 0.2vw, 0.78rem);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.org-chart__mission {\n  -webkit-line-clamp: 3;\n  min-height: calc(1.45em * 3);\n}\n\n.org-chart__switch {\n  justify-self: stretch;\n  width: 100%;\n  font-size: 0.75rem;\n  padding: 0.35rem 0.6rem;\n}\n\n.org-chart__hint {\n  margin-top: 0.75rem;\n}\n\n.org-node--standby {\n  opacity: 0.65;\n  border-style: dashed;\n}\n\n.org-node__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.org-badge {\n  display: inline-block;\n  padding: 0.05rem 0.45rem;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  font-size: clamp(0.64rem, 0.56rem + 0.2vw, 0.78rem);\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: none;\n  color: var(--text-secondary);\n  background: var(--bg-muted, transparent);\n  white-space: nowrap;\n}\n\n.org-badge--prefix {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.org-badge--lead,\n.org-badge--active {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.org-badge--standby {\n  border-style: dashed;\n}\n\n.org-node__switch {\n  padding: 0.15rem 0.55rem;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  font-size: 0.95em;\n}\n\n.org-dialog__turn--meta {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  padding: 0 0 0.5rem;\n  background: transparent;\n  border: 0;\n}\n\n.org-chart__band-nodes {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n  gap: 1rem;\n}\n\n.org-chart__people {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.2rem 1.5rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.org-chart__systems,\n.org-node__list {\n  columns: 18rem;\n  column-gap: 2rem;\n  font-size: 0.8rem;\n}\n\n.org-chart__systems li,\n.org-node__list li {\n  break-inside: avoid;\n  padding: 0.2rem 0;\n}\n\n.org-chart__spaces {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.org-chart__spaces th {\n  padding: 0 1rem 0.4rem 0;\n  text-align: left;\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  border-bottom: 1px solid var(--line-strong);\n}\n\n.org-chart__spaces td {\n  padding: 0.45rem 1rem 0.45rem 0;\n  vertical-align: top;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n}\n\n.org-chart__space-name {\n  width: 18rem;\n  white-space: nowrap;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.org-node {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n  height: 100%;\n  padding: 0.8rem 0.9rem;\n  font-size: clamp(0.8rem, 0.7rem + 0.25vw, 0.95rem);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  color: var(--text-primary);\n}\n\n.org-node--people {\n  align-items: center;\n  text-align: center;\n  border-color: var(--line-strong);\n}\n\n.org-node--agent {\n  border-style: dashed;\n  border-color: var(--border-hover);\n}\n\n.org-node__name {\n  font-size: 1.05em;\n  font-weight: 600;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n  color: var(--text-primary);\n}\n\n.org-node__title {\n  font-size: 0.86em;\n  color: var(--text-muted);\n}\n\n/* A supporting colleague inside a unit's column: the same card, smaller, without actions; its own card with the\n   actions stands in its own unit. */\n.org-node--support {\n  padding: 0.5rem 0.7rem;\n  gap: 0.15rem;\n  border-style: dashed;\n}\n\n.org-node--support .org-node__name {\n  font-size: 0.95em;\n}\n\n.org-node__item {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.org-node__text {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.org-node__alert {\n  font-size: 0.74rem;\n  color: var(--text-primary);\n}\n\n.org-node__meta {\n  display: grid;\n  gap: 0.15rem;\n  margin-top: auto;\n  padding-top: 0.4rem;\n  font-size: 0.82em;\n  color: var(--text-muted);\n  border-top: 1px solid var(--border);\n}\n\n.org-node__meta > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Write and call on a colleague's box: two quiet line icons with their label as a whisper, never buttons with text\n   (IDD D-HP-ADMIN-028). */\n.org-node__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.5rem;\n  margin-top: 0.3rem;\n  font-size: 0.82em;\n}\n\n.org-node__icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.15rem 0.3rem;\n  border: 1px solid transparent;\n  border-radius: calc(var(--radius) / 2);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1em;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.org-node__icon:hover,\n.org-node__icon:focus-visible {\n  color: var(--text-primary);\n  border-color: var(--border);\n  outline: none;\n}\n\n.org-node__icon svg {\n  flex: none;\n}\n\n/* The voice of a colleague, chosen at its box (IDD D-HP-ADMIN-034): a small select in the row of the icons. */\n.org-node__voice {\n  flex: 1 1 100%;\n  order: 10;\n  min-width: 0;\n  max-width: 100%;\n  padding: 0.2rem 0.3rem;\n  border: 1px solid var(--border);\n  border-radius: calc(var(--radius) / 2);\n  background: var(--bg-card);\n  color: var(--text-muted);\n  font-size: 1em;\n  line-height: 1.2;\n}\n\n.org-node__voice:hover,\n.org-node__voice:focus-visible {\n  color: var(--text-primary);\n  outline: none;\n}\n\n/* The call panel is a phone (IDD D-HP-ADMIN-037): the state with its timer, the microphone's level, the hang-up. */\n.org-call__status {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.6rem 1rem;\n  font-size: 0.85rem;\n}\n\n.org-call__state::before {\n  content: \"\";\n  display: inline-block;\n  width: 0.55rem;\n  height: 0.55rem;\n  margin-right: 0.4rem;\n  border-radius: 50%;\n  background: var(--text-muted);\n  vertical-align: 0.05em;\n}\n\n.org-call__state--ringing::before {\n  background: var(--accent);\n  animation: org-call-ring 1s ease-in-out infinite;\n}\n\n.org-call__state--connected::before {\n  background: var(--accent);\n}\n\n@keyframes org-call-ring {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.25; }\n}\n\n.org-call__meter {\n  display: inline-block;\n  width: 7rem;\n  height: 0.45rem;\n  border: 1px solid var(--border);\n  border-radius: 0.3rem;\n  overflow: hidden;\n  background: var(--bg-card);\n}\n\n.org-call__meter-bar {\n  display: block;\n  height: 100%;\n  background: var(--accent);\n  transition: width 0.1s linear;\n}\n\n.org-call__hangup {\n  min-width: 9rem;\n}\n\n.org-call__turns {\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.org-node__marker::before,\n.org-node__alert::before {\n  content: \"\";\n  display: inline-block;\n  width: 0.4rem;\n  height: 0.4rem;\n  margin-right: 0.35rem;\n  border-radius: 50%;\n  background: var(--accent);\n  vertical-align: 0.08em;\n}\n\n@media (max-width: 56.25em) {\n  .org-chart__area {\n    grid-column: auto !important;\n  }\n\n  .org-chart__area-nodes {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n\n  .org-chart__space-name {\n    width: auto;\n    white-space: normal;\n  }\n}\n\n/* Stacked tables share one grid: fixed column widths, so every workload row\n   and every namespace group aligns regardless of name length. Long names and\n   images are clipped and carry the full value as a tooltip. */\n.admin-workload-table,\n.admin-events-table {\n  table-layout: fixed;\n  min-width: 1080px;\n}\n\n.admin-workload-table .admin-col-name { width: 24%; }\n.admin-workload-table .admin-col-state { width: 9%; }\n.admin-workload-table .admin-col-replicas { width: 9%; }\n.admin-workload-table .admin-col-cpu { width: 10%; }\n.admin-workload-table .admin-col-memory { width: 10%; }\n.admin-workload-table .admin-col-restarts { width: 9%; }\n.admin-workload-table .admin-col-image { width: 29%; }\n\n.admin-events-table .admin-col-seen { width: 13%; }\n.admin-events-table .admin-col-object { width: 31%; }\n.admin-events-table .admin-col-reason { width: 16%; }\n.admin-events-table .admin-col-message { width: 40%; }\n\n/* The AI gateway tab stacks several tables; they share one column grid so\n   their edges line up, the same way the workload table does. */\n.admin-gateway-table,\n.admin-usage-table {\n  table-layout: fixed;\n  min-width: 1080px;\n}\n.admin-gateway-table .admin-col-a { width: 26%; }\n.admin-gateway-table .admin-col-b { width: 22%; }\n.admin-gateway-table .admin-col-c { width: 16%; }\n.admin-gateway-table .admin-col-d { width: 36%; }\n.admin-gateway-table .admin-col-rest { width: 52%; }\n.admin-gateway-table .admin-col-rest-wide { width: 74%; }\n\n.admin-usage-table .admin-col-identity { width: 26%; }\n.admin-usage-table .admin-col-tokens { width: 13%; }\n.admin-usage-table .admin-col-model { width: 21%; }\n.admin-usage-table .admin-col-action { width: 14%; }\n\n.admin-table .admin-cell-clip {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-table tbody tr.admin-table-group td,\n.admin-table tbody tr.admin-table-group:hover td {\n  padding: 0.55rem 0.9rem;\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n}\n\n.admin-table-group-name {\n  margin-right: 0.75rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.admin-table-group-note {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.admin-inline-input {\n  min-width: 11rem;\n}\n\n.admin-inline-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n/* Node cards sit beside each other while there is room and stack below it. */\n.admin-node-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(19rem, 1fr));\n  gap: 0.75rem;\n}\n\n.admin-user-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admin-user-search {\n  flex: 1 1 16rem;\n  min-width: 12rem;\n}\n\n.admin-user-select {\n  flex: 0 0 12rem;\n}\n\n.admin-user-count {\n  margin-left: auto;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Six columns, not the twelve-plus of the SMTM tables, so the list fits a\n   normal window without horizontal scrolling. */\n.admin-user-table {\n  min-width: 52rem;\n}\n\n.admin-user-table tbody td {\n  vertical-align: middle;\n}\n\n.admin-user-table tbody tr.is-selected {\n  background: rgba(255, 0, 136, 0.05);\n}\n\n.admin-user-name {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n/* The address is the longest value in the row; it truncates instead of pushing\n   the neighbouring columns out of their width. */\n.admin-user-mail {\n  max-width: 22rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n}\n\n.admin-user-roles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.admin-user-created {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user-pager {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  color: var(--text-muted);\n  font-size: 0.82rem;\n}\n\n.admin-user-hint {\n  align-self: center;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.admin-user-detail {\n  border-color: var(--border-hover);\n}\n\n.card-hover:hover {\n  border-color: var(--border-hover);\n  transform: translateY(-1px);\n}\n\n.shadow-professional,\n.shadow-primary-strong,\n.shadow-success-glow,\n.shadow-error-glow,\n.shadow-info-glow {\n  box-shadow: var(--shadow);\n}\n\n.border-gradient {\n  border: 1px solid var(--border);\n  background: var(--bg-card);\n}\n\n.homepage-photo-frame,\n.site-media {\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  overflow: hidden;\n}\n\n.homepage-photo,\n.site-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.about-photo-frame {\n  height: auto;\n  max-width: 220px;\n  justify-self: end;\n  background: var(--bg-main);\n}\n\n.about-photo {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.about-hero-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(180px, 220px);\n  gap: clamp(1rem, 3vw, 2rem);\n  align-items: start;\n}\n\n.about-hero-copy {\n  min-width: 0;\n}\n\n.about-download-panel {\n  display: grid;\n  grid-template-columns: minmax(11rem, 0.42fr) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: center;\n  margin-top: clamp(1rem, 2vw, 1.35rem);\n  padding: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-secondary);\n}\n\n.about-download-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.7rem;\n}\n\n.about-download-card {\n  display: block;\n  padding: 0.72rem 0.82rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  line-height: 1.25;\n  transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;\n}\n\n.about-download-card:hover {\n  border-color: var(--ink);\n  background: var(--bg-hover);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 63.9375em) {\n  .about-hero-grid,\n  .about-download-panel {\n    grid-template-columns: 1fr;\n  }\n\n  .about-photo-frame {\n    justify-self: start;\n    max-width: 200px;\n  }\n}\n\n@media (max-width: 40em) {\n  .about-download-actions {\n    grid-template-columns: 1fr;\n  }\n}\n\n.homepage-rule {\n  height: 1px;\n  background: var(--border);\n}\n\n.signal-service-list,\n.signal-capability-list,\n.site-row-list {\n  border-top: 1px solid var(--rule);\n}\n\n.signal-service-row,\n.signal-capability-list article,\n.site-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: start;\n  padding: clamp(1.05rem, 2.1vw, 1.55rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.signal-capability-list article,\n.site-row--text {\n  grid-template-columns: minmax(12rem, 0.42fr) minmax(0, 1fr);\n}\n\n.signal-service-row h3,\n.signal-capability-list h3,\n.site-row h3,\n.site-card h3 {\n  margin: 0 0 0.35rem;\n  color: var(--text-primary);\n  font-size: clamp(1.05rem, 1.35vw, 1.32rem);\n  font-weight: 400;\n  letter-spacing: -0.01em;\n  line-height: 1.18;\n}\n\n.signal-service-row p,\n.signal-capability-list p,\n.site-row p,\n.site-card p {\n  max-width: 48rem;\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.68;\n}\n\n.signal-service-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.65rem;\n  margin-top: 0.85rem;\n}\n\n.signal-service-tags span {\n  color: var(--muted);\n  font-size: 0.76rem;\n  font-weight: 400;\n  line-height: 1.25;\n  letter-spacing: 0.01em;\n  padding: 0.26rem 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: transparent;\n}\n\n.signal-service-row a,\n.signal-contact a,\n.site-text-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  justify-self: end;\n  color: var(--ink);\n  font-size: 0.92rem;\n  font-weight: 400;\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.32em;\n  white-space: normal;\n  text-align: center;\n  line-height: 1.4;\n  max-width: min(100%, 18rem);\n  overflow-wrap: anywhere;\n  transition: color 160ms ease;\n}\n\n.signal-service-row a:hover,\n.signal-contact a:hover,\n.site-text-link:hover {\n  color: var(--accent);\n}\n\n.signal-sector-line,\n.site-sector-list,\n.site-label-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.7rem 1.2rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.signal-sector-line p,\n.site-sector-list p,\n.site-label-line span {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.94rem;\n  line-height: 1.45;\n}\n\n.signal-contact,\n.site-contact {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: end;\n  margin-top: clamp(2.5rem, 5vw, 4.5rem);\n  padding-top: 1.4rem;\n  border-top: 1px solid var(--rule);\n}\n\n.site-grid,\n.site-matrix {\n  display: grid;\n  gap: 1px;\n  background: var(--border);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.site-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.site-grid--3,\n.site-matrix--3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.site-grid--4,\n.site-matrix--4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n\n.site-grid > *,\n.site-matrix > * {\n  background: var(--bg-card);\n  border-radius: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n}\n\n.site-list {\n  display: grid;\n  gap: 0;\n  border-top: 1px solid var(--border);\n}\n\n.site-list > *,\n.site-list-row {\n  padding: 0.95rem 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.site-statement {\n  display: inline-block;\n  margin-top: 1.4rem;\n  padding: 0.9rem 1.1rem;\n  border-left: 2px solid var(--accent);\n  background: var(--bg-secondary);\n  color: var(--ink);\n  font-weight: 400;\n  line-height: 1.55;\n}\n\n.site-statement--large {\n  display: block;\n  margin-top: clamp(1.4rem, 2.4vw, 2rem);\n  font-size: clamp(1.1rem, 1.6vw, 1.35rem);\n  font-weight: 300;\n}\n\n.btn-primary,\n.btn-secondary,\n.homepage-button-primary,\n.homepage-button-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  border-radius: var(--radius);\n  border: 1px solid var(--ink);\n  background: var(--ink);\n  color: #ffffff;\n  font-weight: 400;\n  letter-spacing: 0.02em;\n  padding: 0.8rem 1.2rem;\n  box-shadow: none;\n  text-decoration: none;\n  text-align: center;\n  line-height: 1.35;\n  white-space: normal;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;\n}\n\n.btn-primary:hover,\n.homepage-button-primary:hover {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #ffffff;\n  transform: none;\n}\n\n.homepage-button-secondary,\n.btn-secondary {\n  background: transparent;\n  color: var(--ink);\n  border-color: var(--ink);\n}\n\n.homepage-button-secondary:hover,\n.btn-secondary:hover {\n  background: transparent;\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.form-input {\n  width: 100%;\n  background: var(--bg-card);\n  border: 1px solid var(--border-hover);\n  color: var(--ink);\n  padding: 0.85rem 0.95rem;\n  border-radius: var(--radius);\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--ink);\n  box-shadow: 0 0 0 3px rgba(255, 0, 136, 0.14);\n}\n\n.form-input::placeholder {\n  color: var(--text-muted);\n}\n\n.nav-link {\n  color: var(--ink-soft);\n  font-weight: 400;\n  padding: 0.55rem 0.75rem;\n  border-radius: var(--radius);\n  transition: color 160ms ease, background-color 160ms ease;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: var(--ink);\n  background: var(--bg-hover);\n}\n\n.animate-pulse-professional,\n.animate-float-smooth,\n.animate-gradient-pro {\n  animation: none;\n}\n\nsection.pt-20,\nsection.md\\:pt-24,\ndiv.pt-20,\ndiv.md\\:pt-24 {\n  padding-top: clamp(5.5rem, 9vw, 7rem) !important;\n}\n\nsection.pb-8,\nsection.md\\:pb-10 {\n  padding-bottom: clamp(2rem, 4vw, 3rem) !important;\n}\n\nsection.pt-20 > div > .grid,\nsection.md\\:pt-24 > div > .grid,\n.homepage-card > .grid:first-child {\n  gap: clamp(1.5rem, 5vw, 4rem) !important;\n}\n\n.homepage-card .bg-bg-hover,\n.homepage-card .bg-bg-card,\n.bg-bg-card.rounded-2xl,\n.bg-bg-hover.rounded-2xl {\n  border-color: var(--border) !important;\n}\n\n.grid.gap-px,\n.grid.md\\:grid-cols-3.gap-px,\n.grid.md\\:grid-cols-2.lg\\:grid-cols-4.gap-px,\n.grid.md\\:grid-cols-2.lg\\:grid-cols-3.gap-px {\n  border-radius: var(--radius) !important;\n  border-color: var(--border) !important;\n  background: var(--border) !important;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  vertical-align: top;\n}\n\npre {\n  margin: 0;\n}\n\n@media (max-width: 56.25em) {\n  .admin-smtm-training-workbench,\n  .admin-smtm-training-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-smtm-training-card-wide {\n    grid-column: span 1;\n  }\n\n  .admin-smtm-filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-smtm-status-meta {\n    text-align: left;\n  }\n\n  .admin-user-select {\n    flex: 1 1 100%;\n  }\n\n  .admin-user-count {\n    margin-left: 0;\n  }\n\n  .admin-section-head {\n    flex-direction: column;\n  }\n\n  .site-hero {\n    grid-template-columns: 1fr;\n    align-items: start;\n  }\n\n  .signal-section-header,\n  .site-section-head,\n  .signal-service-row,\n  .signal-capability-list article,\n  .signal-contact,\n  .site-row,\n  .site-row--text,\n  .site-contact {\n    grid-template-columns: 1fr;\n  }\n\n  .site-grid--2,\n  .site-grid--3,\n  .site-grid--4,\n  .site-matrix--3,\n  .site-matrix--4 {\n    grid-template-columns: 1fr;\n  }\n\n  .signal-service-row a,\n  .signal-contact a,\n  .site-text-link {\n    white-space: normal;\n    justify-self: start;\n  }\n}\n\n@media (max-width: 35em) {\n  .admin-dashboard-main {\n    width: min(1680px, calc(100% - 1.25rem));\n  }\n\n  .admin-smtm-training-list-scroll,\n  .admin-smtm-training-detail-scroll {\n    max-height: 50vh;\n  }\n\n  .site-main,\n  .signal-home,\n  .site-section__inner,\n  .homepage-section > .max-w-7xl,\n  .homepage-section > .max-w-6xl,\n  .homepage-section > .max-w-4xl,\n  .homepage-muted-panel > .max-w-7xl,\n  .homepage-muted-panel > .max-w-6xl,\n  .homepage-muted-panel > .max-w-4xl,\n  /* D-HP-SITE-032: the pages built from sections keep the shared frame's phone margin too */\n  section > .max-w-7xl,\n  section > .max-w-6xl,\n  section > .max-w-4xl,\n  section > .max-w-3xl {\n    width: min(var(--container), calc(100% - 1.25rem));\n  }\n\n  /* D-HP-SITE-030: on phones a page title is never larger than on a tablet (2.3rem); it scales with the width,\n     balances its lines so no word stands alone on the last one, and hyphenates only a long word wider than the\n     line. */\n  .site-hero h1,\n  .signal-hero h1,\n  .site-title {\n    font-size: clamp(2rem, 9vw, 2.3rem);\n  }\n\n  :where(h1, h2, h3):not(.admin-dashboard-main *) {\n    overflow-wrap: break-word;\n    text-wrap: balance;\n    /* A word longer than the line (de \"Datenschutzerklärung\", fi \"kaupankäyntiavustaja\") is hyphenated by the page\n       language's rules; words under twelve letters never are. */\n    -webkit-hyphens: auto;\n    hyphens: auto;\n    hyphenate-limit-chars: 12 5 5;\n    -webkit-hyphenate-limit-before: 5;\n    -webkit-hyphenate-limit-after: 5;\n  }\n\n  /* The columns of a page head may become narrower than their longest word; where the browser has no hyphenation\n     dictionary for the page language, such a word then breaks at the line's end instead of widening the page. */\n  :where(.site-hero, .finance-hero) > * {\n    min-width: 0;\n  }\n\n  /* The consent dialog's title is one long word in some languages (sv \"Integritetsinställningar\"); it scales down\n     with the width instead of running past the dialog's edge, and reaches its desktop size from about 430px on. */\n  #cookie-consent-title {\n    font-size: clamp(1.5rem, 7vw, 1.875rem);\n  }\n\n  /* When the title and the language control do not fit side by side, the control moves below the title instead of\n     squeezing the title into broken words. */\n  .cookie-consent__head {\n    flex-wrap: wrap;\n  }\n}\n\n/* ---------- admin dashboard density ----------\n   The operator surface shows tables, states and controls, not marketing copy.\n   Everything below tightens the shared components inside the dashboard only;\n   the public pages keep their own proportions. The utility overrides carry two\n   classes plus the two :not() parts so they outrank Tailwind's own spacing. */\n.admin-dashboard-main {\n  font-size: 0.88rem;\n}\n\n.admin-dashboard-main.space-y-6 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 0.7rem;\n}\n\n.admin-dashboard-main .space-y-2 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 0.3rem;\n}\n\n.admin-dashboard-main .space-y-3 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 0.4rem;\n}\n\n.admin-dashboard-main .space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 0.5rem;\n}\n\n.admin-dashboard-main .site-card {\n  padding: 0.8rem 0.9rem;\n}\n\n.admin-dashboard-main .homepage-muted-panel {\n  padding: 0.65rem 0.75rem;\n}\n\n.admin-dashboard-main .homepage-button-primary,\n.admin-dashboard-main .homepage-button-secondary {\n  padding: 0.3rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 500;\n  border-radius: var(--radius);\n  gap: 0.35rem;\n}\n\n.admin-dashboard-main .form-input {\n  padding: 0.32rem 0.55rem;\n  font-size: 0.8rem;\n}\n\n/* The indicator row packs as many cards per line as fit instead of leaving a\n   single orphan below a fixed eight-column grid. */\n/* Service cards are as tall as their content; the links stay bottom-aligned\n   within a row instead of a fixed height stretching every card. */\n.admin-dashboard-main .admin-panel h2,\n.admin-dashboard-main .site-card h2 {\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.admin-dashboard-main .admin-panel h3,\n.admin-dashboard-main .site-card h3 {\n  font-size: 0.87rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n.admin-dashboard-main .site-copy,\n.admin-dashboard-main .site-card p,\n.admin-dashboard-main .homepage-muted-panel p {\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.admin-dashboard-main .editorial-kicker {\n  margin-bottom: 0.35rem;\n}\n\n.admin-dashboard-main .admin-section-head {\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .admin-node-grid {\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .admin-table thead th {\n  padding: 0.35rem 0.55rem;\n  font-size: 0.64rem;\n  letter-spacing: 0.05em;\n}\n\n.admin-dashboard-main .admin-table tbody td {\n  padding: 0.38rem 0.55rem;\n  font-size: 0.79rem;\n}\n\n.admin-dashboard-main .admin-status-pill {\n  padding: 0.08rem 0.45rem;\n  font-size: 0.65rem;\n}\n\n.admin-dashboard-main .admin-inline-actions {\n  gap: 0.3rem;\n}\n\n.admin-dashboard-main .admin-user-toolbar {\n  gap: 0.4rem;\n}\n\n.admin-dashboard-main .admin-user-hint,\n.admin-dashboard-main .admin-user-count {\n  font-size: 0.75rem;\n}\n\n/* The tab-specific grids follow the same rule as the overview: cards pack by\n   available width and are as tall as their content. */\n.admin-dashboard-main .admin-smtm-filter-row {\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .admin-smtm-training-card-tall {\n  min-height: 11rem;\n}\n\n.admin-dashboard-main .admin-smtm-training-detail-grid {\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .admin-smtm-status-meta {\n  min-width: 11rem;\n  font-size: 0.75rem;\n}\n\n/* Tailwind's spacing utilities are sized for the public pages. */\n.admin-dashboard-main .gap-2 { gap: 0.3rem; }\n.admin-dashboard-main .gap-3 { gap: 0.4rem; }\n.admin-dashboard-main .gap-4 { gap: 0.5rem; }\n.admin-dashboard-main .gap-6 { gap: 0.6rem; }\n.admin-dashboard-main .mt-2 { margin-top: 0.3rem; }\n.admin-dashboard-main .mt-4 { margin-top: 0.5rem; }\n\n.admin-dashboard-main input[type=\"checkbox\"],\n.admin-dashboard-main input[type=\"radio\"] {\n  width: 0.85rem;\n  height: 0.85rem;\n}\n\n/* The remaining tab-local components, on the same proportions as the rest. */\n.admin-dashboard-main .admin-smtm-frame-metric { gap: 0.25rem; font-size: 0.74rem; }\n.admin-dashboard-main .admin-smtm-issue-list { gap: 0.25rem; }\n.admin-dashboard-main .admin-smtm-status-body-scroll { gap: 0.5rem; }\n.admin-dashboard-main .admin-smtm-training-workbench { gap: 0.5rem; }\n.admin-dashboard-main .admin-smtm-training-list-scroll { gap: 0.45rem; }\n.admin-dashboard-main .admin-smtm-training-list-item { gap: 0.3rem; padding: 0.6rem 0.7rem; }\n.admin-dashboard-main .admin-smtm-training-list-head { gap: 0.5rem; }\n.admin-dashboard-main .admin-smtm-training-card { gap: 0.45rem; }\n.admin-dashboard-main .admin-smtm-training-detail-list { gap: 0.35rem; }\n.admin-dashboard-main .admin-smtm-training-detail-row { gap: 0.5rem; padding: 0.35rem 0; font-size: 0.79rem; }\n.admin-dashboard-main .admin-azurite-files { gap: 0.3rem; }\n.admin-dashboard-main .admin-azurite-file { font-size: 0.75rem; }\n.admin-dashboard-main .admin-meta-list { padding: 0.55rem 0.7rem; }\n.admin-dashboard-main .admin-user-mail { font-size: 0.74rem; }\n.admin-dashboard-main .admin-user-roles { gap: 0.25rem; }\n.admin-dashboard-main .admin-user-pager { gap: 0.5rem; font-size: 0.76rem; }\n\n/* ---------- admin dashboard navigation ----------\n   Two levels in one bar that stays below the site navigation while the page\n   scrolls: the tabs grouped by what they operate, and the sections of the\n   open tab. Every section fills the same content width, so cards, tables and\n   grids of all tabs share one left and one right edge. */\n.admin-dashboard-main .admin-nav-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.3rem;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.admin-nav-badge.is-warning {\n  background: rgba(168, 98, 0, 0.12);\n  color: var(--warning);\n}\n\n.admin-nav-badge.is-error {\n  background: var(--accent);\n  color: #ffffff;\n}\n\n/* Tables fill their card; only a narrow screen scrolls them sideways. */\n.admin-dashboard-main .admin-table {\n  min-width: 100%;\n}\n\n.admin-fixed-table {\n  table-layout: fixed;\n}\n\n.admin-dashboard-main .admin-table tbody tr.is-selected td {\n  background: var(--bg-hover);\n}\n\n.admin-dashboard-main .admin-detail-row td,\n.admin-dashboard-main .admin-detail-row:hover td {\n  background: var(--bg-secondary);\n}\n\n.admin-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.5rem;\n}\n\n.admin-card {\n  min-width: 0;\n  display: grid;\n  align-content: start;\n  gap: 0.45rem;\n  padding: 0.9rem 1rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n}\n\n.admin-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n/* A project's state as a badge, and the reasons it is not presentable as a list the administrator opens\n   (software development page, IDD D-HP-ADMIN-021). */\n.admin-badge {\n  display: inline-block;\n  padding: 0.1rem 0.6rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.admin-badge-ok {\n  background: color-mix(in srgb, var(--success) 16%, transparent);\n  color: var(--success);\n}\n\n.admin-badge-warn {\n  background: color-mix(in srgb, var(--warning) 18%, transparent);\n  color: var(--warning);\n}\n\n.admin-reasons summary {\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n}\n\n.admin-reasons ol {\n  margin: 0.45rem 0 0;\n  padding-left: 1.6rem;\n  list-style: decimal outside;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.admin-reasons li {\n  display: list-item;\n  list-style: decimal outside;\n  margin-top: 0.35rem;\n  overflow-wrap: anywhere;\n}\n\n.admin-reasons li::marker {\n  content: counter(list-item) \". \";\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.admin-table td.admin-col-state {\n  min-width: 14rem;\n}\n\n.admin-table td.admin-col-address {\n  min-width: 14rem;\n  overflow-wrap: anywhere;\n}\n\n.admin-table td.admin-col-actions {\n  white-space: nowrap;\n}\n\n.admin-table td.admin-col-actions a,\n.admin-table td.admin-col-actions button {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.admin-filter-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-log {\n  max-height: 60vh;\n  overflow-y: auto;\n  font-family: ui-monospace, SFMono-Regular, Consolas, monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n}\n\n.admin-table-scroll-tall {\n  max-height: 60vh;\n}\n\n/* The overview's list of what needs a person: one row per item on a shared\n   column grid, the whole row leads to the section that holds it. */\n.admin-attention-list {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.admin-attention-item {\n  display: grid;\n  grid-template-columns: max-content minmax(0, 1fr) 22rem;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.45rem 0.6rem;\n  border: 0;\n  border-top: 1px solid var(--border);\n  background: var(--bg-card);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  text-align: left;\n}\n\n.admin-attention-item:first-child {\n  border-top: 0;\n}\n\n.admin-attention-item:hover {\n  background: var(--bg-hover);\n  color: var(--ink);\n}\n\n.admin-attention-item .admin-status-pill {\n  justify-self: start;\n  white-space: nowrap;\n}\n\n.admin-attention-text {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.admin-attention-where {\n  color: var(--text-muted);\n  font-size: 0.74rem;\n  text-align: right;\n}\n\n.admin-attention-list > .homepage-muted-panel {\n  border: 0;\n  border-radius: 0;\n}\n\n@media (max-width: 68.75em) {\n  .admin-dashboard-main .admin-table {\n    min-width: 900px;\n  }\n\n  }\n\n@media (max-width: 56.25em) {\n  .admin-dashboard-main   .admin-attention-item {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n\n  .admin-attention-where {\n    text-align: left;\n  }\n\n  .admin-detail-grid,\n  .admin-filter-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---- Team: overview cards and the switcher inside a profile ---- */\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: clamp(1rem, 2.4vw, 1.6rem);\n}\n\n.team-card {\n  display: flex;\n  flex-direction: column;\n  color: inherit;\n  text-decoration: none;\n  transition: border-color 180ms ease, transform 180ms ease;\n}\n\n.team-card:hover,\n.team-card:focus-visible {\n  border-color: var(--ink);\n  transform: translateY(-2px);\n}\n\n.team-card__photo {\n  aspect-ratio: 4 / 5;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.team-card__photo img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 18%;\n}\n\n.team-card__body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: clamp(1rem, 2vw, 1.35rem);\n}\n\n.team-card__body h2 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.3rem, 1.9vw, 1.65rem);\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  line-height: 1.15;\n}\n\n.team-card__headline {\n  margin: 0;\n  color: var(--ink);\n  font-size: 0.94rem;\n  font-weight: 400;\n  line-height: 1.45;\n}\n\n.team-card__summary {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  line-height: 1.66;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 5;\n  overflow: hidden;\n}\n\n.team-card__cta {\n  justify-content: flex-start;\n  justify-self: start;\n  margin-top: auto;\n  padding-top: 0.4rem;\n}\n\n.team-switcher {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.team-switcher__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: var(--ink-soft);\n  font-size: 0.88rem;\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.team-switcher__back:hover {\n  color: var(--accent);\n}\n\n.team-switcher__members {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.team-switcher__item {\n  padding: 0.42rem 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  color: var(--ink-soft);\n  font-size: 0.88rem;\n  font-weight: 400;\n  text-decoration: none;\n  transition: border-color 160ms ease, color 160ms ease;\n}\n\n.team-switcher__item:hover {\n  border-color: var(--border-hover);\n  color: var(--text-primary);\n}\n\n.team-switcher__item--active {\n  border-color: var(--ink);\n  color: var(--ink);\n}\n\n.landing-contact {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: start;\n  margin: clamp(0.8rem, 2vw, 1.6rem) 0 clamp(2rem, 4vw, 3.2rem);\n  padding-top: 1.6rem;\n  border-top: 1px solid var(--rule);\n}\n\n.finance-cta__lead {\n  max-width: 34rem;\n  margin: 0.7rem 0 0;\n  color: var(--text-muted);\n  line-height: 1.72;\n}\n\n.landing-contact__cta {\n  margin-top: 1.3rem;\n}\n\n.landing-contact__facts {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem 1.6rem;\n  margin: 0;\n}\n\n.landing-contact__facts dt {\n  margin-bottom: 0.45rem;\n  color: var(--logo-grey);\n  font-size: 0.72rem;\n  font-weight: 400;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n}\n\n.landing-contact__facts dd {\n  margin: 0;\n  color: var(--ink);\n  font-size: 1rem;\n  line-height: 1.7;\n  overflow-wrap: anywhere;\n}\n\n.landing-contact__facts a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.landing-contact__phone {\n  display: block;\n}\n\n.landing-contact__facts a:hover {\n  color: var(--accent);\n}\n\n.profile-link {\n  color: var(--ink);\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 0.28em;\n}\n\n.profile-link + .profile-link {\n  margin-left: 0.8rem;\n}\n\n.profile-link:hover {\n  color: var(--accent);\n}\n\n/* ---- Teaching page: full-width sections, rows instead of nested cards ---- */\n.teaching-page .signal-section {\n  padding: clamp(1.9rem, 3.2vw, 2.8rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.teaching-page .signal-section-header {\n  margin-bottom: clamp(0.9rem, 1.8vw, 1.3rem);\n}\n\n/* D-HP-SITE-032: the teaching head starts at the shared head's height; the photo stands beside the title. */\n.teaching-hero {\n  align-items: start;\n  padding: clamp(2.4rem, 5vw, 4.8rem) 0 clamp(1.8rem, 3.4vw, 3rem);\n}\n\n.teaching-hero__photo {\n  height: clamp(13rem, 22vw, 19rem);\n}\n\n.teaching-subtitle {\n  margin-bottom: 0.6rem !important;\n  color: var(--text-primary) !important;\n  font-size: 1.08rem;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.teaching-inline-label {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.teaching-cell {\n  padding: 1rem 1.2rem;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.teaching-row {\n  display: grid;\n  gap: 0.5rem clamp(1.2rem, 3.5vw, 3rem);\n  align-items: start;\n  padding: clamp(0.95rem, 1.8vw, 1.3rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.teaching-row--group {\n  grid-template-columns: minmax(13rem, 0.3fr) minmax(0, 1fr) minmax(15rem, 0.46fr);\n}\n\n.teaching-row--format {\n  grid-template-columns: minmax(13rem, 0.3fr) minmax(7rem, 0.16fr) minmax(0, 1fr);\n}\n\n.teaching-row h3,\n.teaching-topics h3 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: clamp(1.02rem, 1.25vw, 1.2rem);\n  font-weight: 400;\n  letter-spacing: -0.01em;\n  line-height: 1.25;\n}\n\n.teaching-row p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.teaching-row .teaching-row__focus {\n  margin-top: 0.3rem;\n  color: var(--text-muted);\n  font-size: 0.86rem;\n}\n\n.teaching-row__focus span {\n  font-weight: 500;\n}\n\n.teaching-row .teaching-row__duration {\n  color: var(--primary-light);\n  font-weight: 500;\n}\n\n.teaching-row__tags {\n  margin-top: 0;\n  justify-content: flex-end;\n}\n\n.teaching-topics {\n  padding: clamp(1.05rem, 2vw, 1.45rem);\n}\n\n.teaching-topics h3 {\n  margin-bottom: 0.8rem;\n}\n\n.teaching-topics li {\n  padding: 0.42rem 0;\n  border-top: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.93rem;\n  line-height: 1.5;\n}\n\n.teaching-topics p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.93rem;\n  line-height: 1.65;\n}\n\n.teaching-topics .signal-service-tags {\n  margin-top: 0;\n}\n\n.teaching-benefits {\n  margin-top: 1.4rem;\n}\n\n.teaching-expertise {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 clamp(1.5rem, 4vw, 3.5rem);\n  border-top: 1px solid var(--border-hover);\n}\n\n.teaching-expertise li {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n.teaching-facts {\n  margin-top: clamp(1.4rem, 3vw, 2.2rem);\n}\n\n/* ---- Finance page: lead, the analysis set apart, one row per function ---- */\n.finance-hero {\n  max-width: 62rem;\n}\n\n/* D-HP-SITE-032: the lead of Finance AI and the IDD pages is the shared lead (size, weight, colour). */\n.finance-lead {\n  margin: 1.1rem 0 0;\n  color: var(--ink-soft);\n  font-size: clamp(1.06rem, 1.4vw, 1.28rem);\n  font-weight: 300;\n  line-height: 1.55;\n}\n\n.finance-analysis {\n  display: grid;\n  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);\n  gap: 1rem clamp(1.5rem, 5vw, 4rem);\n  align-items: start;\n  margin-top: clamp(1.6rem, 3vw, 2.4rem);\n  padding: clamp(1.6rem, 3vw, 2.4rem) clamp(1.2rem, 2.6vw, 2.2rem);\n  border-left: 2px solid var(--accent);\n  background: var(--bg-secondary);\n}\n\n.finance-analysis__text {\n  display: grid;\n  gap: 0.9rem;\n}\n\n.finance-analysis__text p {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 1rem;\n  line-height: 1.72;\n}\n\n.finance-analysis__text p:first-child {\n  color: var(--ink);\n  font-size: 1.1rem;\n}\n\n/* One row per item, title beside text: the functions of the finance page and\n   the applications of the platform on the start page. */\n.finance-features,\n.platform-apps {\n  border-top: 1px solid var(--rule);\n}\n\n.finance-feature,\n.platform-app {\n  display: grid;\n  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);\n  gap: 0.6rem clamp(1.5rem, 5vw, 4rem);\n  align-items: start;\n  padding: clamp(1.1rem, 2vw, 1.5rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.finance-feature h3,\n.platform-app h3 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.08rem, 1.35vw, 1.24rem);\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.finance-feature p,\n.platform-app p {\n  max-width: 54rem;\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.98rem;\n  line-height: 1.7;\n}\n\n.finance-feature .finance-feature__facts {\n  margin-top: 0.45rem;\n  color: var(--muted);\n  font-size: 0.84rem;\n  line-height: 1.6;\n}\n\n/* Pages told in prose (IDD, Veridion) keep several paragraphs in one row and\n   link words inside a paragraph. */\n.story-page .finance-feature p + p {\n  margin-top: 0.8rem;\n}\n\n.story-page__detail {\n  margin-top: 0.8rem;\n}\n\n/* On the start page the rows sit under a section header with its own text, so\n   they take the header's columns. */\n.platform-app {\n  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);\n}\n\n.platform-app__link {\n  margin-top: 0.6rem;\n}\n\n@media (max-width: 63.9375em) {\n  .team-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .finance-analysis,\n  .finance-feature,\n  .platform-app,\n  .legal-section,\n  .profile-contact,\n  .landing-contact,\n  .teaching-row--group,\n  .teaching-row--format,\n  .teaching-expertise {\n    grid-template-columns: 1fr;\n  }\n\n  .teaching-row__tags {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 40em) {\n  .team-grid,\n  .landing-contact__facts {\n    grid-template-columns: 1fr;\n  }\n\n  .team-card__photo {\n    aspect-ratio: 1 / 1;\n  }\n\n  .team-switcher {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n/* ---- Navigation: the logo is the home link ---- */\n.site-nav {\n  background: rgba(255, 255, 255, 0.97);\n  border-bottom: 1px solid var(--border);\n}\n\n.site-nav--scrolled {\n  border-bottom-color: var(--rule);\n}\n\n.site-nav__logo {\n  display: flex;\n  align-items: center;\n}\n\n.site-nav__logo img {\n  display: block;\n  width: auto;\n  height: 30px;\n}\n\n.site-nav__link {\n  position: relative;\n  padding: 0.5rem 0.6rem;\n  color: var(--ink-soft);\n  font-size: 0.9rem;\n  font-weight: 400;\n  white-space: nowrap;\n  text-decoration: none;\n  transition: color 160ms ease;\n}\n\n.site-nav__link:hover {\n  color: var(--ink);\n}\n\n.site-nav__link--active {\n  color: var(--ink);\n}\n\n.site-nav__link--active::after {\n  content: \"\";\n  position: absolute;\n  left: 0.6rem;\n  right: 0.6rem;\n  bottom: 0.15rem;\n  height: 1px;\n  background: var(--accent);\n}\n\n.site-nav__menu {\n  min-width: 13rem;\n  padding: 0.4rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  box-shadow: 0 10px 30px rgba(26, 26, 26, 0.08);\n}\n\n.site-nav__menu-item {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius);\n  color: var(--ink-soft);\n  font-size: 0.9rem;\n  font-weight: 400;\n  text-align: left;\n  text-decoration: none;\n  transition: background-color 160ms ease, color 160ms ease;\n}\n\n.site-nav__menu-item:hover,\n.site-nav__menu-item--active {\n  background: var(--bg-hover);\n  color: var(--ink);\n}\n\n.site-nav__control {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  height: 2.25rem;\n  box-sizing: border-box;\n  padding: 0 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  color: var(--ink-soft);\n  font-size: 0.86rem;\n  font-weight: 400;\n  line-height: 1;\n  white-space: nowrap;\n  transition: border-color 160ms ease, color 160ms ease;\n}\n\n.site-nav__control:hover {\n  border-color: var(--ink);\n  color: var(--ink);\n}\n\n.site-nav__control--lang {\n  border-color: transparent;\n  background: transparent;\n  padding: 0 0.45rem;\n}\n\n.site-nav__control--lang:hover {\n  border-color: transparent;\n  color: var(--ink);\n}\n\n.site-nav__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.25rem;\n  box-sizing: border-box;\n  padding: 0 1rem;\n  font-size: 0.86rem;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n/* D-HP-SITE-030: on narrow phones the bar keeps language, sign-in and menu fully on screen in every language — the\n   logo may shrink in proportion and the controls tighten their padding; wider screens are unchanged. */\n@media (max-width: 30em) {\n  .site-nav .site-nav__logo {\n    flex-shrink: 1;\n    min-width: 4.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .site-nav .site-nav__logo img {\n    max-width: 100%;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .site-nav .site-nav__button {\n    padding: 0 0.7rem;\n  }\n\n  .site-nav .site-nav__control {\n    padding: 0 0.55rem;\n  }\n\n  /* The bar never reaches past the screen sideways: on a phone an overflowing fixed bar widens the layout viewport,\n     which then drags every fixed layer (the consent dialog among them) past the screen and makes the bar measure more\n     room than there is. Menus that open downwards are not affected. */\n  .site-nav > div {\n    overflow-x: clip;\n  }\n}\n\n/* When the bar is too narrow for logo, language, sign-in and menu side by side — on a small phone or with an enlarged\n   system font — sign-in moves into the menu, where it is always offered. The bar is a size container whose em follows\n   its font size, so the point grows with the text; each language's point is its measured need (logo 4.5em, gap 0.5em,\n   the measured width of the right-hand controls, 0.3em margin). */\n@media (max-width: 30em) {\n  .site-nav > div {\n    container: sitenav / inline-size;\n  }\n}\n\n@container sitenav (max-width: 19.66em) {\n  html:lang(de) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 17.78em) {\n  html:lang(en) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 19.15em) {\n  html:lang(nl) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 18.43em) {\n  html:lang(uk) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 19.85em) {\n  html:lang(fr) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 17.86em) {\n  html:lang(it) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 21.06em) {\n  html:lang(es) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 18.9em) {\n  html:lang(sv) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 21.77em) {\n  html:lang(fi) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 18.64em) {\n  html:lang(ja) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 19.89em) {\n  html:lang(pl) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n@container sitenav (max-width: 17.52em) {\n  html:lang(bg) .site-nav .site-nav__button {\n    display: none;\n  }\n}\n\n.site-nav__mobile {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  box-shadow: 0 16px 40px rgba(26, 26, 26, 0.1);\n}\n\n.site-nav__mobile-item {\n  display: block;\n  width: 100%;\n  padding: 0.7rem 1rem;\n  border-left: 2px solid transparent;\n  color: var(--ink-soft);\n  font-size: 1rem;\n  font-weight: 400;\n  text-align: left;\n  text-decoration: none;\n}\n\n.site-nav__mobile-item:hover {\n  background: var(--bg-hover);\n  color: var(--ink);\n}\n\n.site-nav__mobile-item--active {\n  border-left-color: var(--accent);\n  color: var(--ink);\n}\n\n.site-nav__mobile-item--sub {\n  padding-left: 2rem;\n  font-size: 0.92rem;\n}\n\n/* ---- Start page ---- */\n.landing-hero {\n  padding: clamp(2.6rem, 5vw, 4.6rem) 0 clamp(2.4rem, 4.6vw, 4rem);\n  border-bottom: 1px solid var(--rule);\n}\n\n.landing-hero__logo {\n  margin: 0;\n}\n\n.landing-hero__logo img {\n  display: block;\n  width: min(100%, 40rem);\n  height: auto;\n}\n\n.landing-hero__text {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  gap: clamp(1.5rem, 5vw, 4.5rem);\n  align-items: start;\n  margin-top: clamp(2.4rem, 4.4vw, 3.6rem);\n}\n\n.landing-hero__claim {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.6rem, 2.5vw, 2.35rem);\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  line-height: 1.22;\n}\n\n.landing-hero__copy p {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 1.04rem;\n  line-height: 1.74;\n}\n\n.landing-hero__copy p + p {\n  margin-top: 1rem;\n}\n\n/* The vision fills the claim column: the one bold paragraph under the claim,\n   so both hero columns carry equal weight and no space stands empty. */\n.landing-hero__vision {\n  margin: 1.6rem 0 0;\n  color: var(--ink);\n  font-weight: 600;\n  font-size: 1.12rem;\n  line-height: 1.6;\n}\n\n.product-list {\n  border-top: 1px solid var(--rule);\n}\n\n.product-row {\n  display: grid;\n  grid-template-columns: 16rem minmax(0, 1fr) 13rem;\n  gap: clamp(1.4rem, 3.6vw, 3rem);\n  align-items: start;\n  padding: clamp(1.5rem, 2.6vw, 2.2rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.product-row__mark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 16 / 10;\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.product-row__mark img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-row__mark--kyveil {\n  background: #141c27;\n}\n\n.product-row__mark--kyveil img {\n  object-fit: contain;\n}\n\n.product-row__mark--veridion {\n  background: #020733;\n}\n\n.product-row__mark--robuddy {\n  background: var(--bg-secondary);\n}\n\n.product-row__mark--robuddy img {\n  width: auto;\n  height: 88%;\n  object-fit: contain;\n}\n\n.product-row__mark--bisigma,\n.partner-row__mark {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n\n.product-row__mark--bisigma img,\n.partner-row__mark img {\n  display: block;\n  width: min(100%, 16.5rem);\n  height: auto;\n  object-fit: contain;\n}\n\n/* Partner row sits directly under .signal-section-header and shares its exact\n   two-column grid and vertical centering for symmetrical alignment. */\n.partner-row {\n  display: grid;\n  grid-template-columns: minmax(10rem, 0.38fr) minmax(0, 1fr);\n  gap: clamp(1.5rem, 5vw, 4rem);\n  align-items: center;\n  padding: clamp(1.75rem, 3vw, 2.5rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.partner-row__body {\n  display: grid;\n  gap: 0.65rem;\n  justify-items: start;\n}\n\n.partner-row__tagline {\n  margin: 0;\n  color: var(--logo-grey);\n  font-size: 0.72rem;\n  font-weight: 400;\n  letter-spacing: 0.16em;\n  line-height: 1.55;\n  text-transform: uppercase;\n}\n\n.partner-row__body h3 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.3rem, 1.8vw, 1.6rem);\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n}\n\n.partner-row__body p:not(.partner-row__tagline) {\n  max-width: 52rem;\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.98rem;\n  line-height: 1.72;\n}\n\n.partner-row__link {\n  justify-self: start;\n  justify-content: flex-start;\n  text-align: left;\n  margin-top: 0.25rem;\n}\n\n.product-row__body {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.product-row__body h3 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.3rem, 1.8vw, 1.6rem);\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n}\n\n.product-row__body p {\n  max-width: 48rem;\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.98rem;\n  line-height: 1.72;\n}\n\n.product-row__body h3 + p {\n  color: var(--ink);\n  font-size: 1.05rem;\n}\n\n.product-row__body .product-row__note {\n  color: var(--muted);\n  font-size: 0.86rem;\n}\n\n.product-row__offer {\n  display: grid;\n  justify-items: start;\n  gap: 0.7rem;\n}\n\n.product-row__price {\n  margin: 0;\n  color: var(--ink);\n  font-size: 1.15rem;\n  font-weight: 400;\n}\n\n.product-row__offer .site-text-link {\n  justify-self: start;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.service-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  column-gap: clamp(1.5rem, 3.2vw, 2.8rem);\n  border-top: 1px solid var(--rule);\n}\n\n.service-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: clamp(1.3rem, 2.2vw, 1.8rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.service-cell h3 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.12rem, 1.4vw, 1.28rem);\n  font-weight: 400;\n  line-height: 1.3;\n}\n\n.service-cell p {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.95rem;\n  line-height: 1.68;\n}\n\n.service-cell .service-cell__features {\n  color: var(--muted);\n  font-size: 0.82rem;\n  line-height: 1.6;\n}\n\n.service-cell__link {\n  align-self: flex-start;\n  justify-content: flex-start;\n  margin-top: auto;\n  padding-top: 0.3rem;\n  text-align: left;\n}\n\n/* ---- Legal notice and privacy policy: topic left, text right ---- */\n.legal-section {\n  display: grid;\n  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);\n  gap: 0.8rem clamp(1.5rem, 5vw, 4rem);\n  align-items: start;\n  padding: clamp(1.6rem, 3vw, 2.4rem) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n/* D-HP-SITE-030: on phones topic and text stand one above the other. The rule in the tablet block further up never\n   took effect, because this base rule follows it in the file; the legal notice and the privacy statement squeezed\n   their text into a narrow right column on phones. Desktop and tablet keep their two columns unchanged. */\n@media (max-width: 40em) {\n  .legal-section {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.legal-section__title {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(1.2rem, 1.6vw, 1.45rem);\n  font-weight: 300;\n  line-height: 1.3;\n}\n\n.legal-section__body {\n  max-width: 52rem;\n}\n\n.legal-section__body h3 {\n  margin: 1.2rem 0 0.3rem;\n  color: var(--ink);\n  font-size: 0.98rem;\n  font-weight: 500;\n}\n\n.legal-section__body h3:first-child {\n  margin-top: 0;\n}\n\n.legal-section__body p {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.98rem;\n  line-height: 1.72;\n}\n\n.legal-section__body p + p {\n  margin-top: 0.8rem;\n}\n\n.legal-section__body .legal-section__name {\n  color: var(--ink);\n  font-size: 1.1rem;\n  font-weight: 400;\n}\n\n.legal-section__body a,\n.product-row__body p a,\n.signal-section-header p a,\n.story-page p a {\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 0.28em;\n}\n\n.legal-section__body a:hover,\n.product-row__body p a:hover,\n.signal-section-header p a:hover,\n.story-page p a:hover {\n  color: var(--accent);\n}\n\n.legal-note {\n  margin: 1.6rem 0 0;\n  color: var(--muted);\n  font-size: 0.84rem;\n}\n\n/* ---- Team: the function of a member and the contact below a profile ---- */\n.team-members-intro {\n  max-width: 52rem;\n  margin-top: 1.2rem;\n}\n\n.profile-role {\n  margin: 0 0 0.6rem;\n  color: var(--logo-grey);\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.profile-name {\n  margin: 0 0 0.5rem;\n  color: var(--ink);\n  font-size: clamp(2.1rem, 3.6vw, 3.2rem);\n  font-weight: 300;\n  letter-spacing: -0.015em;\n  line-height: 1.1;\n}\n\n.profile-contact {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 1.5rem clamp(1.5rem, 5vw, 4rem);\n  align-items: end;\n  width: min(var(--container), calc(100% - 2rem));\n  margin: 0 auto clamp(2.4rem, 4vw, 3.6rem);\n  padding-top: 1.4rem;\n  border-top: 1px solid var(--rule);\n}\n\n/* D-HP-SITE-030: the same cascade order as the legal sections — on phones the contact block of a profile is one\n   column; desktop and tablet are unchanged. */\n@media (max-width: 40em) {\n  .profile-contact {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.profile-contact__mail {\n  margin: 0.6rem 0 0;\n  color: var(--ink);\n  font-size: 1.05rem;\n}\n\n.profile-contact__mail a:hover {\n  color: var(--accent);\n}\n\n/* ---- Events: start page and events page ---- */\n.site-row--text.event-row {\n  grid-template-columns: minmax(9rem, 13rem) minmax(0, 1fr);\n}\n\n/* D-HP-SITE-030: on phones the date stands above the event; this rule is more specific than the general one in the\n   tablet block, so it needs its own phone rule. Desktop and tablet are unchanged. */\n@media (max-width: 40em) {\n  .site-row--text.event-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.event-row .event-row__date {\n  margin: 0;\n  color: var(--ink);\n  font-size: 0.95rem;\n  font-weight: 400;\n}\n\n.event-row h3 a {\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 0.28em;\n}\n\n.event-row h3 a:hover {\n  color: var(--accent);\n}\n\n.event-year + .event-year {\n  margin-top: clamp(1.8rem, 3vw, 2.6rem);\n}\n\n.event-year__label {\n  margin: 0 0 0.8rem;\n  color: var(--logo-grey);\n  font-size: 0.78rem;\n  font-weight: 400;\n  letter-spacing: 0.2em;\n}\n\n.landing-events__all {\n  justify-self: start;\n  justify-content: flex-start;\n  margin-top: 1.2rem;\n}\n\n/* ---- Footer: laid out like the foot of the company's letters ---- */\n.site-footer {\n  border-top: 1px solid var(--rule);\n  background: var(--bg-main);\n}\n\n.site-footer__inner {\n  width: min(var(--container), calc(100% - 2rem));\n  margin: 0 auto;\n  padding: clamp(2rem, 4vw, 3rem) 0 1.6rem;\n}\n\n.site-footer__grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 1.6rem clamp(1.2rem, 3vw, 2.4rem);\n}\n\n.site-footer__grid p {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.86rem;\n  line-height: 1.75;\n}\n\n.site-footer__grid a,\n.site-footer__grid button {\n  color: inherit;\n  font: inherit;\n  text-decoration: none;\n  transition: color 160ms ease;\n}\n\n.site-footer__grid a:hover,\n.site-footer__grid button:hover {\n  color: var(--accent);\n}\n\n.site-footer .site-footer__name {\n  color: var(--ink);\n  font-weight: 400;\n}\n\n.site-footer .site-footer__label {\n  color: var(--ink);\n}\n\n.site-footer__copyright {\n  margin: clamp(1.6rem, 3vw, 2.4rem) 0 0;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n  color: var(--muted);\n  font-size: 0.8rem;\n}\n\n@media (max-width: 63.9375em) {\n  .landing-hero__text,\n  .product-row,\n  .partner-row {\n    grid-template-columns: 1fr;\n  }\n\n  .product-row__mark {\n    max-width: 22rem;\n  }\n\n  .service-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .site-footer__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 40em) {\n  .service-grid,\n  .site-footer__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .site-nav__logo img {\n    height: 26px;\n  }\n}\n\n/* Account page: who is signed in, one row per fact under a thin rule. */\n.account-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 1.6rem;\n}\n\n.account-facts {\n  margin: 0;\n}\n\n.account-facts__row {\n  display: grid;\n  grid-template-columns: minmax(14rem, 0.36fr) minmax(0, 1fr);\n  gap: 0.2rem clamp(1.5rem, 5vw, 4rem);\n  padding: 1rem 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.account-facts dt,\n.account-facts dd {\n  margin: 0;\n  line-height: 1.5;\n}\n\n.account-facts dt {\n  color: var(--muted);\n}\n\n.account-facts dd {\n  color: var(--ink);\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 40em) {\n  .account-facts__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* The parts of a page with two areas (the IDD page): named at its top as links,\n   and anchors that keep their heading clear of the fixed navigation. */\n.page-parts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 2rem;\n  padding-top: 1.5rem;\n}\n\n.page-parts__link {\n  font-size: 0.95rem;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary, inherit);\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 0.35em;\n}\n\n.page-parts__link:hover {\n  color: var(--accent);\n}\n\n.page-anchor {\n  scroll-margin-top: 5rem;\n}\n\n.page-parts__link--current {\n  color: var(--text-primary, inherit);\n}\n\n/* The parts links at the start of the method part sit on the page ground and\n   keep only a small gap above the method's own heading. */\n.page-parts-bar .site-main {\n  padding-bottom: 0;\n  min-height: 0;\n}\n\n/* The navigation links while the bar is compact: kept in the layout but out of\n   sight and out of reach, so the navigation can measure whether they fit. */\n.site-nav__links--measured {\n  position: absolute;\n  left: -10000px;\n  top: 0;\n  visibility: hidden;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n/* ---------- admin dashboard: the console (IDD D-HP-ADMIN-040) ----------\n   One sidebar with the pages in the groups of the company's working day, one\n   page at a time with its sections; a section carries its state in the header\n   and folds when it holds reference material or a form; numbers stand in rows,\n   never in tiles; long tables show fifty rows and more on request. Writing to\n   and calling a colleague open a dialog over the page (IDD D-HP-ADMIN-041). */\n.admin-dashboard-main {\n  font-size: 0.92rem;\n}\n\n/* The dashboard is an operating surface and uses the whole screen, however wide it is; only the public pages keep\n   the reading width of the container. */\n.site-main.admin-dashboard-main {\n  width: calc(100% - 3rem);\n  max-width: none;\n}\n\n.admin-shell {\n  display: grid;\n  grid-template-columns: 14rem minmax(0, 1fr);\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.admin-sidebar {\n  position: sticky;\n  top: 4.5rem;\n  max-height: calc(100vh - 5rem);\n  overflow-y: auto;\n  padding: 0.6rem 0.6rem 1.2rem 0;\n  border-right: 1px solid var(--border);\n}\n\n.admin-sidebar-head {\n  margin-bottom: 0.6rem;\n  padding: 0 0.6rem 0.9rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.admin-sidebar-title {\n  margin-top: 0.4rem;\n  color: var(--text-primary);\n  font-size: 1.05rem;\n  font-weight: 500;\n}\n\n.admin-sidebar-group {\n  margin-top: 0.85rem;\n}\n\n.admin-sidebar-group-label {\n  padding: 0 0.6rem 0.3rem;\n  color: var(--text-muted);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.admin-sidebar-list,\n.admin-sidebar-sublist {\n  display: grid;\n  gap: 0.1rem;\n}\n\n.admin-sidebar-sublist {\n  margin: 0.1rem 0 0.3rem 0.9rem;\n  padding-left: 0.6rem;\n  border-left: 1px solid var(--border);\n}\n\n.admin-sidebar-sublist.is-next-group {\n  margin-top: 0.35rem;\n  padding-top: 0.35rem;\n  border-top: 1px solid var(--border);\n}\n\n.admin-sidebar-link,\n.admin-sidebar-sublink {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.38rem 0.6rem;\n  border: 0;\n  border-left: 2px solid transparent;\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--ink-soft);\n  font-size: 0.92rem;\n  line-height: 1.3;\n  text-align: left;\n  cursor: pointer;\n}\n\n.admin-sidebar-sublink {\n  padding: 0.28rem 0.5rem;\n  font-size: 0.86rem;\n}\n\n.admin-sidebar-link:hover,\n.admin-sidebar-sublink:hover {\n  background: var(--bg-hover);\n  color: var(--ink);\n}\n\n.admin-sidebar-link.active,\n.admin-sidebar-sublink.active {\n  background: var(--bg-hover);\n  border-left-color: var(--accent);\n  color: var(--ink);\n  font-weight: 500;\n}\n\n.admin-content {\n  min-width: 0;\n}\n\n.admin-page-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.admin-dashboard-main .site-card.admin-page-head {\n  padding: 1rem 1.15rem;\n  overflow: visible;\n}\n\n.admin-page-head .admin-hero-title {\n  font-size: 1.35rem;\n  font-weight: 500;\n}\n\n.admin-page-head .site-copy {\n  margin-top: 0.35rem;\n  max-width: 60rem;\n  font-size: 0.9rem;\n}\n\n.admin-page-meta {\n  display: grid;\n  gap: 0.15rem 1.5rem;\n  margin: 0;\n  font-size: 0.85rem;\n  text-align: right;\n}\n\n.admin-page-meta div {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.admin-page-meta dt {\n  color: var(--text-muted);\n}\n\n.admin-page-meta dd {\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.admin-page-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.admin-dashboard-main .site-card.admin-section {\n  padding: 0.9rem 1.15rem;\n  overflow: visible;\n}\n\n.admin-dashboard-main .admin-section-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem 1rem;\n}\n\n.admin-section-heading {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.6rem;\n  min-width: 0;\n}\n\n.admin-section-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-primary);\n  text-align: left;\n  cursor: pointer;\n}\n\n.admin-dashboard-main .admin-section-toggle h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 500;\n}\n\n.admin-section-caret {\n  flex: none;\n  width: 0.5rem;\n  height: 0.5rem;\n  border-right: 1.5px solid var(--text-muted);\n  border-bottom: 1.5px solid var(--text-muted);\n  transform: rotate(-45deg);\n  transition: transform 150ms ease;\n}\n\n.admin-section.is-open .admin-section-caret {\n  transform: rotate(45deg);\n}\n\n.admin-section-state {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.admin-dashboard-main .admin-status-pill.admin-section-count {\n  margin-top: 0;\n}\n\n.admin-section-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .admin-section-subtitle {\n  margin: 0.35rem 0 0;\n  max-width: 60rem;\n  font-size: 0.86rem;\n}\n\n.admin-section-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n.admin-section-body[hidden] {\n  display: none;\n}\n\n.admin-facts {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 2rem;\n  margin: 0;\n}\n\n.admin-fact {\n  display: grid;\n  grid-template-columns: minmax(9rem, 16rem) minmax(0, 1fr);\n  gap: 1rem;\n  padding: 0.4rem 0;\n  border-top: 1px solid var(--border);\n}\n\n.admin-fact dt {\n  color: var(--text-muted);\n}\n\n.admin-fact dd {\n  margin: 0;\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n.admin-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.45rem 0;\n  border-top: 1px solid var(--border);\n  font-size: 0.9rem;\n}\n\n.admin-row:first-child {\n  border-top: 0;\n}\n\n.admin-row--stack {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.2rem;\n}\n\n.admin-form-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.6rem;\n}\n\n.admin-form-row > .form-input {\n  width: auto;\n  min-width: 12rem;\n  flex: 1 1 12rem;\n}\n\n.admin-field {\n  display: grid;\n  gap: 0.25rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.admin-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.6rem 1rem;\n}\n\n.admin-form-grid-wide {\n  grid-column: 1 / -1;\n}\n\n.admin-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.9rem;\n}\n\n.admin-pair {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.admin-toolbar {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-dashboard-main .homepage-button-primary,\n.admin-dashboard-main .homepage-button-secondary {\n  padding: 0.38rem 0.8rem;\n  font-size: 0.84rem;\n  white-space: nowrap;\n}\n\n.admin-dashboard-main .homepage-button-secondary.is-destructive {\n  border-color: var(--error);\n  color: var(--error);\n}\n\n.admin-dashboard-main .homepage-button-secondary.is-destructive:hover {\n  background: var(--error);\n  border-color: var(--error);\n  color: #ffffff;\n}\n\n.admin-dashboard-main .homepage-button-primary.is-destructive {\n  background: var(--error);\n  border-color: var(--error);\n}\n\n/* A button the dashboard has locked looks locked (D-HP-ADMIN-089). */\n.admin-dashboard-main .homepage-button-primary:disabled,\n.admin-dashboard-main .homepage-button-secondary:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Uniform grid alignment for master switches and per-unit autopilot buttons (IDD D-HP-ADMIN-056, D-HP-ADMIN-046). */\n.admin-autopilot-master {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 22rem));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.admin-autopilot-master > button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 2.35rem;\n  text-align: center;\n}\n\n.admin-autopilot-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.admin-dashboard-main .admin-autopilot-unit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  min-height: 2.35rem;\n  text-align: left;\n}\n\n.admin-autopilot-unit-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  font-weight: 500;\n}\n\n.admin-autopilot-unit-state {\n  flex: none;\n  font-size: 0.78rem;\n  opacity: 0.92;\n  white-space: nowrap;\n}\n\n@media (max-width: 42em) {\n  .admin-autopilot-master,\n  .admin-autopilot-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* The data-lake autopilot toggle (IDD D-HP-ADMIN-063/066): the same geometry as every\n   other action button — the state speaks through color and the section pill, never\n   through size (D-HP-ADMIN-066: uniform, decent). */\n.admin-dashboard-main .admin-datalake-toggle.is-on {\n  background: var(--success);\n  border-color: var(--success);\n  color: #ffffff;\n}\n\n/* Readiness-to-train pipeline (IDD D-HP-ADMIN-067): the measured stages from storage\n   to the first training run. One pill per stage, state through color alone\n   (D-HP-ADMIN-066): met green, active blue with a subtle pulse, waiting neutral,\n   blocked red. rem/em only (D-HP-ADMIN-046). */\n.admin-readiness-summary {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.admin-readiness-pipeline {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.admin-readiness-joint {\n  color: var(--text-muted);\n  font-size: 0.78rem;\n}\n\n.admin-readiness-stage {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid var(--border-hover);\n  border-radius: 999px;\n  padding: 0.22rem 0.62rem;\n  background: var(--bg-secondary);\n  color: var(--ink-soft);\n  font-size: 0.74rem;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.admin-readiness-stage.is-ok {\n  border-color: rgba(46, 125, 79, 0.4);\n  background: rgba(46, 125, 79, 0.08);\n  color: var(--success);\n}\n\n.admin-readiness-stage.is-active {\n  border-color: rgba(37, 99, 235, 0.45);\n  background: rgba(37, 99, 235, 0.08);\n  color: #1d4ed8;\n  animation: admin-readiness-pulse 2.4s ease-in-out infinite;\n}\n\n.admin-readiness-stage.is-blocked {\n  border-color: rgba(192, 38, 45, 0.4);\n  background: rgba(192, 38, 45, 0.07);\n  color: var(--error);\n}\n\n.admin-readiness-counter {\n  margin-left: auto;\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n\n.admin-readiness-unblock {\n  margin: 0;\n  border-left: 0.2rem solid var(--accent);\n  padding-left: 0.6rem;\n}\n\n@keyframes admin-readiness-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.25); }\n  50% { box-shadow: 0 0 0 0.3rem rgba(37, 99, 235, 0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-readiness-stage.is-active {\n    animation: none;\n  }\n}\n\n.admin-link {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-primary);\n  font: inherit;\n  text-align: left;\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 0.15em;\n  cursor: pointer;\n}\n\n.admin-link:hover {\n  color: var(--accent);\n}\n\n.admin-show-more {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.admin-quote {\n  margin: 0;\n  padding: 0.6rem 1rem;\n  border-left: 3px solid var(--accent);\n  font-size: 1rem;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n\n.admin-dashboard-main .admin-table thead th {\n  padding: 0.5rem 0.65rem;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.admin-dashboard-main .admin-table tbody td {\n  padding: 0.5rem 0.65rem;\n  font-size: 0.88rem;\n}\n\n.admin-dashboard-main .admin-status-pill {\n  padding: 0.12rem 0.5rem;\n  font-size: 0.74rem;\n}\n\n.admin-dashboard-main .admin-kpi-label {\n  font-size: 0.8rem;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.admin-dashboard-main .admin-inline-input {\n  width: auto;\n  min-width: 10rem;\n}\n\n.admin-dashboard-main .form-input {\n  padding: 0.42rem 0.6rem;\n  font-size: 0.88rem;\n}\n\n.admin-dashboard-main .admin-inline-actions {\n  align-items: center;\n}\n\n.admin-dashboard-main .admin-attention-item {\n  font-size: 0.9rem;\n}\n\n.admin-dashboard-main .admin-smtm-training-card {\n  padding: 0.65rem 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n/* The dialog over the page (IDD D-HP-ADMIN-041): fixed and centred on a dimmed\n   backdrop; the written conversation and the call share it. */\n.org-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(26, 26, 26, 0.45);\n}\n\n.org-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: min(44rem, 100%);\n  max-height: calc(100vh - 3rem);\n  padding: 1.1rem 1.25rem;\n  border: 1px solid var(--border-hover);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  color: var(--text-primary);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n  outline: none;\n}\n\n.org-dialog__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.org-dialog__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.org-dialog__subtitle {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.org-dialog__close {\n  flex: none;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1.2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.org-dialog__close:hover {\n  border-color: var(--ink);\n  color: var(--text-primary);\n}\n\n.org-dialog__body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-height: 8rem;\n  max-height: 50vh;\n  overflow-y: auto;\n  padding: 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-secondary);\n}\n\n.org-dialog__turn {\n  max-width: 85%;\n  padding: 0.45rem 0.65rem;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n}\n\n.org-dialog__turn--person {\n  align-self: flex-end;\n  border: 1px solid var(--border);\n  background: var(--bg-card);\n}\n\n.org-dialog__turn--bot {\n  align-self: flex-start;\n  background: var(--bg-hover);\n}\n\n.org-dialog__who {\n  margin-bottom: 0.15rem;\n  color: var(--text-muted);\n  font-size: 0.74rem;\n}\n\n.org-dialog__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.6rem;\n}\n\n.org-dialog__form {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.org-dialog__form-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.admin-dashboard-main .org-call__hangup,\n.org-call__hangup {\n  background: var(--error);\n  border-color: var(--error);\n  color: #ffffff;\n}\n\n.admin-dashboard-main .org-call__hangup:hover,\n.org-call__hangup:hover {\n  background: #a11f26;\n  border-color: #a11f26;\n  color: #ffffff;\n}\n\n@media (max-width: 68.75em) {\n  .admin-shell {\n    grid-template-columns: 1fr;\n  }\n\n  /* Under tablet width the sidebar is a bar above the page: the pages in a wrapping row, the open page's sections\n     in a second row, nothing stacked into a long list. */\n  .admin-sidebar {\n    position: static;\n    max-height: none;\n    padding: 0.4rem 0 0.8rem;\n    border-right: 0;\n    border-bottom: 1px solid var(--border);\n  }\n\n  .admin-sidebar-head {\n    margin-bottom: 0.4rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .admin-sidebar-group {\n    margin-top: 0.4rem;\n  }\n\n  .admin-sidebar-list,\n  .admin-sidebar-sublist {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.2rem 0.4rem;\n  }\n\n  .admin-sidebar-sublist {\n    margin: 0.3rem 0 0;\n    padding: 0.3rem 0 0;\n    border-left: 0;\n    border-top: 1px solid var(--border);\n  }\n\n  .admin-sidebar-link,\n  .admin-sidebar-sublink {\n    width: auto;\n  }\n\n  .admin-facts,\n  .admin-form-grid,\n  .admin-pair {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-page-meta {\n    text-align: left;\n  }\n\n  .admin-page-meta div {\n    justify-content: flex-start;\n  }\n}\n\n/* The organisation editor as aligned rows (D-HP-ADMIN-040): a unit's head with its remove button in the right\n   column, its members one per row with name, role and the remove control in fixed columns. */\n.admin-org-tree { display: flex; flex-direction: column; gap: 0.75rem; }\n.admin-org-unit { border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; background: var(--bg-card); }\n.admin-org-unit-head { display: grid; grid-template-columns: minmax(0, 1fr) 7.5rem; align-items: center; gap: 0.75rem; padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--border); background: var(--bg-hover); font-size: 0.9rem; }\n.admin-org-unit-name { display: flex; flex-direction: column; min-width: 0; }\n.admin-org-unit-meta { color: var(--text-muted); font-size: 0.74rem; }\n.admin-org-members { list-style: none; margin: 0; padding: 0; }\n.admin-org-member { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(0, 2fr) 7.5rem; align-items: center; gap: 0.75rem; padding: 0.35rem 0.75rem; border-top: 1px solid var(--border); font-size: 0.82rem; }\n.admin-org-member:first-child { border-top: 0; }\n.admin-org-member-name { color: var(--ink); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.admin-org-member-role { color: var(--text-secondary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.admin-org-remove { justify-self: end; min-width: 2.5rem; padding: 0.15rem 0.6rem; font-size: 0.8rem; }\n\n/* The sovereign LLM architecture paper (#llm, IDD D-HP-ADMIN-062): the generated scientific document in the\n   look of a classic machine-learning paper — always a white page surface with near-black ink regardless of\n   the dashboard theme, a centered serif title block, justified two-column body text, full-width figures and\n   tables, and numbered references in smaller type. Sizes in rem/em only (D-HP-ADMIN-046). */\n.llm-paper-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n/* Both strands' papers stand SIDE BY SIDE (D-HP-ADMIN-071):\n   two sheets next to each other on wide screens — the any-to-any paper left, the document\n   strand right — each its own full document; below the grid's minimum width they wrap,\n   which is the physical bound of a phone, not a hiding mechanism. rem-only (D-HP-ADMIN-046). */\n.llm-paper-duo {\n  /* Three sheets in one row on a wide screen (D-HP-ADMIN-075); below the minimum they wrap. */\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 30rem), 1fr));\n  gap: 1.5rem;\n  align-items: start;\n}\n.llm-paper-duo > section { min-width: 0; }\n\n/* The implementation lifecycle strip under each paper (D-HP-ADMIN-073). */\n.llm-kernel-table td, .llm-kernel-table th { font-size: 0.78rem; }\n.llm-lifecycle { margin-top: 0.75rem; padding: 0.75rem; display: flex; flex-direction: column; gap: 0.6rem; }\n.llm-lifecycle-head { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }\n.llm-lifecycle-steps { display: flex; flex-wrap: wrap; gap: 0.4rem 0.9rem; }\n.llm-lifecycle-step { display: inline-flex; align-items: center; gap: 0.35rem; }\n.llm-lifecycle-detail { font-size: 0.72rem; color: var(--color-text-secondary, #64748b); }\n.llm-lifecycle-table td, .llm-lifecycle-table th { font-size: 0.72rem; }\n\n.llm-paper {\n  max-width: 52rem;\n  width: 100%;\n  margin: 0 auto;\n  padding: 3.5rem 4.5rem;\n  background: #ffffff;\n  color: #1a1a1a;\n  border: 0.0625rem solid #d0d0d0;\n  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.12);\n  font-family: Georgia, Cambria, 'Times New Roman', Times, serif;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n}\n\n.llm-paper a {\n  color: #1a1a1a;\n  text-decoration: underline;\n}\n\n.llm-paper-title {\n  font-size: 1.65rem;\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.25;\n  margin: 0 0 1.75rem;\n  letter-spacing: -0.01em;\n}\n\n.llm-paper-authors {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1rem 3rem;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.llm-paper-author-name {\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.llm-paper-author-affiliation {\n  font-size: 0.85rem;\n}\n\n.llm-paper-dateline {\n  text-align: center;\n  font-size: 0.85rem;\n  margin-bottom: 2rem;\n}\n\n.llm-paper-abstract-heading {\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n}\n\n.llm-paper-abstract {\n  margin: 0 2.5rem 2rem;\n  font-size: 0.9rem;\n  text-align: justify;\n  hyphens: auto;\n}\n\n.llm-paper-abstract p {\n  margin: 0 0 0.6rem;\n}\n\n.llm-paper-section-heading {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 1.9rem 0 0.7rem;\n}\n\n.llm-paper-secnum {\n  margin-right: 0.75rem;\n}\n\n.llm-paper-body p {\n  margin: 0 0 0.75rem;\n  text-align: justify;\n  hyphens: auto;\n}\n\n.llm-paper-figure {\n  margin: 1.5rem 0 1.75rem;\n  text-align: center;\n}\n\n.llm-paper-figure-caption {\n  font-size: 0.82rem;\n  font-style: italic;\n  margin-top: 0.6rem;\n}\n\n.llm-paper-table-block {\n  margin: 1.4rem 0 1.6rem;\n}\n\n.llm-paper-tabcaption {\n  text-align: center;\n  font-size: 0.82rem;\n  font-style: italic;\n  margin-bottom: 0.45rem;\n}\n\n.llm-paper-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.84rem;\n  border-top: 0.125rem solid #1a1a1a;\n  border-bottom: 0.125rem solid #1a1a1a;\n}\n\n.llm-paper-table thead th {\n  border-bottom: 0.0625rem solid #1a1a1a;\n  text-align: left;\n  font-weight: 700;\n  padding: 0.35rem 0.6rem;\n}\n\n.llm-paper-table td {\n  padding: 0.32rem 0.6rem;\n  vertical-align: top;\n}\n\n.llm-paper-table th.llm-paper-num,\n.llm-paper-table td.llm-paper-num {\n  text-align: right;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.llm-paper-totalrow td {\n  border-top: 0.0625rem solid #1a1a1a;\n  font-weight: 700;\n}\n\n.llm-paper-strong {\n  font-weight: 700;\n}\n\n.llm-paper-table .llm-paper-sub {\n  display: block;\n  font-size: 0.78rem;\n  color: #444444;\n  font-style: italic;\n  font-weight: 400;\n  margin-top: 0.15rem;\n}\n\n.llm-paper-formula {\n  text-align: center;\n  font-size: 0.82rem;\n  font-style: italic;\n  margin: -0.8rem 0 1.4rem;\n}\n\n.llm-paper-statusnote {\n  font-size: 0.86rem;\n  font-style: italic;\n  color: #333333;\n  margin: 0.6rem 0 0.9rem;\n  text-align: justify;\n}\n\n.llm-paper-note {\n  text-align: center;\n  font-size: 0.8rem;\n  font-style: italic;\n  color: #555555;\n  margin: 1.5rem 0 0.5rem;\n}\n\n.llm-paper-sup {\n  font-size: 0.7em;\n}\n\n.llm-paper-ref-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #1a1a1a;\n  text-decoration: underline;\n  cursor: pointer;\n  font: inherit;\n}\n\n.llm-paper-references {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.84rem;\n}\n\n.llm-paper-references li {\n  margin: 0 0 0.5rem;\n  padding-left: 1.6rem;\n  text-indent: -1.6rem;\n}\n\n.llm-paper-empty {\n  color: #444444;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.llm-paper-provenance {\n  text-align: center;\n  font-size: 0.78rem;\n  color: #666666;\n  margin-top: 2.5rem;\n  border-top: 0.0625rem solid #d0d0d0;\n  padding-top: 0.8rem;\n}\n\n@media (max-width: 48em) {\n  .llm-paper {\n    padding: 2rem 1.1rem;\n  }\n\n  .llm-paper-abstract {\n    margin: 0 0.75rem 1.5rem;\n  }\n}\n\n/* PDF export of the paper (D-HP-ADMIN-065/069): the paper page toggles body.llm-paper-printing on\n   beforeprint/afterprint, so these rules apply only when the paper is what is being printed and every\n   other page of the site prints normally. The paper stays IN FLOW — its full height defines the page\n   count; the first export positioned it absolutely over a two-page document and Chromium clipped the\n   print after page two. Chrome is hidden with display:none, page margins come from @page. */\n@media print {\n  body.llm-paper-printing * {\n    visibility: hidden;\n  }\n\n  body.llm-paper-printing .llm-paper,\n  body.llm-paper-printing .llm-paper * {\n    visibility: visible;\n  }\n\n  body.llm-paper-printing .site-nav,\n  body.llm-paper-printing .admin-sidebar,\n  body.llm-paper-printing .site-footer,\n  body.llm-paper-printing .llm-paper-toolbar {\n    display: none;\n  }\n\n  body.llm-paper-printing .admin-shell {\n    display: block;\n  }\n\n  body.llm-paper-printing {\n    background: #ffffff;\n  }\n\n  body.llm-paper-printing .site-main {\n    width: 100%;\n    max-width: none;\n    padding: 0;\n  }\n\n  body.llm-paper-printing .llm-paper {\n    position: static;\n    width: 100%;\n    max-width: none;\n    margin: 0;\n    padding: 0;\n    border: none;\n    box-shadow: none;\n    background: #ffffff;\n    color: #000000;\n  }\n\n  body.llm-paper-printing .llm-paper-table-block,\n  body.llm-paper-printing .llm-paper-figure {\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n\n  body.llm-paper-printing .llm-paper-table tr {\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n\n  body.llm-paper-printing .llm-paper a,\n  body.llm-paper-printing .llm-paper-ref-link {\n    color: #000000;\n  }\n}\n\n@page {\n  margin: 1.5cm 1.8cm;\n}\n\n/* The paper's chain steps and kernel table (D-HP-ADMIN-076). */\n/* Every step names itself (\"Step 3b — …\"), so the list carries no markers of its own (D-VCORE-369). */\n.llm-paper-steps { list-style: none; padding-left: 0; margin: 0.4rem 0 0.8rem; }\n.llm-paper-steps li { margin: 0 0 0.55rem; line-height: 1.5; }\n.llm-paper-kernelcell { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.78em; word-break: break-word; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
